import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Audio: { input: any; output: any; }
  BindingsDictionary: { input:  { [key: string]: string }; output:  { [key: string]: string }; }
  BookmarkId: { input: any; output: any; }
  ChartMetadata: { input: any; output: any; }
  ClassSet: { input: string[]; output: string[]; }
  CodeEditorOptions: { input: any; output: any; }
  ComponentId: { input: any; output: any; }
  ContextMenuId: { input: any; output: any; }
  CssObject: { input: any; output: any; }
  CssParamsBindings: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: Date; output: Date; }
  Document: { input: any; output: any; }
  EventData: { input: any; output: any; }
  FieldValueExpression: { input: any; output: any; }
  FlexLayoutItem: { input: any; output: any; }
  FormId: { input: any; output: any; }
  FormatName: { input: string; output: string; }
  Formats: { input: any; output: any; }
  InputBinding: { input: any; output: any; }
  LayoutItemId: { input: any; output: any; }
  Method: { input: any; output: any; }
  MultiSelectObject: { input: any; output: any; }
  RefreshGrid: { input: any; output: any; }
  ResponsiveProperty: { input: string | ResponsivePropertyObject; output: string | ResponsivePropertyObject; }
  SampleData: { input: any; output: any; }
  ServiceBinding: { input: any; output: any; }
  ServiceSnapshotOptionsDictionary: { input:  { [key: string]: ServiceSnapshotOptions }; output:  { [key: string]: ServiceSnapshotOptions }; }
  SingleMapping: { input: any; output: any; }
  SliderMarks: { input: Array<{ label?: node, value: number }> | bool; output: Array<{ label?: node, value: number }> | bool; }
  State: { input: any; output: any; }
  StringDictionary: { input:  { [key: string]: string }; output:  { [key: string]: string }; }
  StylePropertiesDictionary: { input:  { [key: string]: StyleProperties }; output:  { [key: string]: StyleProperties }; }
  StyleSet: { input: any; output: any; }
  TagSet: { input: string[]; output: string[]; }
  TransformMethodOptions: { input: any; output: any; }
  User: { input: any; output: any; }
  Video: { input: any; output: any; }
};

export type AiDialog = IDesignable & IEditable & IField & {
  __typename?: 'AIDialog';
  Bindings?: Maybe<AiDialogBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  Editable?: Maybe<Scalars['Boolean']['output']>;
  FieldType?: Maybe<FieldType>;
  Format?: Maybe<FieldFormat>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  InputBoxHeight?: Maybe<Scalars['String']['output']>;
  /** If dense or normal , will adjust vertical spacing of this and contained components. */
  Margin?: Maybe<Scalars['String']['output']>;
  /** Maximum number of rows to display when multiline option is set to true. */
  MaxRows?: Maybe<Scalars['String']['output']>;
  /** Minimum number of rows to display when multiline option is set to true. */
  MinRows?: Maybe<Scalars['String']['output']>;
  /** If true , a textarea element is rendered instead of an input. */
  Multiline?: Maybe<Scalars['Boolean']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  /** The short hint displayed in the input before the user enters a value. */
  Placeholder?: Maybe<Scalars['String']['output']>;
  ResponseBoxHeight?: Maybe<Scalars['String']['output']>;
  /** Number of rows to display when multiline option is set to true. */
  Rows?: Maybe<Scalars['String']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  /** When set to true, the dialog history of the component is visible to the user. */
  ShowHistory?: Maybe<Scalars['Boolean']['output']>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type AiDialogBindings = {
  __typename?: 'AIDialogBindings';
  Loading?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type AccordionGroup = IDesignable & {
  __typename?: 'AccordionGroup';
  AccordionContainerStyle?: Maybe<StyleProperties>;
  /** The items to render within the accordion */
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<AccordionGroupBindings>;
  Classes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Elevation?: Maybe<Scalars['Int']['output']>;
  ExpandDisabled?: Maybe<Scalars['Boolean']['output']>;
  Expanded?: Maybe<Scalars['Boolean']['output']>;
  Header?: Maybe<LayoutItem>;
  HideExpandIcon?: Maybe<Scalars['Boolean']['output']>;
  Id: Scalars['ID']['output'];
  Items?: Maybe<Array<Maybe<Scalars['FlexLayoutItem']['output']>>>;
  Label?: Maybe<Scalars['String']['output']>;
  Square?: Maybe<Scalars['Boolean']['output']>;
  Style?: Maybe<StyleProperties>;
  ToggleExpanded?: Maybe<Scalars['Boolean']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type AccordionGroupBindings = {
  __typename?: 'AccordionGroupBindings';
  AccordionContainerStyle?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  ExpandDisabled?: Maybe<Scalars['String']['output']>;
  Expanded?: Maybe<Scalars['String']['output']>;
  HideExpandIcon?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  ToggleExpanded?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type AccordionGroupStyleConfigurations = {
  __typename?: 'AccordionGroupStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalChildren?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AccordionLayout = IDesignable & {
  __typename?: 'AccordionLayout';
  AriaLabel?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Data?: Maybe<Scalars['SampleData']['output']>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Groups: Array<AccordionGroup>;
  Id: Scalars['ID']['output'];
  Style?: Maybe<StyleProperties>;
  UniqueName?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type AccordionLayoutBindings = {
  __typename?: 'AccordionLayoutBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Data?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  Groups?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type Action = BecomeUser | CallPhone | CallService | ClearForm | CloseContextMenu | CloseModalPopup | CopyToClipboard | GenerateCode | GoBack | GoToBookmark | GoToPage | Login | Logout | OpenContextMenu | OpenModalPopup | PasteFromClipboard | ReloadPage | SendEmail | SendMessageToChild | SendMessageToParent | SendSms | SetState | Share | ShowMessage | ShowToast | Transform | TriggerAction;

export type ActionEditor = {
  __typename?: 'ActionEditor';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<ActionEditorBindings>;
  Id: Scalars['ID']['output'];
  Name: Scalars['String']['output'];
  Value?: Maybe<Scalars['String']['output']>;
};

export type ActionEditorBindings = {
  __typename?: 'ActionEditorBindings';
  Value?: Maybe<Scalars['String']['output']>;
};

export type Adornment = {
  __typename?: 'Adornment';
  Icon?: Maybe<Icon>;
  Position: Scalars['String']['output'];
  Text?: Maybe<Scalars['String']['output']>;
};

export type Analytics = {
  __typename?: 'Analytics';
  Bindings?: Maybe<AnalyticsBindings>;
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  Metadata?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
};

export type AnalyticsBindings = {
  __typename?: 'AnalyticsBindings';
  EventCategory?: Maybe<Scalars['String']['output']>;
  EventName?: Maybe<Scalars['String']['output']>;
  Metadata?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

export type AppBar = {
  __typename?: 'AppBar';
  Bindings?: Maybe<AppBarBindings>;
  Description?: Maybe<Scalars['String']['output']>;
  Height?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  Logo?: Maybe<Scalars['String']['output']>;
  LogoAltText?: Maybe<Scalars['String']['output']>;
  LogoHeight?: Maybe<Scalars['String']['output']>;
  LogoLink?: Maybe<Scalars['String']['output']>;
  LogoLinkTarget?: Maybe<Scalars['String']['output']>;
  LogoWidth?: Maybe<Scalars['String']['output']>;
  MarginBottom?: Maybe<Scalars['String']['output']>;
  MarginLeft?: Maybe<Scalars['String']['output']>;
  MarginRight?: Maybe<Scalars['String']['output']>;
  MarginTop?: Maybe<Scalars['String']['output']>;
  Menu?: Maybe<Menu>;
  Style?: Maybe<StyleProperties>;
  Title?: Maybe<Scalars['String']['output']>;
  UniqueName: Scalars['String']['output'];
  Variant?: Maybe<Scalars['String']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
};

export type AppBarBindings = {
  __typename?: 'AppBarBindings';
  Style?: Maybe<Scalars['String']['output']>;
};

export enum AppCategory {
  Education = 'EDUCATION',
  Games = 'GAMES',
  PhotoVideo = 'PHOTO_VIDEO',
  Productivity = 'PRODUCTIVITY',
  SocialNetworking = 'SOCIAL_NETWORKING'
}

export enum AppRating {
  Everyone = 'EVERYONE',
  NinePlus = 'NINE_PLUS',
  SeventeenPlus = 'SEVENTEEN_PLUS',
  TwelvePlus = 'TWELVE_PLUS'
}

export enum AppSubCategory {
  PersonalFinance = 'PERSONAL_FINANCE'
}

export type Attribute = {
  __typename?: 'Attribute';
  DefaultValue?: Maybe<Scalars['String']['output']>;
  Entity?: Maybe<Entity>;
  Id: Scalars['ID']['output'];
  IsRequired: Scalars['Boolean']['output'];
  IsUnique: Scalars['Boolean']['output'];
  Name: Scalars['String']['output'];
  Type: AttributeType;
  Values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum AttributeType {
  Boolean = 'Boolean',
  Date = 'Date',
  DateTime = 'DateTime',
  Entity = 'Entity',
  Enum = 'Enum',
  Number = 'Number',
  String = 'String',
  Time = 'Time'
}

export type AudioPlayer = {
  __typename?: 'AudioPlayer';
  AllowDelete?: Maybe<Scalars['Boolean']['output']>;
  Analytics?: Maybe<Analytics>;
  Bindings?: Maybe<AudioPlayerBindings>;
  DestinationBucket?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  RenderAsVideoPlayer?: Maybe<Scalars['Boolean']['output']>;
  /** The transcript of the audio (if available) */
  Text?: Maybe<Scalars['String']['output']>;
  TranscriptStyle?: Maybe<StyleProperties>;
  /** Image source - required and unique */
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type AudioPlayerBindings = {
  __typename?: 'AudioPlayerBindings';
  Text?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type AudioRecorder = {
  __typename?: 'AudioRecorder';
  AllowDelete?: Maybe<Scalars['Boolean']['output']>;
  AudiPlayerOptions?: Maybe<AudioPlayer>;
  Bindings?: Maybe<AudioRecorderBindings>;
  DestinationBucket?: Maybe<Scalars['String']['output']>;
  DisplayPlayerAfterRecording?: Maybe<Scalars['Boolean']['output']>;
  Enabled?: Maybe<Scalars['Boolean']['output']>;
  Id: Scalars['ID']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  /** Image source - required and unique */
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type AudioRecorderBindings = {
  __typename?: 'AudioRecorderBindings';
  Text?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type Avatar = {
  __typename?: 'Avatar';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  /** Image alt tag value */
  AlternativeText?: Maybe<Scalars['String']['output']>;
  Analytics?: Maybe<Analytics>;
  Bindings?: Maybe<ImageBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Id: Scalars['ID']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  Path?: Maybe<Scalars['String']['output']>;
  Size?: Maybe<Scalars['String']['output']>;
  Source?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  /** Image source - required and unique */
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type AvatarBindings = {
  __typename?: 'AvatarBindings';
  AlternativeText?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['String']['output']>;
  Path?: Maybe<Scalars['String']['output']>;
  Size?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type BasicInput = IDesignable & IEditable & IField & {
  __typename?: 'BasicInput';
  /** This prop helps users to fill forms faster, especially on mobile devices. The name can be confusing, as it's more like an autofill. You can learn more about it following the specification . */
  AutoComplete?: Maybe<Scalars['String']['output']>;
  /** If true , the input element is focused during the first mount. */
  AutoFocus?: Maybe<Scalars['Boolean']['output']>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  /** The color of the component. It supports both default and custom theme colors, which can be added as shown in the palette customization guide . The prop defaults to the value ( 'primary' ) inherited from the parent FormControl component. */
  Color?: Maybe<Scalars['String']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  /** If true , the input will not have an underline. */
  DisableUnderline?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the component is disabled. The prop defaults to the value ( false ) inherited from the parent FormControl component. */
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Editable?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the input will indicate an error. The prop defaults to the value ( false ) inherited from the parent FormControl component. */
  Error?: Maybe<Scalars['Boolean']['output']>;
  FieldType?: Maybe<FieldType>;
  Format?: Maybe<FieldFormat>;
  /** If true , the input will take up the full width of its container. */
  FullWidth?: Maybe<Scalars['Boolean']['output']>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  /** If dense , will adjust vertical spacing. This is normally obtained via context from FormControl. The prop defaults to the value ( 'none' ) inherited from the parent FormControl component. */
  Margin?: Maybe<Scalars['String']['output']>;
  /** Maximum number of rows to display when multiline option is set to true. */
  MaxRows?: Maybe<Scalars['String']['output']>;
  /** Minimum number of rows to display when multiline option is set to true. */
  MinRows?: Maybe<Scalars['String']['output']>;
  /** If true , a TextareaAutosize element is rendered. */
  Multiline?: Maybe<Scalars['Boolean']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  /** The short hint displayed in the input before the user enters a value. */
  Placeholder?: Maybe<Scalars['String']['output']>;
  /** It prevents the user from changing the value of the field (not from interacting with the field). */
  ReadOnly?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the input element is required. The prop defaults to the value ( false ) inherited from the parent FormControl component. */
  Required?: Maybe<Scalars['Boolean']['output']>;
  /** Number of rows to display when multiline option is set to true. */
  Rows?: Maybe<Scalars['String']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type BecomeUser = {
  __typename?: 'BecomeUser';
  Bindings?: Maybe<BecomeUserBindings>;
  TargetDomain?: Maybe<Scalars['String']['output']>;
  TargetPage?: Maybe<Scalars['String']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

export type BecomeUserBindings = {
  __typename?: 'BecomeUserBindings';
  TargetDomain?: Maybe<Scalars['String']['output']>;
  TargetPage?: Maybe<Scalars['String']['output']>;
  UserId?: Maybe<Scalars['String']['output']>;
};

export type BindingEditor = {
  __typename?: 'BindingEditor';
  Id?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};

export type BooleanFormat = {
  __typename?: 'BooleanFormat';
  FalseValue?: Maybe<Scalars['String']['output']>;
  TrueValue?: Maybe<Scalars['String']['output']>;
};

export type Button = IDesignable & {
  __typename?: 'Button';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Analytics?: Maybe<Analytics>;
  BadgeMaximum?: Maybe<Scalars['Int']['output']>;
  BadgeValue?: Maybe<Scalars['Int']['output']>;
  Bindings?: Maybe<ButtonBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  /** Element placed below the text. */
  BottomIcon?: Maybe<Icon>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the ripples are centered. They won't start at the cursor interaction position. */
  CenterRipple?: Maybe<Scalars['Boolean']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  /** The color of the component. It supports both default and custom theme colors, which can be added as shown in the palette customization guide . */
  Color?: Maybe<Scalars['String']['output']>;
  ContextId?: Maybe<Scalars['String']['output']>;
  ContextMenu?: Maybe<ContextMenu>;
  /** If true , no elevation is used. */
  DisableElevation?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the  keyboard focus ripple is disabled. */
  DisableFocusRipple?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the ripple effect is disabled. ?? Without a ripple there is no styling for :focus-visible by default. Be sure to highlight the element by applying separate styles with the .Mui-focusVisible class. */
  DisableRipple?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the touch ripple effect is disabled. */
  DisableTouchRipple?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the component is disabled. */
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  /** Element placed after the text. */
  EndIcon?: Maybe<Icon>;
  /** If true , the base button will have a keyboard focus ripple. */
  FocusRipple?: Maybe<Scalars['Boolean']['output']>;
  /** This prop can help identify which element has keyboard focus. The class name will be applied when the element gains the focus through keyboard interaction. It's a polyfill for the CSS :focus-visible selector . The rationale for using this feature is explained here . A polyfill can be used to apply a focus-visible class to other components if needed. */
  FocusVisibleClassName?: Maybe<Scalars['String']['output']>;
  /** If true , the button will take up the full width of its container. */
  FullWidth?: Maybe<Scalars['Boolean']['output']>;
  HasBadge?: Maybe<Scalars['Boolean']['output']>;
  /** The URL to link to when the button is clicked. If defined, an a element will be used as the root node. */
  Href?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  Shape?: Maybe<Scalars['String']['output']>;
  /** The size of the component. small is equivalent to the dense button styling. */
  Size?: Maybe<Scalars['String']['output']>;
  /** Element placed before the text. */
  StartIcon?: Maybe<Icon>;
  Style?: Maybe<StyleProperties>;
  Title?: Maybe<Scalars['String']['output']>;
  /** Element placed above the text. */
  TopIcon?: Maybe<Icon>;
  /** A ref that points to the TouchRipple element. */
  TouchRippleRef?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  getData?: Maybe<Scalars['Method']['output']>;
};

export type ButtonBindings = {
  __typename?: 'ButtonBindings';
  BadgeMaximum?: Maybe<Scalars['String']['output']>;
  BadgeValue?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['String']['output']>;
  Color?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  HasBadge?: Maybe<Scalars['String']['output']>;
  Href?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type ButtonGroup = IDesignable & IEditable & IField & ISelectFromList & {
  __typename?: 'ButtonGroup';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<ButtonGroupBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  Editable?: Maybe<Scalars['Boolean']['output']>;
  Exclusive?: Maybe<Scalars['Boolean']['output']>;
  FieldType?: Maybe<FieldType>;
  Format?: Maybe<FieldFormat>;
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  LabelExpression?: Maybe<Scalars['String']['output']>;
  MultiSelectFilter?: Maybe<FilterCriteria>;
  MultiSelectPossibleValues?: Maybe<Array<Maybe<Scalars['MultiSelectObject']['output']>>>;
  Name?: Maybe<Scalars['String']['output']>;
  Orientation?: Maybe<Scalars['String']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  Style?: Maybe<StyleProperties>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
  Value?: Maybe<Scalars['String']['output']>;
  ValueExpression?: Maybe<Scalars['String']['output']>;
  ValueType?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type ButtonGroupBindings = {
  __typename?: 'ButtonGroupBindings';
  Disabled?: Maybe<Scalars['String']['output']>;
  MultiSelectPossibleValues?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type ButtonStyleConfigurations = {
  __typename?: 'ButtonStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CallPhone = {
  __typename?: 'CallPhone';
  Bindings?: Maybe<CallPhoneBindings>;
  CommandResult?: Maybe<Scalars['String']['output']>;
  Number?: Maybe<Scalars['String']['output']>;
};

export type CallPhoneBindings = {
  __typename?: 'CallPhoneBindings';
  Number?: Maybe<Scalars['String']['output']>;
};

export type CallService = {
  __typename?: 'CallService';
  Bindings?: Maybe<CallServiceBindings>;
  CommandResult?: Maybe<Scalars['String']['output']>;
  Component?: Maybe<Scalars['ComponentId']['output']>;
  Fields?: Maybe<Scalars['String']['output']>;
  Form?: Maybe<Scalars['FormId']['output']>;
  Service?: Maybe<Scalars['String']['output']>;
  ServiceName?: Maybe<Scalars['String']['output']>;
};

export type CallServiceBindings = {
  __typename?: 'CallServiceBindings';
  Component?: Maybe<Scalars['String']['output']>;
  Fields?: Maybe<Scalars['String']['output']>;
  Form?: Maybe<Scalars['String']['output']>;
  Service?: Maybe<Scalars['String']['output']>;
  ServiceName?: Maybe<Scalars['String']['output']>;
};

export enum Cardinality {
  Multiple = 'Multiple',
  Singleton = 'Singleton'
}

export type Chart = IDesignable & IEditable & IField & {
  __typename?: 'Chart';
  Bindings?: Maybe<ChartBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  /** List of all the available chart data fields */
  ChartFields?: Maybe<Array<Maybe<ChartField>>>;
  /** Defines which 3rd party library is used to render the chart */
  ChartLibrary?: Maybe<Scalars['String']['output']>;
  /** Includes all the JSON metadata for the chart */
  ChartMetadata?: Maybe<Scalars['ChartMetadata']['output']>;
  Colors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  Rows?: Maybe<Scalars['SampleData']['output']>;
  Service?: Maybe<Scalars['String']['output']>;
  TransposeRowLabel?: Maybe<Scalars['String']['output']>;
  TransposeRowNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TransposeRowValueFrom?: Maybe<Scalars['String']['output']>;
  TransposeRowsToSeries?: Maybe<Scalars['Boolean']['output']>;
  Typename?: Maybe<Scalars['String']['output']>;
  UniqueName?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  getData?: Maybe<Scalars['Method']['output']>;
};

export type ChartBindings = {
  __typename?: 'ChartBindings';
  Colors?: Maybe<Scalars['String']['output']>;
  Data?: Maybe<Scalars['String']['output']>;
  Loading?: Maybe<Scalars['String']['output']>;
  Rows?: Maybe<Scalars['String']['output']>;
  TransposeRowLabel?: Maybe<Scalars['String']['output']>;
  TransposeRowNames?: Maybe<Scalars['String']['output']>;
  TransposeRowValueFrom?: Maybe<Scalars['String']['output']>;
  TransposeRowsToSeries?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type ChartField = IField & {
  __typename?: 'ChartField';
  DefaultValue?: Maybe<Scalars['String']['output']>;
  FieldType?: Maybe<FieldType>;
  Format?: Maybe<FieldFormat>;
  Id: Scalars['ID']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type Checkbox = IDesignable & IEditable & IField & {
  __typename?: 'Checkbox';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Analytics?: Maybe<Analytics>;
  Bindings?: Maybe<CheckboxBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the component is checked. */
  Checked?: Maybe<Scalars['Boolean']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  /** The color of the component. It supports both default and custom theme colors, which can be added as shown in the palette customization guide . */
  Color?: Maybe<Scalars['String']['output']>;
  /** The default checked state. Use when the component is not controlled. */
  DefaultChecked?: Maybe<Scalars['Boolean']['output']>;
  DefaultValue?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the ripple effect is disabled. */
  DisableRipple?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the component is disabled. */
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Editable?: Maybe<Scalars['Boolean']['output']>;
  FieldType?: Maybe<FieldType>;
  Format?: Maybe<FieldFormat>;
  Icon?: Maybe<Icon>;
  IconWhenChecked?: Maybe<Icon>;
  IconWhenUnchecked?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the component appears indeterminate. This does not set the native input element to indeterminate due to inconsistent behavior across browsers. However, we set a data-indeterminate attribute on the input . */
  Indeterminate?: Maybe<Scalars['Boolean']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  LabelPlacement?: Maybe<Scalars['String']['output']>;
  LabelStyle?: Maybe<StyleProperties>;
  LabelWhenOff?: Maybe<Scalars['String']['output']>;
  LabelWhenOn?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  /** If true , the input element is required. */
  Required?: Maybe<Scalars['Boolean']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  /** The size of the component. small is equivalent to the dense checkbox styling. */
  Size?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
  Value?: Maybe<Scalars['Boolean']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type CheckboxBindings = {
  __typename?: 'CheckboxBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Color?: Maybe<Scalars['String']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Required?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type CheckboxStyleConfigurations = {
  __typename?: 'CheckboxStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CircularProgress = IDesignable & IField & {
  __typename?: 'CircularProgress';
  Bindings?: Maybe<CircularProgressBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  DisableShrink?: Maybe<Scalars['Boolean']['output']>;
  Id: Scalars['ID']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  ShowValue?: Maybe<Scalars['Boolean']['output']>;
  Size?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  Thickness?: Maybe<Scalars['Float']['output']>;
  Value: Scalars['Float']['output'];
  Variant?: Maybe<CircularProgressVariant>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type CircularProgressBindings = {
  __typename?: 'CircularProgressBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  DisableShrink?: Maybe<Scalars['String']['output']>;
  ShowValue?: Maybe<Scalars['Boolean']['output']>;
  Size?: Maybe<Scalars['String']['output']>;
  Thickness?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Variant?: Maybe<CircularProgressVariant>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export enum CircularProgressVariant {
  Determinate = 'determinate',
  Indeterminate = 'indeterminate'
}

export type ClearForm = {
  __typename?: 'ClearForm';
  CommandResult?: Maybe<Scalars['String']['output']>;
  Component?: Maybe<Scalars['ComponentId']['output']>;
  Form?: Maybe<Scalars['FormId']['output']>;
  Purge?: Maybe<Scalars['Boolean']['output']>;
};

export type CloseContextMenu = {
  __typename?: 'CloseContextMenu';
  Bindings?: Maybe<CloseContextMenuBindings>;
  CommandResult?: Maybe<Scalars['String']['output']>;
  Component?: Maybe<Scalars['ComponentId']['output']>;
  ContextMenuId?: Maybe<Scalars['ContextMenuId']['output']>;
};

export type CloseContextMenuBindings = {
  __typename?: 'CloseContextMenuBindings';
  ContextMenuId?: Maybe<Scalars['String']['output']>;
};

export type CloseModalPopup = {
  __typename?: 'CloseModalPopup';
  CommandResult?: Maybe<Scalars['String']['output']>;
  Component?: Maybe<Scalars['ComponentId']['output']>;
  ModalPopupId?: Maybe<Scalars['String']['output']>;
};

export type CodeEditor = {
  __typename?: 'CodeEditor';
  Bindings?: Maybe<CodeEditorBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  FieldType?: Maybe<FieldType>;
  Format?: Maybe<FieldFormat>;
  Height?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  Language?: Maybe<Scalars['String']['output']>;
  MultiLine?: Maybe<Scalars['Boolean']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NumberOfLines?: Maybe<Scalars['Int']['output']>;
  Options?: Maybe<Scalars['CodeEditorOptions']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type CodeEditorBindings = {
  __typename?: 'CodeEditorBindings';
  Language?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type Command = {
  __typename?: 'Command';
  Id?: Maybe<Scalars['ID']['output']>;
  Instruction?: Maybe<IInstruction>;
  NextCommand?: Maybe<Scalars['String']['output']>;
  NextCommandIdOnFailure?: Maybe<Scalars['String']['output']>;
  NextCommandIdOnSuccess?: Maybe<Scalars['String']['output']>;
  Parameters?: Maybe<Array<Maybe<IParameterWithValues>>>;
  SkipCommand?: Maybe<Scalars['String']['output']>;
  StopExecution?: Maybe<Scalars['String']['output']>;
};

export type CommandSet = {
  __typename?: 'CommandSet';
  Commands?: Maybe<Array<Maybe<Command>>>;
  ExecuteCommandsInParallel?: Maybe<Scalars['Boolean']['output']>;
  FirstCommandId?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
};

export type Component = {
  __typename?: 'Component';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<ComponentBindings>;
  Category?: Maybe<Scalars['String']['output']>;
  /** A Component in the library is always encapsulated in a Container */
  ComponentContainer?: Maybe<Container>;
  ComponentId?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Events?: Maybe<Scalars['EventData']['output']>;
  /** The items (typically buttons) that are displayed in the header of the component */
  HeaderItems?: Maybe<Array<LayoutItem>>;
  /** If set to true, the title of this component is not displayed in the feed */
  HideTitle?: Maybe<Scalars['Boolean']['output']>;
  /** Icon to represent the component in the component palette */
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  InReviewMode?: Maybe<Scalars['Boolean']['output']>;
  IncludeInCatalog?: Maybe<Scalars['Boolean']['output']>;
  /** Initial Height (in GridStack units) of the component when dropped */
  InitialHeight?: Maybe<Scalars['Int']['output']>;
  /** Initial Width (in GridStack units) of the component when dropped */
  InitialWidth?: Maybe<Scalars['Int']['output']>;
  Inputs?: Maybe<InputData>;
  InstanceId?: Maybe<Scalars['String']['output']>;
  /** Used to represent the component in higher resolution */
  LargeImage?: Maybe<Scalars['String']['output']>;
  ModalPopups?: Maybe<Array<Maybe<Dialog>>>;
  Name: Scalars['String']['output'];
  SampleData?: Maybe<Scalars['SampleData']['output']>;
  SerialNumber?: Maybe<Scalars['String']['output']>;
  /** In an instance of a component, the below overrides the default values for any service property set in Services */
  ServiceSnapshots?: Maybe<Array<Maybe<Service>>>;
  Services?: Maybe<Array<Maybe<Service>>>;
  /** These shares are used at runtime to indicate that a user has shared a component with the current user */
  SharingInfo?: Maybe<SharingInfo>;
  SharingOptions?: Maybe<SharingOptions>;
  /** Used to represent the icon in the component palette */
  SmallImage?: Maybe<Scalars['String']['output']>;
  State?: Maybe<Scalars['State']['output']>;
  Styles?: Maybe<Scalars['StyleSet']['output']>;
  SubCategory?: Maybe<Scalars['String']['output']>;
  /** List of keywords/tags that represent this component */
  Tags?: Maybe<Scalars['TagSet']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TitleClasses?: Maybe<Scalars['ClassSet']['output']>;
  /** Component Type. Determines where in State it will be added on drop */
  Type: Scalars['String']['output'];
  UseSampleDataToInitializeState?: Maybe<Scalars['Boolean']['output']>;
};

export type ComponentBindings = {
  __typename?: 'ComponentBindings';
  InReviewMode?: Maybe<Scalars['String']['output']>;
};

export type ComponentLibrary = {
  __typename?: 'ComponentLibrary';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<ComponentLibraryBindings>;
  Components: Array<Maybe<LibraryItem>>;
  Id: Scalars['ID']['output'];
  Name: Scalars['String']['output'];
};

export type ComponentLibraryBindings = {
  __typename?: 'ComponentLibraryBindings';
  Components?: Maybe<Scalars['String']['output']>;
  Enabled?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type ConfigurationEditor = {
  __typename?: 'ConfigurationEditor';
  Bindings?: Maybe<ConfigurationEditorBindings>;
  Id: Scalars['ID']['output'];
  Name: Scalars['String']['output'];
};

export type ConfigurationEditorBindings = {
  __typename?: 'ConfigurationEditorBindings';
  Visible?: Maybe<Scalars['String']['output']>;
};

export type Container = SimpleContainer | TabContainer;

export type ContextAutocomplete = {
  __typename?: 'ContextAutocomplete';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<ContextAutocompleteBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  /** The model from which to infer the (hierarchical) list of items to display in the autocomplete list. */
  Model?: Maybe<Model>;
  Name?: Maybe<Scalars['String']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type ContextAutocompleteBindings = {
  __typename?: 'ContextAutocompleteBindings';
  Disabled?: Maybe<Scalars['String']['output']>;
  Model?: Maybe<Scalars['String']['output']>;
};

export type ContextMenu = {
  __typename?: 'ContextMenu';
  Bindings?: Maybe<ContextMenuBindings>;
  ClassName?: Maybe<Scalars['String']['output']>;
  Content: LayoutItem;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  Style?: Maybe<StyleProperties>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type ContextMenuBindings = {
  __typename?: 'ContextMenuBindings';
  Enabled?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type Control = AiDialog | ActionEditor | AudioPlayer | AudioRecorder | Avatar | BasicInput | Button | ButtonGroup | Checkbox | CircularProgress | CodeEditor | ComponentLibrary | ContextAutocomplete | ContextMenu | DatePicker | FileList | FileUpload | Html | IFrame | Icon | IconSelector | Image | InputField | Label | LinearProgress | Link | ListClearAllButton | ListExportButton | ListQuickFilter | Markdown | MultiSelect | Overlay | ProportionalBar | RadioGroup | ResolutionButtons | RichTextEditor | Slider | Snackbar | StyleEditor | Switch | VisibleMenu;

export type CopyToClipboard = {
  __typename?: 'CopyToClipboard';
  Bindings?: Maybe<CopyToClipboardBindings>;
  Options?: Maybe<Scalars['TransformMethodOptions']['output']>;
  TransformMethod?: Maybe<Scalars['String']['output']>;
};

export type CopyToClipboardBindings = {
  __typename?: 'CopyToClipboardBindings';
  ClipboardContent?: Maybe<Scalars['String']['output']>;
  Options?: Maybe<Scalars['String']['output']>;
  TransformMethod?: Maybe<Scalars['String']['output']>;
};

export type Country = {
  __typename?: 'Country';
  Code: Scalars['String']['output'];
  Name: Scalars['String']['output'];
};

export type CssClass = {
  __typename?: 'CssClass';
  Bindings?: Maybe<Scalars['CssParamsBindings']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  Name: Scalars['String']['output'];
  Style?: Maybe<Scalars['CssObject']['output']>;
};

export type CustomLabel = {
  __typename?: 'CustomLabel';
  CaseSensitive?: Maybe<Scalars['Boolean']['output']>;
  Label: Scalars['String']['output'];
  Locale?: Maybe<Scalars['String']['output']>;
  Method?: Maybe<Scalars['String']['output']>;
  ReplaceBy: Scalars['String']['output'];
};

export type DateFormat = {
  __typename?: 'DateFormat';
  DateStyle?: Maybe<Scalars['String']['output']>;
  Day?: Maybe<Scalars['String']['output']>;
  Hour?: Maybe<Scalars['String']['output']>;
  Hour12?: Maybe<Scalars['Boolean']['output']>;
  Locale?: Maybe<Scalars['String']['output']>;
  Minute?: Maybe<Scalars['String']['output']>;
  Month?: Maybe<Scalars['String']['output']>;
  Prefix?: Maybe<Scalars['String']['output']>;
  Second?: Maybe<Scalars['String']['output']>;
  Suffix?: Maybe<Scalars['String']['output']>;
  TimeStyle?: Maybe<Scalars['String']['output']>;
  TimeZone?: Maybe<Scalars['String']['output']>;
  Year?: Maybe<Scalars['String']['output']>;
};

export type DatePicker = IDesignable & IField & {
  __typename?: 'DatePicker';
  Analytics?: Maybe<Analytics>;
  Bindings?: Maybe<DatePickerBindings>;
  ClassName?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  /** Disables the ability to clear the selected value */
  DisableClearable?: Maybe<Scalars['Boolean']['output']>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  Label?: Maybe<Scalars['String']['output']>;
  MaxDate?: Maybe<Scalars['String']['output']>;
  MinDate?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Slot>;
  Style?: Maybe<StyleProperties>;
  Value?: Maybe<Scalars['String']['output']>;
};

export type DatePickerBindings = {
  __typename?: 'DatePickerBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  MaxDate?: Maybe<Scalars['String']['output']>;
  MinDate?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type DatePickerStyleConfigurations = {
  __typename?: 'DatePickerStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DateTimePicker = IDesignable & IField & {
  __typename?: 'DateTimePicker';
  Bindings?: Maybe<DateTimePickerBindings>;
  ClassName?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Id: Scalars['ID']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  Value?: Maybe<Scalars['String']['output']>;
};

export type DateTimePickerBindings = {
  __typename?: 'DateTimePickerBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type Dialog = {
  __typename?: 'Dialog';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<DialogBindings>;
  ButtonClicked?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  /** When the user clicks on the Cancel button, the following commands will be executed */
  CommandSetOnCancel?: Maybe<CommandSet>;
  /** When the user clicks on the Cancel button, the following commands will be executed */
  CommandSetOnClose?: Maybe<CommandSet>;
  /** When the user clicks on the OK button, the following commands will be executed */
  CommandSetOnOk?: Maybe<CommandSet>;
  ContentClasses?: Maybe<Scalars['ClassSet']['output']>;
  ContentContainer?: Maybe<Container>;
  ContentStyle?: Maybe<StyleProperties>;
  ContentText?: Maybe<Scalars['String']['output']>;
  Draggable?: Maybe<Scalars['Boolean']['output']>;
  FooterContainer?: Maybe<Container>;
  FullCustom?: Maybe<Scalars['Boolean']['output']>;
  FullScreen?: Maybe<Scalars['Boolean']['output']>;
  /** The Header item is any layout item that can be placed in the header, above the title */
  HeaderItem?: Maybe<LayoutItem>;
  Id: Scalars['ID']['output'];
  InnerDialogClasses?: Maybe<Scalars['ClassSet']['output']>;
  InnerDialogStyle?: Maybe<StyleProperties>;
  ShowCancelButton?: Maybe<Scalars['Boolean']['output']>;
  ShowCloseButton?: Maybe<Scalars['Boolean']['output']>;
  ShowOkButton?: Maybe<Scalars['Boolean']['output']>;
  Style?: Maybe<StyleProperties>;
  /** The title is simple text */
  Title?: Maybe<Scalars['String']['output']>;
  TitleContainerStyle?: Maybe<StyleProperties>;
  TitleStyle?: Maybe<StyleProperties>;
};

export type DialogBindings = {
  __typename?: 'DialogBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  ContentClasses?: Maybe<Scalars['String']['output']>;
  ContentStyle?: Maybe<Scalars['String']['output']>;
  ContentText?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  FullCustom?: Maybe<Scalars['String']['output']>;
  FullScreen?: Maybe<Scalars['String']['output']>;
  ShowCancelButton?: Maybe<Scalars['String']['output']>;
  ShowCloseButton?: Maybe<Scalars['String']['output']>;
  ShowOkButton?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TitleStyle?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
  open?: Maybe<Scalars['String']['output']>;
};

export type DocumentViewer = IDesignable & IField & {
  __typename?: 'DocumentViewer';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  AuxiliaryButtonClasses?: Maybe<Scalars['ClassSet']['output']>;
  AuxiliaryButtonStyle?: Maybe<StyleProperties>;
  Bindings?: Maybe<DocumentViewerBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  ButtonClasses?: Maybe<Scalars['ClassSet']['output']>;
  ButtonStyle?: Maybe<StyleProperties>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  DocumentFormat?: Maybe<Scalars['String']['output']>;
  DocumentMaxWidth?: Maybe<Scalars['Float']['output']>;
  Documents?: Maybe<Array<Maybe<Scalars['Document']['output']>>>;
  ErrorMessage?: Maybe<Scalars['String']['output']>;
  FallbackImageUrl?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  InfiniteMode?: Maybe<Scalars['Boolean']['output']>;
  InfiniteStyle?: Maybe<StyleProperties>;
  LoadAllPage?: Maybe<Scalars['Boolean']['output']>;
  MaxLoadingTimeSeconds?: Maybe<Scalars['Int']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NavigationButtonSize?: Maybe<Scalars['String']['output']>;
  NumPages?: Maybe<Scalars['Int']['output']>;
  PathExpression?: Maybe<Scalars['String']['output']>;
  PreviewMode?: Maybe<Scalars['Boolean']['output']>;
  Scale?: Maybe<Scalars['Float']['output']>;
  Style?: Maybe<StyleProperties>;
  Value?: Maybe<Scalars['Document']['output']>;
  ValueExpression?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  ZoomHorizontalPosition?: Maybe<Scalars['String']['output']>;
  ZoomVerticalPosition?: Maybe<Scalars['String']['output']>;
};

export type DocumentViewerBindings = {
  __typename?: 'DocumentViewerBindings';
  AuxiliaryButtonClasses?: Maybe<Scalars['String']['output']>;
  AuxiliaryButtonStyle?: Maybe<Scalars['String']['output']>;
  ButtonClasses?: Maybe<Scalars['String']['output']>;
  ButtonStyle?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['String']['output']>;
  DocumentFormat?: Maybe<Scalars['String']['output']>;
  Documents?: Maybe<Scalars['String']['output']>;
  ErrorMessage?: Maybe<Scalars['String']['output']>;
  InfiniteMode?: Maybe<Scalars['String']['output']>;
  MaxLoadingTimeSeconds?: Maybe<Scalars['String']['output']>;
  NavigationButtonSize?: Maybe<Scalars['String']['output']>;
  PathExpression?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  ValueExpression?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type DocumentViewerStyleConfigurations = {
  __typename?: 'DocumentViewerStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalChildren?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Drawer = {
  __typename?: 'Drawer';
  /** Side from which the drawer will appear. */
  Anchor: Scalars['String']['output'];
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  /** This is the component that is rendered as a reference in the drawer */
  ComponentName?: Maybe<Scalars['String']['output']>;
  Content?: Maybe<Page>;
  Height?: Maybe<Scalars['String']['output']>;
  /** If true , the backdrop is not rendered. */
  HideBackdrop?: Maybe<Scalars['Boolean']['output']>;
  Id: Scalars['ID']['output'];
  MarginBottom?: Maybe<Scalars['String']['output']>;
  MarginLeft?: Maybe<Scalars['String']['output']>;
  MarginRight?: Maybe<Scalars['String']['output']>;
  MarginTop?: Maybe<Scalars['String']['output']>;
  /** If true , the component is shown. */
  Open?: Maybe<Scalars['Boolean']['output']>;
  Style?: Maybe<StyleProperties>;
  /** The duration for the transition, in milliseconds. You may specify a single timeout for all transitions, or individually with an object. */
  TransitionDuration?: Maybe<Scalars['String']['output']>;
  UniqueName: Scalars['String']['output'];
  /** The variant to use. */
  Variant: Scalars['String']['output'];
  Width?: Maybe<Scalars['String']['output']>;
};

export type DropDownButton = IDesignable & {
  __typename?: 'DropDownButton';
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  Name: Scalars['String']['output'];
  Sequence?: Maybe<Scalars['Int']['output']>;
};

export type Entity = {
  __typename?: 'Entity';
  Attributes?: Maybe<Array<Maybe<Attribute>>>;
  Id: Scalars['ID']['output'];
  Model?: Maybe<Model>;
  Name: Scalars['String']['output'];
};

/** A feature is a menu item that can point to an external URL or an internal page */
export type Feature = {
  __typename?: 'Feature';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  AllowNavigation?: Maybe<Scalars['Boolean']['output']>;
  Bindings?: Maybe<FeatureBindings>;
  /** Element placed below the text. */
  BottomIcon?: Maybe<Icon>;
  ButtonStyle?: Maybe<StyleProperties>;
  ContextId?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  /** Element placed after the text. */
  EndIcon?: Maybe<Icon>;
  /** The url segment that references this page */
  ExternalUrl?: Maybe<Scalars['String']['output']>;
  Features?: Maybe<Array<Feature>>;
  Id: Scalars['ID']['output'];
  Label?: Maybe<Scalars['String']['output']>;
  /** The internal page for this feature */
  PageUrl?: Maybe<Scalars['String']['output']>;
  /** Element placed before the text. */
  StartIcon?: Maybe<Icon>;
  Style?: Maybe<StyleProperties>;
  /** Element placed above the text. */
  TopIcon?: Maybe<Icon>;
  /** Equivalent to  "_blank", "_self", "_parent", "_top" */
  UrlOpenTarget?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type FeatureBindings = {
  __typename?: 'FeatureBindings';
  ButtonStyle?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
};

/** Feed implements an infinitely scrollable page */
export type Feed = IApplication & IDesignable & {
  __typename?: 'Feed';
  AddHeaders?: Maybe<Scalars['Boolean']['output']>;
  Bindings?: Maybe<FeedBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  Components?: Maybe<Array<Component>>;
  /** Default styling to be applied to each container */
  ComponentsStyle?: Maybe<StyleProperties>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  FeedFooter?: Maybe<LayoutItem>;
  FeedHeader?: Maybe<LayoutItem>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  InReviewMode?: Maybe<Scalars['Boolean']['output']>;
  ReviewDialogOptions?: Maybe<ReviewDialog>;
  Service?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  Typename?: Maybe<Scalars['String']['output']>;
  UniqueName: Scalars['String']['output'];
  Visible?: Maybe<Scalars['Boolean']['output']>;
  getData?: Maybe<Scalars['Method']['output']>;
};

export type FeedBindings = {
  __typename?: 'FeedBindings';
  Components?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  InReviewMode?: Maybe<Scalars['String']['output']>;
  Loading?: Maybe<Scalars['String']['output']>;
  Reviews?: Maybe<Scalars['String']['output']>;
  SelectedItem?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type FieldFormat = {
  __typename?: 'FieldFormat';
  EditableMask?: Maybe<Scalars['String']['output']>;
  FieldType?: Maybe<FieldType>;
  Id?: Maybe<Scalars['ID']['output']>;
  ReadOnlyDisplayMask?: Maybe<Scalars['String']['output']>;
};

export type FieldList = {
  __typename?: 'FieldList';
  Id?: Maybe<Scalars['ID']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

export enum FieldType {
  Boolean = 'Boolean',
  DateOnly = 'DateOnly',
  DateTime = 'DateTime',
  Decimal = 'Decimal',
  Id = 'ID',
  Integer = 'Integer',
  String = 'String'
}

export type FileList = {
  __typename?: 'FileList';
  Bindings?: Maybe<FileListBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  IconSize?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  /**
   * Icons (Large, Medium, Small): This view mode displays files and folders as icons. The size of the icons can be adjusted (large, medium, or small) to suit your preference, providing a visual representation of the contents.
   *
   * List: This mode lists all files and folders in a simple list format, showing more items on the screen at once without much detail about each item. It's useful for browsing many items quickly.
   *
   * Details: In this view, files and folders are listed along with detailed information such as file size, type, modification date, and more. It's particularly useful for managing files, as you can sort them by any of these attributes.
   *
   * Tiles: Tiles view provides a balance between icons and details, displaying medium-sized icons alongside file or folder names. It gives a bit more visual context than the List view without taking up as much space as large icons.
   *
   * Content: This mode offers a detailed list view that includes a small preview and additional information about the file or folder, such as date modified and file type. It's somewhat a blend of the Details and Tiles views, providing both visual and textual information.
   */
  ViewMode?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type FileListBindings = {
  __typename?: 'FileListBindings';
  Disabled?: Maybe<Scalars['String']['output']>;
  IconSize?: Maybe<Scalars['String']['output']>;
  /**
   * The target structure is always
   * {
   *   "Id": "d8f0abf2-83a5-443a-9169-a1197260698a.png",
   *   "Name": "Screenshot 2023-05-13 215140.png",
   *   "Size": 12678,
   *   "ContentType": "image/png",
   *   "LastModified": "2023-05-14T01:51:40.255Z"
   * }
   */
  Rows?: Maybe<Scalars['String']['output']>;
  ViewMode?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type FileUpload = {
  __typename?: 'FileUpload';
  /**
   * Enable or disable file browser.
   * @default true
   */
  AllowBrowse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Allow only selecting directories with browse (no support for filtering dnd at this point)
   * @default false
   */
  AllowDirectoriesOnly?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Enable or disable drag n’ drop.
   * @default true
   */
  AllowDrop?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Enable or disable adding multiple files.
   * @default false
   */
  AllowMultiple?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Enable or disable pasting of files. Pasting files is not
   * supported on all browsers.
   * @default true
   */
  AllowPaste?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Allows user to process a file. When set to false, this removes the file upload button.
   * @default true
   */
  AllowProcess?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Allows the user to reorder the file items
   * @default false
   */
  AllowReorder?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Allow drop to replace a file, only works when allowMultiple is false.
   * @default true
   */
  AllowReplace?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Allows the user to revert file upload.
   * @default true
   */
  AllowRevert?: Maybe<Scalars['Boolean']['output']>;
  Analytics?: Maybe<Analytics>;
  Bindings?: Maybe<FileUploadBindings>;
  /**
   * Enables custom validity messages.
   * @default false
   */
  CheckValidity?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Force use of chunk uploads even for files smaller than chunk size
   * @default false
   */
  ChunkForce?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Amount of times to retry upload of a chunk when it fails
   * @default [500, 1000, 3000]
   */
  ChunkRetryDelays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /**
   * Size of chunks (5MB default)
   * @default 5000000
   */
  ChunkSize?: Maybe<Scalars['Int']['output']>;
  /**
   * Enable chunk uploads
   * @default false
   */
  ChunkUploads?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Require drop on the File Upload element itself to catch the file.
   * @default true
   */
  DropOnElement?: Maybe<Scalars['Boolean']['output']>;
  /**
   * File Upload will catch all files dropped on the webpage.
   * @default false
   */
  DropOnPage?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When enabled, files are validated before they are dropped.
   * A file is not added when it’s invalid.
   * @default false
   */
  DropValidation?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The base value used to calculate file size
   * @default 1000
   */
  FileSizeBase?: Maybe<Scalars['Int']['output']>;
  /**
   * Require the file to be successfully reverted before continuing.
   * @default false
   */
  ForceRevert?: Maybe<Scalars['Boolean']['output']>;
  Icon?: Maybe<Icon>;
  /**
   * The icon used for done.
   * @default '<svg></svg>'
   */
  IconDone?: Maybe<Scalars['String']['output']>;
  /**
   * The icon used for process actions.
   * @default '<svg></svg>'
   */
  IconProcess?: Maybe<Scalars['String']['output']>;
  /**
   * The icon used for remove actions.
   * @default '<svg></svg>'
   */
  IconRemove?: Maybe<Scalars['String']['output']>;
  /**
   * The icon used for retry actions.
   * @default '<svg></svg>'
   */
  IconRetry?: Maybe<Scalars['String']['output']>;
  /**
   * The icon used for undo actions.
   * @default '<svg></svg>'
   */
  IconUndo?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  /**
   * Ignored file names when handling dropped directories.
   * Dropping directories is not supported on all browsers.
   * @default ['.ds_store', 'thumbs.db', 'desktop.ini']
   */
  IgnoredFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Immediately upload new files to the server.
   * @default true
   */
  InstantUpload?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The interval to use before showing each item being added to the list.
   * @default 75
   */
  ItemInsertInterval?: Maybe<Scalars['Int']['output']>;
  /**
   * Default index in list to add items that have been dropped at the top of the list.
   * @default 'before'
   */
  ItemInsertLocation?: Maybe<Scalars['String']['output']>;
  /**
   * Set to false to always add items to beginning or end of list.
   * @default true
   */
  ItemInsertLocationFreedom?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Label used for abort load button.
   * @default 'Abort'
   */
  LabelButtonAbortItemLoad?: Maybe<Scalars['String']['output']>;
  /**
   * Label used for abort upload button.
   * @default 'Cancel'
   */
  LabelButtonAbortItemProcessing?: Maybe<Scalars['String']['output']>;
  /**
   * Label used for upload button.
   * @default 'Upload'
   */
  LabelButtonProcessItem?: Maybe<Scalars['String']['output']>;
  /**
   * Label used for remove button.
   * @default 'Remove'
   */
  LabelButtonRemoveItem?: Maybe<Scalars['String']['output']>;
  /**
   * Label used for retry load.
   * @default 'Retry'
   */
  LabelButtonRetryItemLoad?: Maybe<Scalars['String']['output']>;
  /**
   * Label used for retry upload button.
   * @default 'Retry'
   */
  LabelButtonRetryItemProcessing?: Maybe<Scalars['String']['output']>;
  /**
   * Label used for undo upload button.
   * @default 'Undo'
   */
  LabelButtonUndoItemProcessing?: Maybe<Scalars['String']['output']>;
  /**
   * The decimal separator used to render numbers.
   * By default this is determined automatically.
   * @default 'auto'
   */
  LabelDecimalSeparator?: Maybe<Scalars['String']['output']>;
  /**
   * Label used when file is added (assistive only).
   * @default 'Added'
   */
  LabelFileAdded?: Maybe<Scalars['String']['output']>;
  /**
   * Label used when showing the number of files and there is more than one.
   * @default 'files in list'
   */
  LabelFileCountPlural?: Maybe<Scalars['String']['output']>;
  /**
   * Label used when showing the number of files and there is only one.
   * @default 'file in list'
   */
  LabelFileCountSingular?: Maybe<Scalars['String']['output']>;
  /**
   * Label used when file load failed.
   * @default 'Error during load'
   */
  LabelFileLoadError?: Maybe<Scalars['String']['output']>;
  /**
   * Label used while loading a file.
   * @default 'Loading'
   */
  LabelFileLoading?: Maybe<Scalars['String']['output']>;
  /**
   * Label used when uploading a file.
   * @default 'Uploading'
   */
  LabelFileProcessing?: Maybe<Scalars['String']['output']>;
  /**
   * Label used when upload was cancelled.
   * @default 'Upload cancelled'
   */
  LabelFileProcessingAborted?: Maybe<Scalars['String']['output']>;
  /**
   * Label used when file upload has completed.
   * @default 'Upload complete'
   */
  LabelFileProcessingComplete?: Maybe<Scalars['String']['output']>;
  /**
   * Label used when something went wrong during file upload.
   * @default 'Error during upload'
   */
  LabelFileProcessingError?: Maybe<Scalars['String']['output']>;
  /**
   * Label used when something went wrong during reverting the file upload.
   * @default 'Error during revert'
   */
  LabelFileProcessingRevertError?: Maybe<Scalars['String']['output']>;
  /**
   * Label used when something went during during removing the file upload.
   * @default 'Error during remove'
   */
  LabelFileRemoveError?: Maybe<Scalars['String']['output']>;
  /**
   * Label used when file is removed (assistive only).
   * @default 'Removed'
   */
  LabelFileRemoved?: Maybe<Scalars['String']['output']>;
  /**
   * Label used when no file size information was received.
   * @default 'Size not available'
   */
  LabelFileSizeNotAvailable?: Maybe<Scalars['String']['output']>;
  /**
   * Label used while waiting for file size information.
   * @default 'Waiting for size'
   */
  LabelFileWaitingForSize?: Maybe<Scalars['String']['output']>;
  /**
   * Default label shown to indicate this is a drop area.
   * File Upload will automatically bind browse file events to
   * the element with CSS class .File Upload--label-action.
   * @default 'Drag & Drop your files or <span class="File Upload--label-action"> Browse </span>'
   */
  LabelIdle?: Maybe<Scalars['String']['output']>;
  /**
   * Label shown when the field contains invalid files and is validated by the parent form.
   * @default 'Field contains invalid files'
   */
  LabelInvalidField?: Maybe<Scalars['String']['output']>;
  /**
   * Label used to indicate to the user that an action can be cancelled.
   * @default 'tap to cancel'
   */
  LabelTapToCancel?: Maybe<Scalars['String']['output']>;
  /**
   * Label used to indicate to the user that an action can be retried.
   * @default 'tap to retry'
   */
  LabelTapToRetry?: Maybe<Scalars['String']['output']>;
  /**
   * Label used to indicate to the user that an action can be undone.
   * @default 'tap to undo'
   */
  LabelTapToUndo?: Maybe<Scalars['String']['output']>;
  /**
   * The thousands separator used to render numbers.
   * By default this is determined automatically.
   * @default 'auto'
   */
  LabelThousandsSeparator?: Maybe<Scalars['String']['output']>;
  /**
   * The maximum number of files that File Upload pond can handle.
   * @default null
   */
  MaxFiles?: Maybe<Scalars['Int']['output']>;
  /**
   * The maximum number of files that can be uploaded in parallel.
   * @default 2
   */
  MaxParallelUploads?: Maybe<Scalars['Int']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  /**
   * Set to true to show remove item button.
   * @default false
   */
  ShowButtonProcessItem?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Set to true to show remove item button.
   * @default true
   */
  ShowButtonRemoveItem?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Set to true to show remove item button.
   * @default true
   */
  ShowLoadIndicator?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Set to true to show remove item button.
   * @default true
   */
  ShowProgressIndicator?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Tells File Upload to store files in hidden file input elements so they can be posted along with
   * normal form post. This only works if the browser supports the DataTransfer constructor,
   * this is the case on Firefox, Chrome, Chromium powered browsers and Safari version 14.1
   * and higher.
   * @default false
   */
  StoreAsFile?: Maybe<Scalars['Boolean']['output']>;
  Style?: Maybe<StyleProperties>;
  /**
   * The position of the remove item button.
   * @default 'right'
   */
  StyleButtonProcessItemAlign?: Maybe<Scalars['String']['output']>;
  /**
   * The position of the remove item button.
   * @default 'right'
   */
  StyleButtonProcessItemPosition?: Maybe<Scalars['String']['output']>;
  /**
   * The size of the remove item button.
   * @default 'small'
   */
  StyleButtonProcessItemSize?: Maybe<Scalars['String']['output']>;
  /**
   * Enable to align the remove button to the left side of the file item.
   * @default 'center'
   */
  StyleButtonRemoveItemAlign?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The position of the remove item button.
   * @default 'left'
   */
  StyleButtonRemoveItemPosition?: Maybe<Scalars['String']['output']>;
  /**
   * The size of the remove item button.
   * @default 'small'
   */
  StyleButtonRemoveItemSize?: Maybe<Scalars['String']['output']>;
  /**
   * Set a forced aspect ratio for the file items.
   *
   * Useful when rendering cropped or fixed aspect ratio images in grid view.
   * @default null
   */
  StyleItemPanelAspectRatio?: Maybe<Scalars['String']['output']>;
  /**
   * The position of
   *
   * the remove item button.
   * @default 'center bottom'
   */
  StyleLoadIndicatorPosition?: Maybe<Scalars['String']['output']>;
  /**
   * The position of the remove item button.
   * @default 'small'
   */
  StyleLoadIndicatorSize?: Maybe<Scalars['String']['output']>;
  /**
   * Set a forced aspect ratio for the File Upload drop area.
   *
   * Accepts human readable aspect ratios like `1:1` or numeric aspect ratios like `0.75`.
   * @default null
   */
  StylePanelAspectRatio?: Maybe<Scalars['String']['output']>;
  /**
   * Set a different layout render mode.
   * @default null
   */
  StylePanelLayout?: Maybe<Scalars['String']['output']>;
  /**
   * The position of the remove item button.
   * @default 'right bottom'
   */
  StyleProgressIndicatorPosition?: Maybe<Scalars['String']['output']>;
  /**
   * The position of the remove item button.
   * @default 'small'
   */
  StyleProgressIndicatorSize?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type FileUploadBindings = {
  __typename?: 'FileUploadBindings';
  Style?: Maybe<Scalars['String']['output']>;
};

export enum FilterCriteria {
  BeginsWith = 'BeginsWith',
  Contains = 'Contains',
  EndsWith = 'EndsWith',
  Equals = 'Equals'
}

export type FilterParams = {
  __typename?: 'FilterParams';
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FinApp = IApplication & {
  __typename?: 'FinApp';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  AppConfigId?: Maybe<Scalars['String']['output']>;
  Bindings?: Maybe<FinAppBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  ComparisonList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Elements?: Maybe<Service>;
  EventCount?: Maybe<Scalars['String']['output']>;
  Exchange?: Maybe<Scalars['String']['output']>;
  HideElements?: Maybe<Scalars['String']['output']>;
  HideLoader?: Maybe<Scalars['Boolean']['output']>;
  Id: Scalars['ID']['output'];
  Indices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  LimitColumns?: Maybe<Scalars['Boolean']['output']>;
  MarketIdentifier?: Maybe<Scalars['String']['output']>;
  ModelId?: Maybe<Scalars['String']['output']>;
  RankingType?: Maybe<Scalars['String']['output']>;
  SelectedCountry?: Maybe<Scalars['String']['output']>;
  ShouldShowConfiguration?: Maybe<Scalars['Boolean']['output']>;
  ShowInternational?: Maybe<Scalars['Boolean']['output']>;
  ShowLinks?: Maybe<Scalars['Boolean']['output']>;
  Style?: Maybe<StyleProperties>;
  Symbol?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
  Typename?: Maybe<Scalars['String']['output']>;
  UserPrefs?: Maybe<Service>;
  View?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  XID?: Maybe<Scalars['String']['output']>;
  XIDs?: Maybe<Scalars['String']['output']>;
};

export type FinAppBindings = {
  __typename?: 'FinAppBindings';
  AppConfigId?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['String']['output']>;
  ComparisonList?: Maybe<Scalars['String']['output']>;
  Elements?: Maybe<Scalars['String']['output']>;
  EventCount?: Maybe<Scalars['String']['output']>;
  Exchange?: Maybe<Scalars['String']['output']>;
  HideElements?: Maybe<Scalars['String']['output']>;
  HideLoader?: Maybe<Scalars['String']['output']>;
  Indices?: Maybe<Scalars['String']['output']>;
  LimitColumns?: Maybe<Scalars['Boolean']['output']>;
  MarketIdentifier?: Maybe<Scalars['String']['output']>;
  ModelId?: Maybe<Scalars['String']['output']>;
  RankingType?: Maybe<Scalars['String']['output']>;
  SelectedCountry?: Maybe<Scalars['String']['output']>;
  ShouldShowConfiguration?: Maybe<Scalars['String']['output']>;
  ShowInternational?: Maybe<Scalars['String']['output']>;
  ShowLinks?: Maybe<Scalars['Boolean']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Symbol?: Maybe<Scalars['String']['output']>;
  UserPrefs?: Maybe<Scalars['String']['output']>;
  View?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
  XID?: Maybe<Scalars['String']['output']>;
  XIDs?: Maybe<Scalars['String']['output']>;
};

export type FinAppStyleConfigurations = {
  __typename?: 'FinAppStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
};

export type FlexLayout = {
  __typename?: 'FlexLayout';
  AlignContent?: Maybe<Scalars['String']['output']>;
  AlignItems?: Maybe<Scalars['String']['output']>;
  AlignSelf?: Maybe<Scalars['String']['output']>;
  Bindings?: Maybe<FlexLayoutBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  ColumnGap?: Maybe<Scalars['Int']['output']>;
  /** Defines the horizontal space between the type item components. It overrides the value of the spacing prop. */
  ColumnSpacing?: Maybe<Scalars['String']['output']>;
  /** The number of columns. */
  Columns?: Maybe<Scalars['String']['output']>;
  ContextId?: Maybe<Scalars['String']['output']>;
  /** Defines the flex-direction style property. It is applied for all screen sizes. */
  Direction?: Maybe<Scalars['String']['output']>;
  /** If a number, it sets the number of columns the grid item uses. It can't be greater than the total number of columns of the container (12 by default). If 'auto', the grid item's width matches its content. If false, the prop is ignored. If true, the grid item's width grows to use the space available in the grid container. The value is applied for the xl breakpoint and wider screens if not overridden. */
  ExtraLarge?: Maybe<Scalars['String']['output']>;
  /** If a number, it sets the number of columns the grid item uses. It can't be greater than the total number of columns of the container (12 by default). If 'auto', the grid item's width matches its content. If false, the prop is ignored. If true, the grid item's width grows to use the space available in the grid container. The value is applied for all the screen sizes with the lowest priority. */
  ExtraSmall?: Maybe<Scalars['String']['output']>;
  FlexWrap?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  /** The inner Layouts inside this element */
  InnerLayouts?: Maybe<Array<Maybe<Layout>>>;
  /** If true , the component will have the flex container behavior. You should be wrapping items with a container . */
  IsFlexContainer?: Maybe<Scalars['Boolean']['output']>;
  /** This is a grid item */
  IsLeaf?: Maybe<Scalars['Boolean']['output']>;
  ItemStyles?: Maybe<Scalars['StylePropertiesDictionary']['output']>;
  Items?: Maybe<Array<Maybe<Scalars['FlexLayoutItem']['output']>>>;
  JustifyContent?: Maybe<Scalars['String']['output']>;
  /** If a number, it sets the number of columns the grid item uses. It can't be greater than the total number of columns of the container (12 by default). If 'auto', the grid item's width matches its content. If false, the prop is ignored. If true, the grid item's width grows to use the space available in the grid container. The value is applied for the lg breakpoint and wider screens if not overridden. */
  Large?: Maybe<Scalars['String']['output']>;
  /** Page/Container/Item/Element that this flex layout refers to */
  LayoutItem?: Maybe<LayoutItem>;
  /** If a number, it sets the number of columns the grid item uses. It can't be greater than the total number of columns of the container (12 by default). If 'auto', the grid item's width matches its content. If false, the prop is ignored. If true, the grid item's width grows to use the space available in the grid container. The value is applied for the md breakpoint and wider screens if not overridden. */
  Medium?: Maybe<Scalars['String']['output']>;
  RowGap?: Maybe<Scalars['Int']['output']>;
  /** Defines the vertical space between the type item components. It overrides the value of the spacing prop. */
  RowSpacing?: Maybe<Scalars['String']['output']>;
  /**
   * When set to true, this component will generate an HTML Id equal to the ID
   * field, which can then be used as an HTML bookmark in the page
   */
  SetAsBookmark?: Maybe<Scalars['Boolean']['output']>;
  /** If a number, it sets the number of columns the grid item uses. It can't be greater than the total number of columns of the container (12 by default). If 'auto', the grid item's width matches its content. If false, the prop is ignored. If true, the grid item's width grows to use the space available in the grid container. The value is applied for the sm breakpoint and wider screens if not overridden. */
  Small?: Maybe<Scalars['String']['output']>;
  /** Defines the space between the type item components. It can only be used on a type container component. */
  Spacing?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  /** Defines the flex-wrap style property. It's applied for all screen sizes. */
  Wrap?: Maybe<Scalars['String']['output']>;
};

export type FlexLayoutBindings = {
  __typename?: 'FlexLayoutBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type FlexProperties = {
  __typename?: 'FlexProperties';
  AlignSelf?: Maybe<Scalars['ResponsiveProperty']['output']>;
  FlexBasis?: Maybe<Scalars['ResponsiveProperty']['output']>;
  FlexGrow?: Maybe<Scalars['ResponsiveProperty']['output']>;
  FlexShrink?: Maybe<Scalars['ResponsiveProperty']['output']>;
  FlexWrap?: Maybe<Scalars['ResponsiveProperty']['output']>;
  ItemId: Scalars['String']['output'];
  TextAlign?: Maybe<Scalars['ResponsiveProperty']['output']>;
};

export type Form = IApplication & IDesignable & {
  __typename?: 'Form';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<FormBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  ContextId?: Maybe<Scalars['String']['output']>;
  Data?: Maybe<Scalars['SampleData']['output']>;
  Enabled?: Maybe<Scalars['Boolean']['output']>;
  FormId?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  Items?: Maybe<Array<LayoutItem>>;
  Layout?: Maybe<Layout>;
  Paper?: Maybe<Paper>;
  Service?: Maybe<Scalars['String']['output']>;
  /**
   * When set to true, this component will generate an HTML Id equal to the ID
   * field, which can then be used as an HTML bookmark in the page
   */
  SetAsBookmark?: Maybe<Scalars['Boolean']['output']>;
  ShowBindingField?: Maybe<Scalars['Boolean']['output']>;
  StopPropagation?: Maybe<Scalars['Boolean']['output']>;
  Style?: Maybe<StyleProperties>;
  Typename?: Maybe<Scalars['String']['output']>;
  UniqueName: Scalars['String']['output'];
  Visible?: Maybe<Scalars['Boolean']['output']>;
  getData?: Maybe<Scalars['Method']['output']>;
};

export type FormBindings = {
  __typename?: 'FormBindings';
  Data?: Maybe<Scalars['String']['output']>;
  Enabled?: Maybe<Scalars['String']['output']>;
  Items?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type FormStyleConfigurations = {
  __typename?: 'FormStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FragmentLayout = {
  __typename?: 'FragmentLayout';
  Bindings?: Maybe<FragmentLayoutBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  ContextId?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type FragmentLayoutBindings = {
  __typename?: 'FragmentLayoutBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type FreeFormLayout = {
  __typename?: 'FreeFormLayout';
  Bottom?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  ContextId?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  ItemStyles?: Maybe<Scalars['StylePropertiesDictionary']['output']>;
  Items?: Maybe<Array<Maybe<Scalars['FlexLayoutItem']['output']>>>;
  Left?: Maybe<Scalars['String']['output']>;
  Position?: Maybe<Scalars['String']['output']>;
  Right?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  Top?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  ZIndex?: Maybe<Scalars['String']['output']>;
};

export type FreeFormLayoutBindings = {
  __typename?: 'FreeFormLayoutBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  InReviewMode?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type GenerateCode = {
  __typename?: 'GenerateCode';
  Bindings?: Maybe<Scalars['BindingsDictionary']['output']>;
  CommandResult?: Maybe<Scalars['String']['output']>;
  DataTransformations?: Maybe<Scalars['BindingsDictionary']['output']>;
  GenerationType?: Maybe<Scalars['String']['output']>;
  InputData?: Maybe<Scalars['SampleData']['output']>;
  Options?: Maybe<Scalars['TransformMethodOptions']['output']>;
};

export type GoBack = {
  __typename?: 'GoBack';
  CommandResult?: Maybe<Scalars['String']['output']>;
};

export type GoToBookmark = {
  __typename?: 'GoToBookmark';
  Bindings?: Maybe<GoToBookmarkBindings>;
  Bookmark?: Maybe<Scalars['BookmarkId']['output']>;
  CommandResult?: Maybe<Scalars['String']['output']>;
};

export type GoToBookmarkBindings = {
  __typename?: 'GoToBookmarkBindings';
  Bookmark?: Maybe<Scalars['String']['output']>;
};

export type GoToPage = {
  __typename?: 'GoToPage';
  Bindings?: Maybe<GoToPageBindings>;
  CommandResult?: Maybe<Scalars['String']['output']>;
  IgnoreSessionPrefix?: Maybe<Scalars['Boolean']['output']>;
  OpenInNewWindow?: Maybe<Scalars['Boolean']['output']>;
  QueryStringBindings?: Maybe<Scalars['BindingsDictionary']['output']>;
  URLBindings?: Maybe<Scalars['BindingsDictionary']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  UseNativeRedirect?: Maybe<Scalars['Boolean']['output']>;
};

export type GoToPageBindings = {
  __typename?: 'GoToPageBindings';
  Url?: Maybe<Scalars['String']['output']>;
};

export type GoogleAnalytics = {
  __typename?: 'GoogleAnalytics';
  IsEnabled?: Maybe<Scalars['Boolean']['output']>;
  TagId?: Maybe<Scalars['String']['output']>;
};

export type GridEditor = {
  __typename?: 'GridEditor';
  Bindings?: Maybe<GridEditorBindings>;
  Data?: Maybe<Scalars['SampleData']['output']>;
  Id: Scalars['ID']['output'];
  Label?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  SelectedIndex?: Maybe<Scalars['Int']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
  UseFormDialog?: Maybe<Scalars['Boolean']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};

export type GridEditorBindings = {
  __typename?: 'GridEditorBindings';
  Data?: Maybe<Scalars['String']['output']>;
  SelectedIndex?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
  UseFormDialog?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};

export type GridStackLayout = {
  __typename?: 'GridStackLayout';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  /** Tells to ignore x and y attributes and to place element to the first available position. Having either one missing will also do that. */
  AutoPosition?: Maybe<Scalars['Boolean']['output']>;
  Classes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Make gridItem size itself to the content, calling GridStack.resizeToContent(el) whenever the grid or item is resized. */
  FitToContent?: Maybe<Scalars['Boolean']['output']>;
  /** Element size in row (default 1x1) */
  H?: Maybe<Scalars['Int']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  /** The inner Layouts inside this element */
  InnerLayouts?: Maybe<Array<Maybe<Layout>>>;
  /** Page/Container/Item/Element that this flex layout refers to */
  LayoutItem?: Maybe<LayoutItem>;
  /** Element constraint - Maximum Height */
  MaxH?: Maybe<Scalars['Int']['output']>;
  /** Element constraint - Maximum Width */
  MaxW?: Maybe<Scalars['Int']['output']>;
  /** Element constraint - Minimum Height */
  MinH?: Maybe<Scalars['Int']['output']>;
  /** Element constraint - Minimum Width */
  MinW?: Maybe<Scalars['Int']['output']>;
  /** Element size in column (default 1x1) */
  W?: Maybe<Scalars['Int']['output']>;
  /** Element position in columrow. Note: if missing this will autoPosition the item */
  X?: Maybe<Scalars['Int']['output']>;
  /** Element position in row. Note: if missing this will autoPosition the item */
  Y?: Maybe<Scalars['Int']['output']>;
};

export enum GroupProp {
  Always = 'Always',
  Never = 'Never'
}

export type Html = {
  __typename?: 'Html';
  Bindings?: Maybe<HtmlBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Id: Scalars['ID']['output'];
  Style?: Maybe<StyleProperties>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type HtmlBindings = {
  __typename?: 'HtmlBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type IActionTrigger = {
  CommandSet?: Maybe<CommandSet>;
  ListenTo?: Maybe<Scalars['Method']['output']>;
  PropagateToParent?: Maybe<TriggerPropagation>;
  SkipAction?: Maybe<Scalars['String']['output']>;
  StopPropagation?: Maybe<Scalars['Boolean']['output']>;
  Trigger?: Maybe<Scalars['String']['output']>;
  postHandler?: Maybe<Scalars['Method']['output']>;
  preHandler?: Maybe<Scalars['Method']['output']>;
};

export type IApplication = {
  Id: Scalars['ID']['output'];
  Service?: Maybe<Scalars['String']['output']>;
  Typename?: Maybe<Scalars['String']['output']>;
  UniqueName: Scalars['String']['output'];
  getData?: Maybe<Scalars['Method']['output']>;
};

export type IDesignable = {
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
};

export type IEditable = {
  Editable?: Maybe<Scalars['Boolean']['output']>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
};

export type IField = {
  DefaultValue?: Maybe<Scalars['String']['output']>;
  FieldType?: Maybe<FieldType>;
  Format?: Maybe<FieldFormat>;
  Id: Scalars['ID']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  Variant?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type IFrame = IDesignable & IEditable & IField & {
  __typename?: 'IFrame';
  Bindings?: Maybe<IFrameBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  Editable?: Maybe<Scalars['Boolean']['output']>;
  FieldType?: Maybe<FieldType>;
  Format?: Maybe<FieldFormat>;
  Height?: Maybe<Scalars['String']['output']>;
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  Message?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  Source: Scalars['String']['output'];
  Style?: Maybe<StyleProperties>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type IFrameBindings = {
  __typename?: 'IFrameBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  Height?: Maybe<Scalars['String']['output']>;
  Icon?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Reload?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
};

export type IInstruction = {
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  Name: Scalars['String']['output'];
  ParameterTypes?: Maybe<Array<Maybe<IParameter>>>;
};

export type IParameter = {
  Description?: Maybe<Scalars['String']['output']>;
  IsMandatory?: Maybe<Scalars['Boolean']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParameterType?: Maybe<ParameterType>;
};

export type IParameterWithValues = {
  Name?: Maybe<Scalars['String']['output']>;
  /** Value can have a serialized element in it, such as a mapping, if the parameter type if Mapping, for example */
  Value?: Maybe<Scalars['FieldValueExpression']['output']>;
};

export type ISelectFromList = {
  MultiSelectFilter?: Maybe<FilterCriteria>;
  MultiSelectPossibleValues?: Maybe<Array<Maybe<Scalars['MultiSelectObject']['output']>>>;
  ServiceList?: Maybe<ServiceList>;
};

export type Icon = {
  __typename?: 'Icon';
  Bindings?: Maybe<IconBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Color?: Maybe<Scalars['String']['output']>;
  ContextId?: Maybe<Scalars['String']['output']>;
  IconLibrary?: Maybe<Scalars['String']['output']>;
  IconName: Scalars['String']['output'];
  Id: Scalars['ID']['output'];
  Size?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  Variant?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type IconBindings = {
  __typename?: 'IconBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  IconName?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Variant?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type IconSelector = {
  __typename?: 'IconSelector';
  Bindings?: Maybe<IconSelectorBindings>;
  Id: Scalars['ID']['output'];
  Name: Scalars['String']['output'];
  Value?: Maybe<Scalars['String']['output']>;
};

export type IconSelectorBindings = {
  __typename?: 'IconSelectorBindings';
  Value?: Maybe<Scalars['String']['output']>;
};

export type IconStyleConfigurations = {
  __typename?: 'IconStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Image = {
  __typename?: 'Image';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  /** Image alt tag value */
  AlternativeText?: Maybe<Scalars['String']['output']>;
  Analytics?: Maybe<Analytics>;
  /** The color the image transitions in from */
  BgColor?: Maybe<Scalars['String']['output']>;
  Bindings?: Maybe<ImageBindings>;
  /** CSS class for the image */
  ClassName?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  /** Any valid CSS length value (for the shift) */
  Distance?: Maybe<Scalars['String']['output']>;
  /** Sets the CSS transition-duration in milliseconds */
  Duration?: Maybe<Scalars['Int']['output']>;
  /** Sets the CSS transition-timing-function */
  Easing?: Maybe<Scalars['String']['output']>;
  /** Display default error icon, or your own */
  ErrorIcon?: Maybe<Icon>;
  FallbackImage?: Maybe<Scalars['String']['output']>;
  /** Any valid CSS object-fit value */
  Fit?: Maybe<Scalars['String']['output']>;
  /** Any valid CSS height value */
  Height?: Maybe<Scalars['String']['output']>;
  HideOnError?: Maybe<Scalars['Boolean']['output']>;
  /** CSS class for the icon wrapper div */
  IconWrapperClassName?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  Path?: Maybe<Scalars['String']['output']>;
  /** Any valid CSS position value */
  Position?: Maybe<Scalars['String']['output']>;
  /** Either "left", "right", "top", "bottom" or "false" */
  Shift?: Maybe<Scalars['String']['output']>;
  /** Duration of shift in milliseconds */
  ShiftDuration?: Maybe<Scalars['Int']['output']>;
  /** Display default loading spinner, or your own */
  ShowLoading?: Maybe<Scalars['Boolean']['output']>;
  Size?: Maybe<Scalars['String']['output']>;
  Source?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  /** Image source - required and unique */
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  /** Any valid CSS width value */
  Width?: Maybe<Scalars['String']['output']>;
  /** CSS class for the root wrapper div */
  WrapperClassName?: Maybe<Scalars['String']['output']>;
};

export type ImageBindings = {
  __typename?: 'ImageBindings';
  AlternativeText?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['String']['output']>;
  Path?: Maybe<Scalars['String']['output']>;
  Size?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type InputData = {
  __typename?: 'InputData';
  DefaultValue?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Required?: Maybe<Scalars['Boolean']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['FieldValueExpression']['output']>;
};

export type InputField = IDesignable & IEditable & IField & {
  __typename?: 'InputField';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Adornment?: Maybe<Adornment>;
  Analytics?: Maybe<Analytics>;
  /** This prop helps users to fill forms faster, especially on mobile devices. The name can be confusing, as it's more like an autofill. You can learn more about it following the specification . */
  AutoComplete?: Maybe<Scalars['String']['output']>;
  /** If true , the input element is focused during the first mount. */
  AutoFocus?: Maybe<Scalars['Boolean']['output']>;
  Bindings?: Maybe<InputFieldBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  /** If true, will enable the component to clear the value of its input on when Enter is pressed */
  ClearValueOnEnter?: Maybe<Scalars['Boolean']['output']>;
  Color?: Maybe<Scalars['String']['output']>;
  /** This is the context for the autocomplete that appears in the editor */
  ContextAutocomplete?: Maybe<ContextAutocomplete>;
  /** Debounce override for the input field to control the delay before a handler is run */
  Debounce?: Maybe<Scalars['Int']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  /** If true , the component is disabled. */
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Editable?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the label is displayed in an error state. */
  Error?: Maybe<Scalars['Boolean']['output']>;
  FieldType?: Maybe<FieldType>;
  FocusOnDisplay?: Maybe<Scalars['Boolean']['output']>;
  Format?: Maybe<Scalars['FormatName']['output']>;
  /** If true , the input will take up the full width of its container. */
  FullWidth?: Maybe<Scalars['Boolean']['output']>;
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  InputType?: Maybe<Scalars['String']['output']>;
  /** This is the label that appears at the top of the input box, within the top border */
  Label?: Maybe<Scalars['String']['output']>;
  /** If dense or normal , will adjust vertical spacing of this and contained components. */
  Margin?: Maybe<Scalars['String']['output']>;
  Max?: Maybe<Scalars['Float']['output']>;
  /** Maximum length of characters for the field. */
  MaxLength?: Maybe<Scalars['String']['output']>;
  /** Maximum number of rows to display when multiline option is set to true. */
  MaxRows?: Maybe<Scalars['String']['output']>;
  /** For when the input is a number, the minimum and maximum values */
  Min?: Maybe<Scalars['Float']['output']>;
  /** Minimum number of rows to display when multiline option is set to true. */
  MinRows?: Maybe<Scalars['String']['output']>;
  /** If true , a textarea element is rendered instead of an input. */
  Multiline?: Maybe<Scalars['Boolean']['output']>;
  /** When Multiline=true, set MultilineAutosize so that the input field will grow as the user types */
  MultilineAutosize?: Maybe<Scalars['Boolean']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  /** The short hint displayed in the input before the user enters a value. */
  Placeholder?: Maybe<Scalars['String']['output']>;
  /** If true , the label is displayed as required and the input element is required. */
  Required?: Maybe<Scalars['Boolean']['output']>;
  Resize?: Maybe<Scalars['String']['output']>;
  /** Number of rows to display when multiline option is set to true. */
  Rows?: Maybe<Scalars['String']['output']>;
  /** Render a Select element while passing the Input element to Select as input parameter. If this option is set you must pass the options of the select as children. */
  Select?: Maybe<Scalars['Boolean']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  /**
   * When set to true, this component will generate an HTML Id equal to the ID
   * field, which can then be used as an HTML bookmark in the page
   */
  SetAsBookmark?: Maybe<Scalars['Boolean']['output']>;
  Size?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  /** When true, copied JSON string will be transformed to a string representation of the JSON object if valid */
  TransformToString?: Maybe<Scalars['Boolean']['output']>;
  Valid?: Maybe<Valid>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
  Value?: Maybe<Scalars['String']['output']>;
  /** The variant to use. */
  Variant?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type InputFieldBindings = {
  __typename?: 'InputFieldBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  InputType?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  MaxLength?: Maybe<Scalars['String']['output']>;
  MaxRows?: Maybe<Scalars['String']['output']>;
  MinRows?: Maybe<Scalars['String']['output']>;
  Multiline?: Maybe<Scalars['String']['output']>;
  Rows?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Valid?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type InputFieldStyleConfigurations = {
  __typename?: 'InputFieldStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalChildren?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type JsonView = IDesignable & IField & {
  __typename?: 'JsonView';
  Bindings?: Maybe<JsonViewBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Data?: Maybe<Scalars['String']['output']>;
  DataName?: Maybe<Scalars['String']['output']>;
  Expanded?: Maybe<Scalars['Boolean']['output']>;
  Id: Scalars['ID']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Search?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  Title?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type JsonViewBindings = {
  __typename?: 'JsonViewBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Data?: Maybe<Scalars['String']['output']>;
  DataName?: Maybe<Scalars['String']['output']>;
  Expanded?: Maybe<Scalars['Boolean']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Search?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type Label = IDesignable & IField & {
  __typename?: 'Label';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Analytics?: Maybe<Analytics>;
  Bindings?: Maybe<LabelBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  BooleanFormat?: Maybe<BooleanFormat>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  ChipClasses?: Maybe<Scalars['ClassSet']['output']>;
  ClassName?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  /** The color of the component. It supports both default and custom theme colors, which can be added as shown in the palette customization guide . */
  Color?: Maybe<Scalars['String']['output']>;
  Currency?: Maybe<Scalars['String']['output']>;
  /** Enables language-sensitive date & time formatting */
  DateFormat?: Maybe<DateFormat>;
  /** If true , the transition animation is disabled. */
  DisableAnimation?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the component is disabled. */
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  DisplayAsChip?: Maybe<Scalars['Boolean']['output']>;
  /** When true, the label will display a tooltip with its value.  This is useful when the label is truncated. */
  EllipsisOnOverflow?: Maybe<Scalars['Boolean']['output']>;
  EndIcon?: Maybe<Icon>;
  /** If true , the label is displayed in an error state. */
  Error?: Maybe<Scalars['Boolean']['output']>;
  FieldType?: Maybe<FieldType>;
  Filled?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the input of this label is focused. */
  Focused?: Maybe<Scalars['Boolean']['output']>;
  Format?: Maybe<FieldFormat>;
  FormatName?: Maybe<Scalars['FormatName']['output']>;
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  /** If the label data is an array, what List separator to use.  Commas are used by default, unless DisplayAsChip is set to true */
  ListSeparator?: Maybe<Scalars['String']['output']>;
  /** If dense , will adjust vertical spacing. This is normally obtained via context from FormControl. */
  Margin?: Maybe<Scalars['String']['output']>;
  MultiLine?: Maybe<Scalars['Boolean']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  /** Enables language-sensitive number formatting, allowing for options such as decimal places, currency, and percentage formatting. */
  NumberFormat?: Maybe<NumberFormat>;
  NumberOfLines?: Maybe<Scalars['Int']['output']>;
  /** if true , the label will indicate that the input is required. */
  Required?: Maybe<Scalars['Boolean']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  /**
   * When set to true, this component will generate an HTML Id equal to the ID
   * field, which can then be used as an HTML bookmark in the page
   */
  SetAsBookmark?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the label is shrunk. */
  Shrink?: Maybe<Scalars['Boolean']['output']>;
  /** The size of the component. */
  Size?: Maybe<Scalars['String']['output']>;
  StartIcon?: Maybe<Icon>;
  Style?: Maybe<StyleProperties>;
  Title?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  /** The variant to use. */
  Variant?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  getData?: Maybe<Scalars['Method']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type LabelBindings = {
  __typename?: 'LabelBindings';
  ChipClasses?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['String']['output']>;
  Currency?: Maybe<Scalars['String']['output']>;
  FormatName?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type LabelStyleConfigurations = {
  __typename?: 'LabelStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum Language {
  English = 'ENGLISH',
  French = 'FRENCH',
  German = 'GERMAN',
  Spanish = 'SPANISH'
}

export type Layout = AccordionLayout | FlexLayout | FragmentLayout | FreeFormLayout | GridStackLayout | LinearLayout | TabLayout | TableLayout;

export type LayoutItem = AiDialog | AccordionLayout | ActionEditor | AudioPlayer | AudioRecorder | Avatar | BasicInput | Button | ButtonGroup | Chart | Checkbox | CircularProgress | CodeEditor | Component | ComponentLibrary | ContextAutocomplete | ContextMenu | DatePicker | Dialog | Feed | FileList | FileUpload | FinApp | Form | Html | IFrame | Icon | Image | InputField | Label | LinearProgress | Link | List | ListClearAllButton | ListColumn | ListExportButton | ListQuickFilter | Markdown | MultiFilter | MultiSelect | Overlay | Page | PropertiesEditor | ProportionalBar | RadioGroup | Repeater | ResolutionButtons | RichTextEditor | RichTreeList | SimpleContainer | Slider | Snackbar | Switch | TabContainer | TabLayout | TreeList | VisibleMenu;

export type LibraryItem = {
  __typename?: 'LibraryItem';
  Category?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Icon?: Maybe<Icon>;
  Id: Scalars['String']['output'];
  InitialHeight?: Maybe<Scalars['Int']['output']>;
  InitialWidth?: Maybe<Scalars['Int']['output']>;
  Name: Scalars['String']['output'];
  SerialNumber?: Maybe<Scalars['String']['output']>;
  SubCategory?: Maybe<Scalars['String']['output']>;
  Template?: Maybe<LayoutItem>;
  Type?: Maybe<Scalars['String']['output']>;
};

export type LinearLayout = {
  __typename?: 'LinearLayout';
  AlignItems?: Maybe<Scalars['ResponsiveProperty']['output']>;
  /** Defines the flex-direction style property. It is applied for all screen sizes. */
  Direction?: Maybe<Scalars['ResponsiveProperty']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  /** The inner Layouts inside this element */
  InnerLayouts?: Maybe<Array<Maybe<Layout>>>;
  ItemAlignment?: Maybe<Scalars['ResponsiveProperty']['output']>;
  /** Page/Container/Item/Element that this flex layout refers to */
  LayoutItem?: Maybe<LayoutItem>;
  /** The layout items this layout applies to */
  LayoutItemIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The layout items this layout applies to */
  LayoutItemProps?: Maybe<Array<Maybe<FlexProperties>>>;
  /** Defines the space between immediate children. */
  Spacing?: Maybe<Scalars['ResponsiveProperty']['output']>;
  Style?: Maybe<StyleProperties>;
};

export type LinearProgress = IDesignable & IField & {
  __typename?: 'LinearProgress';
  Bindings?: Maybe<LinearProgressBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Id: Scalars['ID']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  Value?: Maybe<Scalars['Float']['output']>;
  ValueBuffer?: Maybe<Scalars['Float']['output']>;
  Variant?: Maybe<LinearProgressVariant>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type LinearProgressBindings = {
  __typename?: 'LinearProgressBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  ValueBuffer?: Maybe<Scalars['String']['output']>;
  Variant?: Maybe<CircularProgressVariant>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export enum LinearProgressVariant {
  Buffer = 'buffer',
  Determinate = 'determinate',
  Indeterminate = 'indeterminate',
  Query = 'query'
}

export type Link = IDesignable & IField & {
  __typename?: 'Link';
  Analytics?: Maybe<Analytics>;
  Bindings?: Maybe<LinkBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  FileExtension?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  Label?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  Target?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  URL?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type LinkBindings = {
  __typename?: 'LinkBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  FileExtension?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  URL?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type List = IApplication & {
  __typename?: 'List';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<ListBindings>;
  ClearGridState?: Maybe<Scalars['Boolean']['output']>;
  Columns?: Maybe<Array<ListColumn>>;
  ColumnsClasses?: Maybe<Scalars['ClassSet']['output']>;
  ColumnsHeaderClasses?: Maybe<Scalars['ClassSet']['output']>;
  DisabledColumnGrouping?: Maybe<Scalars['Boolean']['output']>;
  EditMode?: Maybe<Scalars['String']['output']>;
  EnableCellSelection?: Maybe<Scalars['Boolean']['output']>;
  EnableEditing?: Maybe<Scalars['Boolean']['output']>;
  EnableRowClickSelection?: Maybe<Scalars['Boolean']['output']>;
  EnableSideBar?: Maybe<Scalars['Boolean']['output']>;
  GridHeight?: Maybe<Scalars['String']['output']>;
  GridLayout?: Maybe<Scalars['String']['output']>;
  GroupingClasses?: Maybe<Scalars['ClassSet']['output']>;
  GroupingHeaderClasses?: Maybe<Scalars['ClassSet']['output']>;
  GroupingsCollapsed?: Maybe<Scalars['Boolean']['output']>;
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  Items?: Maybe<Array<Maybe<LayoutItem>>>;
  ListColumns?: Maybe<Array<ListColumn>>;
  Loading?: Maybe<Scalars['Boolean']['output']>;
  PaginationAutoPageSize?: Maybe<Scalars['Boolean']['output']>;
  PivotMode?: Maybe<Scalars['Boolean']['output']>;
  QuickFilterText?: Maybe<Scalars['String']['output']>;
  ReadOnlyEdit?: Maybe<Scalars['Boolean']['output']>;
  Refresh?: Maybe<Scalars['RefreshGrid']['output']>;
  RowGroupDisplayType?: Maybe<Scalars['String']['output']>;
  RowGroupName?: Maybe<Scalars['String']['output']>;
  RowHeight?: Maybe<Scalars['Float']['output']>;
  Rows?: Maybe<Scalars['SampleData']['output']>;
  RowsAutoSizeStrategy?: Maybe<Scalars['String']['output']>;
  RowsPerPage?: Maybe<Scalars['Int']['output']>;
  SelectionMode?: Maybe<Scalars['String']['output']>;
  Service?: Maybe<Service>;
  ShowAddRowsButton?: Maybe<Scalars['Boolean']['output']>;
  ShowAdvancedFilter?: Maybe<Scalars['Boolean']['output']>;
  ShowCheckboxSelection?: Maybe<Scalars['Boolean']['output']>;
  ShowClearAllFilters?: Maybe<Scalars['Boolean']['output']>;
  ShowExport?: Maybe<Scalars['Boolean']['output']>;
  ShowFloatingFilter?: Maybe<Scalars['Boolean']['output']>;
  ShowGroupingPanel?: Maybe<Scalars['String']['output']>;
  ShowPageSizeSelector?: Maybe<Scalars['Boolean']['output']>;
  ShowPagination?: Maybe<Scalars['Boolean']['output']>;
  ShowQuickFilter?: Maybe<Scalars['Boolean']['output']>;
  SideBarOpenByDefault?: Maybe<Scalars['Boolean']['output']>;
  SpreadsheetModeOptions?: Maybe<SpreadsheetModeOptions>;
  Toolbar?: Maybe<ListToolbar>;
  Typename?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  getData?: Maybe<Scalars['Method']['output']>;
};

export type ListAndChartLabels = {
  __typename?: 'ListAndChartLabels';
  ApplyFilter?: Maybe<Scalars['String']['output']>;
  Area?: Maybe<Scalars['String']['output']>;
  AreaChart?: Maybe<Scalars['String']['output']>;
  AreaGroup?: Maybe<Scalars['String']['output']>;
  AriaChecked?: Maybe<Scalars['String']['output']>;
  AriaHidden?: Maybe<Scalars['String']['output']>;
  AriaUnchecked?: Maybe<Scalars['String']['output']>;
  AriaVisible?: Maybe<Scalars['String']['output']>;
  AutosizeAllColumns?: Maybe<Scalars['String']['output']>;
  AutosizeThisColumn?: Maybe<Scalars['String']['output']>;
  Average?: Maybe<Scalars['String']['output']>;
  Axis?: Maybe<Scalars['String']['output']>;
  Background?: Maybe<Scalars['String']['output']>;
  BarChart?: Maybe<Scalars['String']['output']>;
  BarGroup?: Maybe<Scalars['String']['output']>;
  Blanks?: Maybe<Scalars['String']['output']>;
  Blur?: Maybe<Scalars['String']['output']>;
  Bold?: Maybe<Scalars['String']['output']>;
  BoldItalic?: Maybe<Scalars['String']['output']>;
  Bottom?: Maybe<Scalars['String']['output']>;
  Bubble?: Maybe<Scalars['String']['output']>;
  BubbleTooltip?: Maybe<Scalars['String']['output']>;
  Callout?: Maybe<Scalars['String']['output']>;
  Categories?: Maybe<Scalars['String']['output']>;
  Chart?: Maybe<Scalars['String']['output']>;
  ChartRange?: Maybe<Scalars['String']['output']>;
  CollapseAll?: Maybe<Scalars['String']['output']>;
  Color?: Maybe<Scalars['String']['output']>;
  ColumnChart?: Maybe<Scalars['String']['output']>;
  ColumnGroup?: Maybe<Scalars['String']['output']>;
  Contains?: Maybe<Scalars['String']['output']>;
  Copy?: Maybe<Scalars['String']['output']>;
  CopyWithHeaders?: Maybe<Scalars['String']['output']>;
  Count?: Maybe<Scalars['String']['output']>;
  CsvExport?: Maybe<Scalars['String']['output']>;
  CtrlC?: Maybe<Scalars['String']['output']>;
  CtrlV?: Maybe<Scalars['String']['output']>;
  Data?: Maybe<Scalars['String']['output']>;
  Doughnut?: Maybe<Scalars['String']['output']>;
  DoughnutTooltip?: Maybe<Scalars['String']['output']>;
  EndsWith?: Maybe<Scalars['String']['output']>;
  Equals?: Maybe<Scalars['String']['output']>;
  ExcelExport?: Maybe<Scalars['String']['output']>;
  ExpandAll?: Maybe<Scalars['String']['output']>;
  Export?: Maybe<Scalars['String']['output']>;
  FillOpacity?: Maybe<Scalars['String']['output']>;
  FilterOoo?: Maybe<Scalars['String']['output']>;
  First?: Maybe<Scalars['String']['output']>;
  Font?: Maybe<Scalars['String']['output']>;
  Format?: Maybe<Scalars['String']['output']>;
  GreaterThan?: Maybe<Scalars['String']['output']>;
  GreaterThanOrEqual?: Maybe<Scalars['String']['output']>;
  GroupBy?: Maybe<Scalars['String']['output']>;
  GroupedAreaTooltip?: Maybe<Scalars['String']['output']>;
  GroupedBar?: Maybe<Scalars['String']['output']>;
  GroupedBarTooltip?: Maybe<Scalars['String']['output']>;
  GroupedColumn?: Maybe<Scalars['String']['output']>;
  GroupedColumnTooltip?: Maybe<Scalars['String']['output']>;
  HistogramBinCount?: Maybe<Scalars['String']['output']>;
  HistogramChart?: Maybe<Scalars['String']['output']>;
  HistogramGroup?: Maybe<Scalars['String']['output']>;
  HistogramTooltip?: Maybe<Scalars['String']['output']>;
  InRange?: Maybe<Scalars['String']['output']>;
  Italic?: Maybe<Scalars['String']['output']>;
  ItemPaddingX?: Maybe<Scalars['String']['output']>;
  ItemPaddingY?: Maybe<Scalars['String']['output']>;
  Labels?: Maybe<Scalars['String']['output']>;
  Last?: Maybe<Scalars['String']['output']>;
  Left?: Maybe<Scalars['String']['output']>;
  Legend?: Maybe<Scalars['String']['output']>;
  Length?: Maybe<Scalars['String']['output']>;
  LessThan?: Maybe<Scalars['String']['output']>;
  LessThanOrEqual?: Maybe<Scalars['String']['output']>;
  Line?: Maybe<Scalars['String']['output']>;
  LineGroup?: Maybe<Scalars['String']['output']>;
  LineTooltip?: Maybe<Scalars['String']['output']>;
  LineWidth?: Maybe<Scalars['String']['output']>;
  LoadingOoo?: Maybe<Scalars['String']['output']>;
  MarkerPadding?: Maybe<Scalars['String']['output']>;
  MarkerSize?: Maybe<Scalars['String']['output']>;
  MarkerStroke?: Maybe<Scalars['String']['output']>;
  Markers?: Maybe<Scalars['String']['output']>;
  Max?: Maybe<Scalars['String']['output']>;
  Min?: Maybe<Scalars['String']['output']>;
  More?: Maybe<Scalars['String']['output']>;
  Next?: Maybe<Scalars['String']['output']>;
  NoDataToChart?: Maybe<Scalars['String']['output']>;
  NoMatches?: Maybe<Scalars['String']['output']>;
  NoPin?: Maybe<Scalars['String']['output']>;
  None?: Maybe<Scalars['String']['output']>;
  Normal?: Maybe<Scalars['String']['output']>;
  NormalizedArea?: Maybe<Scalars['String']['output']>;
  NormalizedAreaTooltip?: Maybe<Scalars['String']['output']>;
  NormalizedBar?: Maybe<Scalars['String']['output']>;
  NormalizedBarTooltip?: Maybe<Scalars['String']['output']>;
  NormalizedColumn?: Maybe<Scalars['String']['output']>;
  NormalizedColumnTooltip?: Maybe<Scalars['String']['output']>;
  NotContains?: Maybe<Scalars['String']['output']>;
  NotEqual?: Maybe<Scalars['String']['output']>;
  Of?: Maybe<Scalars['String']['output']>;
  Offset?: Maybe<Scalars['String']['output']>;
  Padding?: Maybe<Scalars['String']['output']>;
  Page?: Maybe<Scalars['String']['output']>;
  Paste?: Maybe<Scalars['String']['output']>;
  Pie?: Maybe<Scalars['String']['output']>;
  PieChart?: Maybe<Scalars['String']['output']>;
  PieGroup?: Maybe<Scalars['String']['output']>;
  PieTooltip?: Maybe<Scalars['String']['output']>;
  PinColumn?: Maybe<Scalars['String']['output']>;
  PinLeft?: Maybe<Scalars['String']['output']>;
  PinRight?: Maybe<Scalars['String']['output']>;
  PivotChart?: Maybe<Scalars['String']['output']>;
  PivotChartAndPivotMode?: Maybe<Scalars['String']['output']>;
  PivotChartRequiresPivotMode?: Maybe<Scalars['String']['output']>;
  PivotChartTitle?: Maybe<Scalars['String']['output']>;
  Position?: Maybe<Scalars['String']['output']>;
  Previous?: Maybe<Scalars['String']['output']>;
  RangeChartTitle?: Maybe<Scalars['String']['output']>;
  ResetColumns?: Maybe<Scalars['String']['output']>;
  Right?: Maybe<Scalars['String']['output']>;
  Scatter?: Maybe<Scalars['String']['output']>;
  ScatterGroup?: Maybe<Scalars['String']['output']>;
  ScatterTooltip?: Maybe<Scalars['String']['output']>;
  SearchOoo?: Maybe<Scalars['String']['output']>;
  SelectAll?: Maybe<Scalars['String']['output']>;
  Series?: Maybe<Scalars['String']['output']>;
  Settings?: Maybe<Scalars['String']['output']>;
  Shadow?: Maybe<Scalars['String']['output']>;
  Size?: Maybe<Scalars['String']['output']>;
  StackedArea?: Maybe<Scalars['String']['output']>;
  StackedAreaTooltip?: Maybe<Scalars['String']['output']>;
  StackedBar?: Maybe<Scalars['String']['output']>;
  StackedBarTooltip?: Maybe<Scalars['String']['output']>;
  StackedColumn?: Maybe<Scalars['String']['output']>;
  StackedColumnTooltip?: Maybe<Scalars['String']['output']>;
  StartsWith?: Maybe<Scalars['String']['output']>;
  StrokeOpacity?: Maybe<Scalars['String']['output']>;
  StrokeWidth?: Maybe<Scalars['String']['output']>;
  Sum?: Maybe<Scalars['String']['output']>;
  Thickness?: Maybe<Scalars['String']['output']>;
  Ticks?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  To?: Maybe<Scalars['String']['output']>;
  ToolPanel?: Maybe<Scalars['String']['output']>;
  Tooltips?: Maybe<Scalars['String']['output']>;
  Top?: Maybe<Scalars['String']['output']>;
  UngroupBy?: Maybe<Scalars['String']['output']>;
  ValueAggregation?: Maybe<Scalars['String']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  XOffset?: Maybe<Scalars['String']['output']>;
  XRotation?: Maybe<Scalars['String']['output']>;
  XYChart?: Maybe<Scalars['String']['output']>;
  YOffset?: Maybe<Scalars['String']['output']>;
  YRotation?: Maybe<Scalars['String']['output']>;
};

export type ListBindings = {
  __typename?: 'ListBindings';
  ClearGridState?: Maybe<Scalars['String']['output']>;
  Columns?: Maybe<Scalars['String']['output']>;
  EditMode?: Maybe<Scalars['String']['output']>;
  ListColumns?: Maybe<Scalars['String']['output']>;
  Loading?: Maybe<Scalars['String']['output']>;
  PageInfo?: Maybe<Scalars['String']['output']>;
  QuickFilterText?: Maybe<Scalars['String']['output']>;
  Refresh?: Maybe<Scalars['String']['output']>;
  RowModesModel?: Maybe<Scalars['String']['output']>;
  Rows?: Maybe<Scalars['String']['output']>;
  RowsPerPage?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type ListClearAllButton = {
  __typename?: 'ListClearAllButton';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<ListClearAllButtonBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  StartIcon?: Maybe<Icon>;
  Style?: Maybe<StyleProperties>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type ListClearAllButtonBindings = {
  __typename?: 'ListClearAllButtonBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type ListColumn = IDesignable & IEditable & IField & {
  __typename?: 'ListColumn';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  AggFunc?: Maybe<Scalars['String']['output']>;
  AutoSize?: Maybe<Scalars['Boolean']['output']>;
  Bindings?: Maybe<ListColumnBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  CellLayout?: Maybe<LayoutItem>;
  CellRendererItems?: Maybe<Array<Maybe<LayoutItem>>>;
  ChipClasses?: Maybe<Scalars['ClassSet']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  ColSpan?: Maybe<Scalars['String']['output']>;
  ColumnFixedWidth?: Maybe<Scalars['Int']['output']>;
  ColumnMinimumWidth?: Maybe<Scalars['Int']['output']>;
  DataType?: Maybe<Scalars['String']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DisableFiltering?: Maybe<Scalars['Boolean']['output']>;
  DisableGrouping?: Maybe<Scalars['Boolean']['output']>;
  DisableSorting?: Maybe<Scalars['Boolean']['output']>;
  DisplayAsChip?: Maybe<Scalars['Boolean']['output']>;
  Editable?: Maybe<Scalars['Boolean']['output']>;
  FieldType?: Maybe<FieldType>;
  FilterParams?: Maybe<FilterParams>;
  Flex?: Maybe<Scalars['Float']['output']>;
  FormatName?: Maybe<Scalars['FormatName']['output']>;
  HeaderName?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  IsPrimaryKey?: Maybe<Scalars['Boolean']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Pinned?: Maybe<Scalars['String']['output']>;
  Pivot?: Maybe<Scalars['Boolean']['output']>;
  Resizable?: Maybe<Scalars['Boolean']['output']>;
  RowGroup?: Maybe<Scalars['Boolean']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  Sort?: Maybe<Scalars['String']['output']>;
  SortingOrder?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Style?: Maybe<StyleProperties>;
  SuppressHeaderMenu?: Maybe<Scalars['Boolean']['output']>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  __typename?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type ListColumnBindings = {
  __typename?: 'ListColumnBindings';
  RowGroup?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type ListColumnStyleConfigurations = {
  __typename?: 'ListColumnStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ListExportButton = {
  __typename?: 'ListExportButton';
  Bindings?: Maybe<ListExportButtonBindings>;
  CSVDelimiter?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  EnableCSV?: Maybe<Scalars['Boolean']['output']>;
  EnableExcel?: Maybe<Scalars['Boolean']['output']>;
  EnablePrint?: Maybe<Scalars['Boolean']['output']>;
  ExcelSheetName?: Maybe<Scalars['String']['output']>;
  FileName?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  PrintHideFooter?: Maybe<Scalars['Boolean']['output']>;
  PrintHideToolbar?: Maybe<Scalars['Boolean']['output']>;
  Style?: Maybe<StyleProperties>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type ListExportButtonBindings = {
  __typename?: 'ListExportButtonBindings';
  Visible?: Maybe<Scalars['String']['output']>;
};

export type ListPageInfo = {
  __typename?: 'ListPageInfo';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
};

export type ListQuickFilter = {
  __typename?: 'ListQuickFilter';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Adornment?: Maybe<Adornment>;
  Bindings?: Maybe<ListQuickFilterBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  /** Placeholder text shown in the editor when no content is present */
  PlaceholderText?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  onInput?: Maybe<Scalars['EventData']['output']>;
};

export type ListQuickFilterBindings = {
  __typename?: 'ListQuickFilterBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type ListStyleConfigurations = {
  __typename?: 'ListStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ListToolbar = {
  __typename?: 'ListToolbar';
  Items?: Maybe<Array<Button>>;
  ShowExport?: Maybe<Scalars['Boolean']['output']>;
};

export type LocalizedAppInfo = {
  __typename?: 'LocalizedAppInfo';
  Description: Scalars['String']['output'];
  Keywords: Array<Maybe<Scalars['String']['output']>>;
  Language: Language;
  Name: Scalars['String']['output'];
};

export type Login = {
  __typename?: 'Login';
  Bindings?: Maybe<LoginBindings>;
  CommandResult?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  Password?: Maybe<Scalars['String']['output']>;
  SuccessRedirect?: Maybe<Scalars['String']['output']>;
};

export type LoginBindings = {
  __typename?: 'LoginBindings';
  Email?: Maybe<Scalars['String']['output']>;
  Password?: Maybe<Scalars['String']['output']>;
};

export type LoginPage = {
  __typename?: 'LoginPage';
  AllowFaceId: Scalars['Boolean']['output'];
  AllowRememberMe: Scalars['Boolean']['output'];
  BackgroundImage: Image;
  BiometricsEnabled: Scalars['Boolean']['output'];
  ForgotPasswordLinkText?: Maybe<Scalars['String']['output']>;
  LoginButtonImage: Image;
  LoginButtonText?: Maybe<Scalars['String']['output']>;
  Logo: Image;
  PasswordLabel?: Maybe<Scalars['String']['output']>;
  PasswordPlaceholder?: Maybe<Scalars['String']['output']>;
  ShowForgotPasswordLink: Scalars['Boolean']['output'];
  ShowSignupLink: Scalars['Boolean']['output'];
  SignUpLink?: Maybe<Scalars['String']['output']>;
  SocialLoginButtons?: Maybe<Array<Maybe<SocialLoginButton>>>;
  Subtitle?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  UsernameLabel?: Maybe<Scalars['String']['output']>;
  UsernamePlaceholder?: Maybe<Scalars['String']['output']>;
};

export type Logout = {
  __typename?: 'Logout';
  CommandResult?: Maybe<Scalars['String']['output']>;
};

export type Mapping = {
  __typename?: 'Mapping';
  Source?: Maybe<Scalars['SingleMapping']['output']>;
  Target?: Maybe<Scalars['SingleMapping']['output']>;
};

export type MarkFrequency = {
  __typename?: 'MarkFrequency';
  Label: Scalars['Float']['output'];
  Value: Scalars['Float']['output'];
};

export type Markdown = {
  __typename?: 'Markdown';
  Bindings?: Maybe<MarkdownBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Id: Scalars['ID']['output'];
  Placeholder?: Maybe<Scalars['String']['output']>;
  ShowTypingIndicator?: Maybe<Scalars['Boolean']['output']>;
  StreamUrl?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  TypingIndicatorIcon?: Maybe<Icon>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkdownBindings = {
  __typename?: 'MarkdownBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  StreamUrl?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

/** A menu is a collection of Features that can be assigned to a role/user */
export type Menu = {
  __typename?: 'Menu';
  Bindings?: Maybe<MenuBindings>;
  ButtonStyle?: Maybe<StyleProperties>;
  Category?: Maybe<Scalars['String']['output']>;
  ContextId?: Maybe<Scalars['String']['output']>;
  Data?: Maybe<Scalars['SampleData']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Features: Array<Maybe<Feature>>;
  Id?: Maybe<Scalars['ID']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  LandingPageUrl: Scalars['String']['output'];
  Loading?: Maybe<Scalars['Boolean']['output']>;
  /** Menu name.  Note that it must be unique */
  Name: Scalars['String']['output'];
  SerialNumber?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  SubCategory?: Maybe<Scalars['String']['output']>;
};

export type MenuBindings = {
  __typename?: 'MenuBindings';
  ButtonStyle?: Maybe<Scalars['String']['output']>;
  Data?: Maybe<Scalars['String']['output']>;
  Loading?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
};

export type ModalPopupEditor = {
  __typename?: 'ModalPopupEditor';
  Bindings?: Maybe<ModalPopupEditorBindings>;
  Id: Scalars['ID']['output'];
  Name: Scalars['String']['output'];
};

export type ModalPopupEditorBindings = {
  __typename?: 'ModalPopupEditorBindings';
  Value?: Maybe<Scalars['String']['output']>;
};

export type Model = {
  __typename?: 'Model';
  Entities?: Maybe<Array<Maybe<Entity>>>;
  Id: Scalars['ID']['output'];
  Name: Scalars['String']['output'];
};

export type MultiFilter = {
  __typename?: 'MultiFilter';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<MultiFilterBindings>;
  ButtonClasses?: Maybe<Scalars['ClassSet']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Data?: Maybe<Scalars['SampleData']['output']>;
  Fields?: Maybe<Array<Maybe<IField>>>;
  Id: Scalars['ID']['output'];
  Items?: Maybe<Array<LayoutItem>>;
  Label?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

export type MultiFilterBindings = {
  __typename?: 'MultiFilterBindings';
  Data?: Maybe<Scalars['String']['output']>;
  Fields?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type MultiSelect = IDesignable & IEditable & IField & ISelectFromList & {
  __typename?: 'MultiSelect';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Adornment?: Maybe<Adornment>;
  Analytics?: Maybe<Analytics>;
  /** If true , the portion of the selected suggestion that has not been typed by the user, known as the completion string, appears inline after the input cursor in the textbox. The inline completion string is visually highlighted and has a selected state. */
  AutoComplete?: Maybe<Scalars['Boolean']['output']>;
  AutoHighlight?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the selected option becomes the value of the input when the Autocomplete loses focus unless the user chooses a different option or changes the character string in the input. When using freeSolo mode, the typed value will be the input value if the Autocomplete loses focus without highlighting an option. */
  AutoSelect?: Maybe<Scalars['Boolean']['output']>;
  /** If enabled, the control selects the first option available in the list when loading */
  AutoselectFirstOption?: Maybe<Scalars['Boolean']['output']>;
  Bindings?: Maybe<MultiSelectBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  /** Control if the input should be blurred when an option is selected: - false the input is not blurred. - true the input is always blurred. - touch the input is blurred after a touch event. - mouse the input is blurred after a mouse event. */
  BlurOnSelect?: Maybe<Scalars['String']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  CaptionClasses?: Maybe<Scalars['ClassSet']['output']>;
  CaptionTemplate?: Maybe<Scalars['String']['output']>;
  CheckboxMultiSelect?: Maybe<Scalars['Boolean']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  /** If set to true, the value is cleared inmediately after selecting an option */
  ClearAfterSelect?: Maybe<Scalars['Boolean']['output']>;
  /** Clear after the following interval in milliseconds.  This takes efect if ClearAfterSelect=true */
  ClearInterval?: Maybe<Scalars['Int']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  /** Disables the ability to clear the selected value */
  DisableClearable?: Maybe<Scalars['Boolean']['output']>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Editable?: Maybe<Scalars['Boolean']['output']>;
  FieldType?: Maybe<FieldType>;
  Format?: Maybe<FieldFormat>;
  /** Support free entry */
  FreeSolo?: Maybe<Scalars['Boolean']['output']>;
  GroupBy?: Maybe<Scalars['String']['output']>;
  GroupClasses?: Maybe<Scalars['ClassSet']['output']>;
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  LabelClasses?: Maybe<Scalars['ClassSet']['output']>;
  LabelExpression?: Maybe<Scalars['String']['output']>;
  MultiSelectFilter?: Maybe<FilterCriteria>;
  MultiSelectPossibleValues?: Maybe<Array<Maybe<Scalars['MultiSelectObject']['output']>>>;
  /** Support multiple selection */
  Multiple?: Maybe<Scalars['Boolean']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NoOptionsText?: Maybe<Scalars['String']['output']>;
  /** Array of options. */
  Options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The OptionsLabelExpression is used to display the options in the dropdown */
  OptionsLabelExpression?: Maybe<Scalars['String']['output']>;
  /** The short hint displayed in the input before the user enters a value. */
  Placeholder?: Maybe<Scalars['String']['output']>;
  SearchFilter?: Maybe<Scalars['String']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  ServiceList?: Maybe<ServiceList>;
  Style?: Maybe<StyleProperties>;
  UseGroupBy?: Maybe<Scalars['Boolean']['output']>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
  Value?: Maybe<Scalars['String']['output']>;
  ValueExpression?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type MultiSelectBindings = {
  __typename?: 'MultiSelectBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  ClearAfterSelect?: Maybe<Scalars['String']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  GroupBy?: Maybe<Scalars['String']['output']>;
  Icon?: Maybe<Scalars['String']['output']>;
  MultiSelectPossibleValues?: Maybe<Scalars['String']['output']>;
  NoOptionsText?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  SearchFilter?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  UseGroupBy?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type MultiSelectStyleConfigurations = {
  __typename?: 'MultiSelectStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalChildren?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NativeApplication = {
  __typename?: 'NativeApplication';
  Availability: Array<Maybe<Country>>;
  BiometricEnabled: Scalars['Boolean']['output'];
  BundleId: Scalars['String']['output'];
  Category: AppCategory;
  Description: Scalars['String']['output'];
  Icon: Image;
  Id: Scalars['ID']['output'];
  Keywords: Array<Maybe<Scalars['String']['output']>>;
  LastUpdatedDate?: Maybe<Scalars['Date']['output']>;
  LocalizedInfo?: Maybe<Array<Maybe<LocalizedAppInfo>>>;
  Name: Scalars['String']['output'];
  Price?: Maybe<Scalars['Float']['output']>;
  PrimaryLanguage: Language;
  PrivacyPolicyURL?: Maybe<Scalars['String']['output']>;
  ReleaseDate?: Maybe<Scalars['Date']['output']>;
  Screenshots: Array<Maybe<Image>>;
  SubCategory?: Maybe<AppSubCategory>;
  SupportURL: Scalars['String']['output'];
  Version: Scalars['String']['output'];
};

export type NumberFormat = {
  __typename?: 'NumberFormat';
  Currency?: Maybe<Scalars['String']['output']>;
  Locale?: Maybe<Scalars['String']['output']>;
  MaximumFractionDigits?: Maybe<Scalars['Int']['output']>;
  MinimumFractionDigits?: Maybe<Scalars['Int']['output']>;
  Prefix?: Maybe<Scalars['String']['output']>;
  SignDisplay?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Suffix?: Maybe<Scalars['String']['output']>;
};

export type OpenContextMenu = {
  __typename?: 'OpenContextMenu';
  Bindings?: Maybe<OpenContextMenuBindings>;
  CommandResult?: Maybe<Scalars['String']['output']>;
  Component?: Maybe<Scalars['ComponentId']['output']>;
  ContextMenuId?: Maybe<Scalars['String']['output']>;
  Form?: Maybe<Scalars['FormId']['output']>;
};

export type OpenContextMenuBindings = {
  __typename?: 'OpenContextMenuBindings';
  Component?: Maybe<Scalars['String']['output']>;
  ContextMenuId?: Maybe<Scalars['String']['output']>;
};

export type OpenModalPopup = {
  __typename?: 'OpenModalPopup';
  Component?: Maybe<Scalars['ComponentId']['output']>;
  Message: Scalars['String']['output'];
  ModalPopupId?: Maybe<Scalars['String']['output']>;
  ShowCancelButton?: Maybe<Scalars['Boolean']['output']>;
  ShowCloseButton?: Maybe<Scalars['Boolean']['output']>;
  ShowOkButton?: Maybe<Scalars['Boolean']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type Overlay = {
  __typename?: 'Overlay';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<OverlayBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Draggable?: Maybe<Scalars['Boolean']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  Items?: Maybe<Array<LayoutItem>>;
  Name?: Maybe<Scalars['String']['output']>;
  Position?: Maybe<Position>;
  Style?: Maybe<StyleProperties>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type OverlayBindings = {
  __typename?: 'OverlayBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Position?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type Page = IDesignable & {
  __typename?: 'Page';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  BackgroundColor?: Maybe<Scalars['String']['output']>;
  Bindings?: Maybe<PageBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  Category?: Maybe<Scalars['String']['output']>;
  /** The Ids of components that are referenced by this page */
  ComponentReferenceIds?: Maybe<Array<Scalars['String']['output']>>;
  Context?: Maybe<Array<Maybe<IField>>>;
  Description?: Maybe<Scalars['String']['output']>;
  Icon?: Maybe<Icon>;
  Id?: Maybe<Scalars['ID']['output']>;
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  Items?: Maybe<Array<LayoutItem>>;
  Label?: Maybe<Scalars['String']['output']>;
  Layout?: Maybe<Layout>;
  ModalPopups?: Maybe<Array<Maybe<Dialog>>>;
  /** Name is the business key and must be unique */
  Name: Scalars['String']['output'];
  PageTemplate?: Maybe<PageTemplate>;
  /** Note that this takes the form a slug, e.g. blog/how-to-grow-tomatoes or open-new-account */
  PageUrl?: Maybe<Scalars['String']['output']>;
  SampleData?: Maybe<Scalars['SampleData']['output']>;
  SerialNumber?: Maybe<Scalars['String']['output']>;
  /** The Ids of services that are referenced by this page */
  ServiceReferenceIds?: Maybe<Array<Scalars['String']['output']>>;
  Services?: Maybe<Array<Maybe<Service>>>;
  State?: Maybe<Scalars['State']['output']>;
  Style?: Maybe<StyleProperties>;
  Styles?: Maybe<Scalars['StylePropertiesDictionary']['output']>;
  SubCategory?: Maybe<Scalars['String']['output']>;
  Theme?: Maybe<Scalars['String']['output']>;
  UseSampleDataToInitializeState?: Maybe<Scalars['Boolean']['output']>;
};

export type PageBindings = {
  __typename?: 'PageBindings';
  Disabled?: Maybe<Scalars['String']['output']>;
  InDesignMode?: Maybe<Scalars['String']['output']>;
  Loading?: Maybe<Scalars['String']['output']>;
  Styles?: Maybe<Scalars['String']['output']>;
  Theme?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type PageTemplate = {
  __typename?: 'PageTemplate';
  BottomAppBar?: Maybe<AppBar>;
  BottomAppBarHeight?: Maybe<Scalars['ResponsiveProperty']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Footer?: Maybe<Drawer>;
  FooterHeight?: Maybe<Scalars['ResponsiveProperty']['output']>;
  Header?: Maybe<Drawer>;
  HeaderHeight?: Maybe<Scalars['ResponsiveProperty']['output']>;
  Id: Scalars['ID']['output'];
  LeftSidebar?: Maybe<Drawer>;
  LeftSidebarWidth?: Maybe<Scalars['ResponsiveProperty']['output']>;
  Name: Scalars['String']['output'];
  RightSidebar?: Maybe<Drawer>;
  RightSidebarWidth?: Maybe<Scalars['ResponsiveProperty']['output']>;
  TopAppBar?: Maybe<AppBar>;
  TopAppBarHeight?: Maybe<Scalars['ResponsiveProperty']['output']>;
};

export type Paper = {
  __typename?: 'Paper';
  Elevation?: Maybe<Scalars['Int']['output']>;
  Square?: Maybe<Scalars['Boolean']['output']>;
  Style?: Maybe<StyleProperties>;
  Variant?: Maybe<Scalars['String']['output']>;
};

export enum ParameterType {
  Boolean = 'Boolean',
  Decimal = 'Decimal',
  Integer = 'Integer',
  Mapping = 'Mapping',
  String = 'String'
}

export type PasteFromClipboard = {
  __typename?: 'PasteFromClipboard';
  Bindings?: Maybe<Scalars['BindingsDictionary']['output']>;
  Options?: Maybe<Scalars['TransformMethodOptions']['output']>;
  TransformMethod?: Maybe<Scalars['String']['output']>;
};

export type Position = {
  __typename?: 'Position';
  bottom?: Maybe<Scalars['Float']['output']>;
  left?: Maybe<Scalars['Float']['output']>;
  right?: Maybe<Scalars['Float']['output']>;
  top?: Maybe<Scalars['Float']['output']>;
};

export type PropertiesEditor = IApplication & {
  __typename?: 'PropertiesEditor';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  AddAncillaryButtons?: Maybe<Scalars['Boolean']['output']>;
  Bindings?: Maybe<PropertiesEditorBindings>;
  Data?: Maybe<Scalars['SampleData']['output']>;
  DefaultTypeName?: Maybe<Scalars['String']['output']>;
  Enabled?: Maybe<Scalars['Boolean']['output']>;
  FieldTypes?: Maybe<Scalars['SampleData']['output']>;
  FieldWidth?: Maybe<Scalars['String']['output']>;
  FieldsReadOnly?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The unqique Id of the form within the properties editor */
  FormId?: Maybe<Scalars['String']['output']>;
  /** The items (typically buttons) that are displayed in the header of the properties editor */
  HeaderItems?: Maybe<Array<LayoutItem>>;
  HideIndividualBindings?: Maybe<Scalars['Boolean']['output']>;
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  IgnoreLocalState?: Maybe<Scalars['Boolean']['output']>;
  LabelWidth?: Maybe<Scalars['String']['output']>;
  Resizable?: Maybe<ResizableProperties>;
  SearchPropInput?: Maybe<Scalars['String']['output']>;
  Service?: Maybe<Scalars['String']['output']>;
  ShowBindingField?: Maybe<Scalars['Boolean']['output']>;
  Style?: Maybe<StyleProperties>;
  ToggleExpanded?: Maybe<Scalars['String']['output']>;
  Typename?: Maybe<Scalars['String']['output']>;
  UniqueName?: Maybe<Scalars['String']['output']>;
  UseFieldGroups?: Maybe<Scalars['Boolean']['output']>;
  ViewMode?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  WrapperLayoutType?: Maybe<Scalars['String']['output']>;
  getData?: Maybe<Scalars['Method']['output']>;
  isSubComponent?: Maybe<Scalars['Boolean']['output']>;
};

export type PropertiesEditorBindings = {
  __typename?: 'PropertiesEditorBindings';
  Data?: Maybe<Scalars['String']['output']>;
  Enabled?: Maybe<Scalars['String']['output']>;
  FieldTypes?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type ProportionalBar = {
  __typename?: 'ProportionalBar';
  Bindings?: Maybe<ProportionalBarBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Colors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DataSeparator?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  Style?: Maybe<StyleProperties>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  getData?: Maybe<Scalars['Method']['output']>;
};

export type ProportionalBarBindings = {
  __typename?: 'ProportionalBarBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Data?: Maybe<Scalars['String']['output']>;
  Rows?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  getComponentLibrary?: Maybe<ComponentLibrary>;
  getDialog?: Maybe<Dialog>;
  getMenu?: Maybe<Menu>;
  getPage?: Maybe<Page>;
  getSiteConfiguration?: Maybe<SiteConfiguration>;
  queryComponentLibrary?: Maybe<Array<ComponentLibrary>>;
  queryDialog?: Maybe<Array<Dialog>>;
  queryMenu?: Maybe<Array<Menu>>;
  queryPage?: Maybe<Array<Page>>;
  querySiteConfiguration?: Maybe<Array<SiteConfiguration>>;
};


export type QueryGetComponentLibraryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetDialogArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMenuArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetSiteConfigurationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RadioGroup = IDesignable & IEditable & IField & ISelectFromList & {
  __typename?: 'RadioGroup';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Analytics?: Maybe<Analytics>;
  Bindings?: Maybe<RadioGroupBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  Editable?: Maybe<Scalars['Boolean']['output']>;
  FieldType?: Maybe<FieldType>;
  Format?: Maybe<FieldFormat>;
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  LabelExpression?: Maybe<Scalars['String']['output']>;
  MultiSelectFilter?: Maybe<FilterCriteria>;
  MultiSelectPossibleValues?: Maybe<Array<Maybe<Scalars['MultiSelectObject']['output']>>>;
  Name?: Maybe<Scalars['String']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  Style?: Maybe<StyleProperties>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
  Value?: Maybe<Scalars['String']['output']>;
  ValueExpression?: Maybe<Scalars['String']['output']>;
  ValueType?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type RadioGroupBindings = {
  __typename?: 'RadioGroupBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  MultiSelectPossibleValues?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type Reference = {
  __typename?: 'Reference';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<ReferenceBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Id: Scalars['ID']['output'];
  Inputs?: Maybe<Scalars['InputBinding']['output']>;
  ReferenceId: Scalars['String']['output'];
  ReferenceSource: Scalars['String']['output'];
  ReferenceType: Scalars['String']['output'];
  Style?: Maybe<StyleProperties>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type ReferenceBindings = {
  __typename?: 'ReferenceBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  ReferenceId?: Maybe<Scalars['String']['output']>;
  ReferenceSource?: Maybe<Scalars['String']['output']>;
  ReferenceType?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type ReferenceStyleConfigurations = {
  __typename?: 'ReferenceStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
};

export type ReloadPage = {
  __typename?: 'ReloadPage';
  CommandResult?: Maybe<Scalars['String']['output']>;
};

export type Repeater = IApplication & IDesignable & {
  __typename?: 'Repeater';
  /** Is set to true, the user can add items to the tree */
  AllowAdd?: Maybe<Scalars['Boolean']['output']>;
  /** Is set to true, the elements in the tree can be re-ordered (up&down) */
  AllowDelete?: Maybe<Scalars['Boolean']['output']>;
  /** Is set to true, the elements in the tree can be re-ordered (up&down) */
  AllowReordering?: Maybe<Scalars['Boolean']['output']>;
  Bindings?: Maybe<RepeaterBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  CollapseIcon?: Maybe<Icon>;
  /** Content is deprecated in favor of Items */
  Content?: Maybe<Form>;
  Details?: Maybe<Form>;
  /** If true, it removes the margin between two expanded accordion items and the increase of height. */
  DisableGutters?: Maybe<Scalars['Boolean']['output']>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  ExcludeFromForm?: Maybe<Scalars['Boolean']['output']>;
  ExpandIcon?: Maybe<Icon>;
  Expanded?: Maybe<Scalars['Boolean']['output']>;
  Fields: Array<Scalars['String']['output']>;
  /** A container that has in it all the header cells */
  Header?: Maybe<LayoutItem>;
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  Items?: Maybe<Array<LayoutItem>>;
  Layout?: Maybe<Layout>;
  Rows?: Maybe<Scalars['SampleData']['output']>;
  /** Scroll to last item as it appears */
  ScrollToLast?: Maybe<Scalars['Boolean']['output']>;
  Style?: Maybe<StyleProperties>;
  Title?: Maybe<LayoutItem>;
  Typename?: Maybe<Scalars['String']['output']>;
  UseVirtualization?: Maybe<Scalars['Boolean']['output']>;
  /**
   * List displays items vertically.
   * Grid displays items horizontally, as cards.
   * If not specified it defualts to Grid
   */
  Variant?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  VituralizationHeight?: Maybe<Scalars['String']['output']>;
  getData?: Maybe<Scalars['Method']['output']>;
};

export type RepeaterBindings = {
  __typename?: 'RepeaterBindings';
  AllowAdd?: Maybe<Scalars['String']['output']>;
  AllowDelete?: Maybe<Scalars['String']['output']>;
  AllowReordering?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  Loading?: Maybe<Scalars['String']['output']>;
  Rows?: Maybe<Scalars['String']['output']>;
  ScrollToLast?: Maybe<Scalars['String']['output']>;
  SelectedItem?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  UseVirtualization?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
  VituralizationHeight?: Maybe<Scalars['String']['output']>;
};

export type RepeaterStyleConfigurations = {
  __typename?: 'RepeaterStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ResizableProperties = {
  __typename?: 'ResizableProperties';
  direction?: Maybe<Scalars['String']['output']>;
  dragBorderColor?: Maybe<Scalars['String']['output']>;
  maxHeight?: Maybe<Scalars['Float']['output']>;
  maxWidth?: Maybe<Scalars['Float']['output']>;
  minHeight?: Maybe<Scalars['Float']['output']>;
  minWidth?: Maybe<Scalars['Float']['output']>;
  startHeight?: Maybe<Scalars['String']['output']>;
  startWidth?: Maybe<Scalars['String']['output']>;
};

export type ResolutionButtons = IDesignable & IEditable & IField & {
  __typename?: 'ResolutionButtons';
  Bindings?: Maybe<ResolutionButtonsBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  Editable?: Maybe<Scalars['Boolean']['output']>;
  FieldType?: Maybe<FieldType>;
  Format?: Maybe<FieldFormat>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  InitialState?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  Style?: Maybe<StyleProperties>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type ResolutionButtonsBindings = {
  __typename?: 'ResolutionButtonsBindings';
  SetHeight?: Maybe<Scalars['String']['output']>;
  SetWidth?: Maybe<Scalars['String']['output']>;
};

export type ResponsivePropertyObject = {
  __typename?: 'ResponsivePropertyObject';
  lg?: Maybe<Scalars['String']['output']>;
  md?: Maybe<Scalars['String']['output']>;
  sm?: Maybe<Scalars['String']['output']>;
  xl?: Maybe<Scalars['String']['output']>;
  xs?: Maybe<Scalars['String']['output']>;
};

export type ReviewDialog = {
  __typename?: 'ReviewDialog';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<ReviewDialogBindings>;
  Data?: Maybe<ReviewDialogData>;
  Enabled?: Maybe<Scalars['Boolean']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  Item?: Maybe<LayoutItem>;
  ShowComments?: Maybe<Scalars['Boolean']['output']>;
  ShowInfo?: Maybe<Scalars['Boolean']['output']>;
  ShowReaction?: Maybe<Scalars['Boolean']['output']>;
  ShowTextNotes?: Maybe<Scalars['Boolean']['output']>;
  ShowVoiceNotes?: Maybe<Scalars['Boolean']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type ReviewDialogBindings = {
  __typename?: 'ReviewDialogBindings';
  Data?: Maybe<Scalars['String']['output']>;
  Enabled?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type ReviewDialogData = {
  __typename?: 'ReviewDialogData';
  Item?: Maybe<LayoutItem>;
  NoteCount?: Maybe<Scalars['Int']['output']>;
  Notes?: Maybe<Array<Maybe<ReviewNote>>>;
  Reaction?: Maybe<Scalars['String']['output']>;
  Reviewer?: Maybe<Scalars['String']['output']>;
};

export type ReviewNote = {
  __typename?: 'ReviewNote';
  /** A voice note left by the reviewer */
  AudioNote?: Maybe<Scalars['Audio']['output']>;
  /** The person who made the note */
  Author: Scalars['String']['output'];
  /** Excerpts contains the highlights of this note, usually generated by AI */
  Excerpts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Id: Scalars['String']['output'];
  NoteType: Scalars['String']['output'];
  /** For support of nested notes.  Null if it does not have a parent */
  ParentId?: Maybe<Scalars['String']['output']>;
  ReviewDateTime: Scalars['DateTime']['output'];
  /** Capture the screen and mouse movement at the time of the review */
  ScreenRecording?: Maybe<Scalars['Video']['output']>;
  /** Capture the screen at the time of the review */
  Screenshot?: Maybe<Image>;
  /** General sentiment of the review, usually generated by AI */
  Sentiment?: Maybe<Scalars['String']['output']>;
  /** Summary of the review, usually generated by AI */
  Summary?: Maybe<Scalars['String']['output']>;
  /** Text contains the user-entered text by the reviewer.  In the case of audio & video notes, it contains the generated trasncript of the voice. */
  Text?: Maybe<Scalars['String']['output']>;
  /** A video note left by the reviewer */
  VideoNote?: Maybe<Scalars['Video']['output']>;
};

export type RichTextEditor = {
  __typename?: 'RichTextEditor';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<RichTextEditorBindings>;
  /** Enables or disables the character counter */
  CharCounterCount?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum character limit for the editor content */
  CharCounterMax?: Maybe<Scalars['Int']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  /** This is the context for the autocomplete that appears in the editor */
  ContextAutocomplete?: Maybe<ContextAutocomplete>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  /** List of allowed file types for upload, e.g., ['pdf', 'docx'] */
  FileAllowedTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum file size for uploads, in bytes */
  FileMaxSize?: Maybe<Scalars['Int']['output']>;
  /** Defines the height of the editor */
  Height?: Maybe<Scalars['Int']['output']>;
  /** Defines the maximum height of the editor */
  HeightMax?: Maybe<Scalars['Int']['output']>;
  /** Defines the minimum height of the editor */
  HeightMin?: Maybe<Scalars['Int']['output']>;
  Id: Scalars['ID']['output'];
  /** List of allowed image types for upload, e.g., ['jpeg', 'png'] */
  ImageAllowedTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Default width of images inserted into the editor */
  ImageDefaultWidth?: Maybe<Scalars['Int']['output']>;
  /** Buttons shown for inserting images into the editor */
  ImageInsertButtons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Maximum file size for image uploads, in bytes */
  ImageMaxSize?: Maybe<Scalars['Int']['output']>;
  /** Buttons shown for editing links in the editor */
  LinkEditButtons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Buttons shown for inserting links into the editor */
  LinkInsertButtons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Scalars['String']['output']>;
  /** Placeholder text shown in the editor when no content is present */
  PlaceholderText?: Maybe<Scalars['String']['output']>;
  /** Quick insert buttons for media, such as images and videos */
  QuickInsertButtons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Enables or disables the quick insert functionality */
  QuickInsertEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Tags that can be used for quick insert */
  QuickInsertTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  Style?: Maybe<StyleProperties>;
  SupportTributes?: Maybe<Scalars['Boolean']['output']>;
  /** List of buttons to be shown on the toolbar */
  ToolbarButtons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Defines whether the toolbar is inline (appears only when the text is selected) */
  ToolbarInline?: Maybe<Scalars['Boolean']['output']>;
  TributeDisplayName?: Maybe<Scalars['String']['output']>;
  TributeKey?: Maybe<Scalars['String']['output']>;
  TributeRows?: Maybe<Scalars['SampleData']['output']>;
  TributeSearchString?: Maybe<Scalars['SampleData']['output']>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
  Value?: Maybe<Scalars['String']['output']>;
  /** List of allowed video types for upload, e.g., ['mp4', 'webm'] */
  VideoAllowedTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Default display of videos inserted into the editor */
  VideoDefaultDisplay?: Maybe<Scalars['String']['output']>;
  /** Default width of videos inserted into the editor */
  VideoDefaultWidth?: Maybe<Scalars['Int']['output']>;
  /** Buttons shown for inserting videos into the editor */
  VideoInsertButtons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Enables or disables the video upload functionality */
  VideoUpload?: Maybe<Scalars['Boolean']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type RichTextEditorBindings = {
  __typename?: 'RichTextEditorBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  TributeRows?: Maybe<Scalars['String']['output']>;
  TributeSearchString?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type RichTextEditorStyleConfigurations = {
  __typename?: 'RichTextEditorStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
};

export type RichTreeList = {
  __typename?: 'RichTreeList';
  AllowAdd?: Maybe<Scalars['Boolean']['output']>;
  AllowDelete?: Maybe<Scalars['Boolean']['output']>;
  AllowReordering?: Maybe<Scalars['Boolean']['output']>;
  Bindings?: Maybe<RichTreeListBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Id: Scalars['ID']['output'];
  Items?: Maybe<Array<Array<Scalars['String']['output']>>>;
  Loading?: Maybe<Scalars['Boolean']['output']>;
  Searchable?: Maybe<Scalars['Boolean']['output']>;
  Style?: Maybe<StyleProperties>;
};

export type RichTreeListBindings = {
  __typename?: 'RichTreeListBindings';
  AllowAdd?: Maybe<Scalars['String']['output']>;
  AllowDelete?: Maybe<Scalars['String']['output']>;
  AllowReordering?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  Items?: Maybe<Scalars['String']['output']>;
  Loading?: Maybe<Scalars['String']['output']>;
  SelectedItem?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type ScrollToTop = {
  __typename?: 'ScrollToTop';
  CommandResult?: Maybe<Scalars['String']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
};

export type SendEmail = {
  __typename?: 'SendEmail';
  Bindings?: Maybe<SendEmailBindings>;
  CC?: Maybe<Scalars['String']['output']>;
  CommandResult?: Maybe<Scalars['String']['output']>;
  Message?: Maybe<Scalars['String']['output']>;
  Subject?: Maybe<Scalars['String']['output']>;
  To?: Maybe<Scalars['String']['output']>;
};

export type SendEmailBindings = {
  __typename?: 'SendEmailBindings';
  CC?: Maybe<Scalars['String']['output']>;
  Message?: Maybe<Scalars['String']['output']>;
  Subject?: Maybe<Scalars['String']['output']>;
  To?: Maybe<Scalars['String']['output']>;
};

export type SendMessageToChild = {
  __typename?: 'SendMessageToChild';
  Bindings?: Maybe<SendMessageToChildBindings>;
  CommandResult?: Maybe<Scalars['String']['output']>;
  IFrame?: Maybe<Scalars['String']['output']>;
};

export type SendMessageToChildBindings = {
  __typename?: 'SendMessageToChildBindings';
  Actions?: Maybe<Scalars['String']['output']>;
  Source?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

export type SendMessageToParent = {
  __typename?: 'SendMessageToParent';
  Bindings?: Maybe<Scalars['BindingsDictionary']['output']>;
  CommandResult?: Maybe<Scalars['String']['output']>;
};

export type SendSms = {
  __typename?: 'SendSMS';
  Bindings?: Maybe<SendSmsBindings>;
  Message?: Maybe<Scalars['String']['output']>;
  Number?: Maybe<Scalars['String']['output']>;
};

export type SendSmsBindings = {
  __typename?: 'SendSMSBindings';
  Message?: Maybe<Scalars['String']['output']>;
  Number?: Maybe<Scalars['String']['output']>;
};

export type Service = {
  __typename?: 'Service';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<Scalars['ServiceBinding']['output']>;
  ConfigBindings?: Maybe<Scalars['ServiceBinding']['output']>;
  Debounce?: Maybe<Scalars['Int']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Fields?: Maybe<Array<Maybe<ServiceField>>>;
  Id?: Maybe<Scalars['ID']['output']>;
  IgnoreLocale?: Maybe<Scalars['Boolean']['output']>;
  IsReadOnlyReference?: Maybe<Scalars['Boolean']['output']>;
  Mappings?: Maybe<Mapping>;
  Name?: Maybe<Scalars['String']['output']>;
  Require?: Maybe<Scalars['String']['output']>;
  SampleData?: Maybe<Scalars['SampleData']['output']>;
  Service?: Maybe<Scalars['String']['output']>;
  Trigger?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
  UseSampleData?: Maybe<Scalars['Boolean']['output']>;
};

export type ServiceField = {
  __typename?: 'ServiceField';
  Bindings?: Maybe<ServiceFieldBindings>;
  Id?: Maybe<Scalars['ID']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Required?: Maybe<Scalars['Boolean']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['FieldValueExpression']['output']>;
};

export type ServiceFieldBindings = {
  __typename?: 'ServiceFieldBindings';
  DefaultValue?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};

export type ServiceLibrary = {
  __typename?: 'ServiceLibrary';
  Bindings?: Maybe<ServiceLibraryBindings>;
  Id: Scalars['ID']['output'];
  Name: Scalars['String']['output'];
  ServiceSets?: Maybe<Array<Maybe<ServiceSet>>>;
};

export type ServiceLibraryBindings = {
  __typename?: 'ServiceLibraryBindings';
  Enabled?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ServiceSets?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type ServiceList = {
  __typename?: 'ServiceList';
  Fields?: Maybe<Array<Maybe<IField>>>;
  Id?: Maybe<Scalars['ID']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Service?: Maybe<Scalars['String']['output']>;
};

export type ServiceSet = {
  __typename?: 'ServiceSet';
  Category?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  LibraryServices?: Maybe<Array<Maybe<Service>>>;
  Name: Scalars['String']['output'];
  SubCategory?: Maybe<Scalars['String']['output']>;
};

export type ServiceSnapshotOptions = {
  __typename?: 'ServiceSnapshotOptions';
  /** If true, a snapshot of selected fields is taken, this is typically business keys, such as Id */
  SelectedFieldsToSnap?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** If true, a snapshot of all fields is taken */
  SnapAllFields?: Maybe<Scalars['Boolean']['output']>;
  /** If true a full snapshot of the component state is taken */
  SnapServiceData?: Maybe<Scalars['Boolean']['output']>;
};

export type SetState = {
  __typename?: 'SetState';
  Bindings?: Maybe<Scalars['BindingsDictionary']['output']>;
};

export type Share = {
  __typename?: 'Share';
  Bindings?: Maybe<ShareBindings>;
  Component?: Maybe<Component>;
  File?: Maybe<Scalars['String']['output']>;
  NoteType?: Maybe<Scalars['String']['output']>;
  SelectedUsers?: Maybe<Array<Scalars['String']['output']>>;
  Text?: Maybe<Scalars['String']['output']>;
};

export type ShareBindings = {
  __typename?: 'ShareBindings';
  Component?: Maybe<Scalars['String']['output']>;
  File?: Maybe<Scalars['String']['output']>;
  NoteType?: Maybe<Scalars['String']['output']>;
  SelectedUsers?: Maybe<Scalars['String']['output']>;
  Text?: Maybe<Scalars['String']['output']>;
};

export type ShareDialog = {
  __typename?: 'ShareDialog';
  /** A voice note left by the sharer */
  AudioNote?: Maybe<Scalars['Audio']['output']>;
  Bindings?: Maybe<ShareDialogBindings>;
  ComponentInstanceId?: Maybe<Scalars['String']['output']>;
  ContextId?: Maybe<Scalars['String']['output']>;
  Data?: Maybe<ShareDialogData>;
  Enabled?: Maybe<Scalars['Boolean']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  NoteType?: Maybe<Scalars['String']['output']>;
  SelectedFieldsToSnap?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ShareSource?: Maybe<ShareSource>;
  /** The user ids to share this component with */
  SharedWith?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SnapAllFields?: Maybe<Scalars['Boolean']['output']>;
  SnapComponentData?: Maybe<Scalars['Boolean']['output']>;
  /** Text contains the user-entered text by the sharer.  In the case of audio & video notes, it contains the generated trasncript of the voice. */
  Text?: Maybe<Scalars['String']['output']>;
  /** A video note left by the sharer */
  VideoNote?: Maybe<Scalars['Video']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type ShareDialogBindings = {
  __typename?: 'ShareDialogBindings';
  Data?: Maybe<Scalars['String']['output']>;
  Enabled?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type ShareDialogData = {
  __typename?: 'ShareDialogData';
  ComponentInstanceId?: Maybe<Scalars['String']['output']>;
  Item?: Maybe<LayoutItem>;
};

export type ShareSource = {
  __typename?: 'ShareSource';
  Description?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
};

export type SharingInfo = {
  __typename?: 'SharingInfo';
  /** A voice note left by the sharer */
  AudioNote?: Maybe<Scalars['Audio']['output']>;
  NoteType?: Maybe<Scalars['String']['output']>;
  ServiceSnapshots?: Maybe<Array<Maybe<Service>>>;
  ShareSource?: Maybe<ShareSource>;
  /** The user who shared this component */
  SharedBy?: Maybe<Scalars['User']['output']>;
  /** The date/time when this component was shared */
  SharedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Text contains the user-entered text by the sharer.  In the case of audio & video notes, it contains the generated trasncript of the voice. */
  Text?: Maybe<Scalars['String']['output']>;
  /** A video note left by the sharer */
  VideoNote?: Maybe<Scalars['Video']['output']>;
};

export type SharingOptions = {
  __typename?: 'SharingOptions';
  /** If true, the component can be shared with other users */
  CanShare?: Maybe<Scalars['Boolean']['output']>;
  ServiceSnapshotOptions?: Maybe<Scalars['ServiceSnapshotOptionsDictionary']['output']>;
  /** Target component that will be used to display this share.  If null, it is itself */
  TargetComponentId?: Maybe<Scalars['String']['output']>;
};

export type ShowMessage = {
  __typename?: 'ShowMessage';
  Bindings?: Maybe<ShowMessageBindings>;
  Message: Scalars['String']['output'];
  ShowCancelButton?: Maybe<Scalars['Boolean']['output']>;
  ShowCloseButton?: Maybe<Scalars['Boolean']['output']>;
  ShowOkButton?: Maybe<Scalars['Boolean']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type ShowMessageBindings = {
  __typename?: 'ShowMessageBindings';
  Message?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type ShowToast = {
  __typename?: 'ShowToast';
  AutoHideDuration?: Maybe<Scalars['Int']['output']>;
  Message?: Maybe<Scalars['String']['output']>;
  Severity?: Maybe<Scalars['String']['output']>;
};

export type SimpleContainer = IDesignable & {
  __typename?: 'SimpleContainer';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<SimpleContainerBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Context?: Maybe<Array<Maybe<IField>>>;
  CreateForm?: Maybe<Scalars['Boolean']['output']>;
  Data?: Maybe<Scalars['SampleData']['output']>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Icon?: Maybe<Icon>;
  Id?: Maybe<Scalars['ID']['output']>;
  IgnoreLayout?: Maybe<Scalars['Boolean']['output']>;
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  InReviewMode?: Maybe<Scalars['Boolean']['output']>;
  IsReadOnlyReference?: Maybe<Scalars['Boolean']['output']>;
  Items?: Maybe<Array<LayoutItem>>;
  Layout?: Maybe<Layout>;
  Paper?: Maybe<Paper>;
  Resizable?: Maybe<ResizableProperties>;
  ReviewDialogOptions?: Maybe<ReviewDialog>;
  Style?: Maybe<StyleProperties>;
  Title?: Maybe<Scalars['String']['output']>;
  UniqueName?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type SimpleContainerBindings = {
  __typename?: 'SimpleContainerBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Data?: Maybe<Scalars['String']['output']>;
  Enabled?: Maybe<Scalars['String']['output']>;
  InReviewMode?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type SimpleContainerStyleConfigurations = {
  __typename?: 'SimpleContainerStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SiteConfiguration = {
  __typename?: 'SiteConfiguration';
  CustomLabels?: Maybe<Array<Maybe<CustomLabel>>>;
  DefaultCCY?: Maybe<Scalars['String']['output']>;
  DefaultLocale?: Maybe<Scalars['String']['output']>;
  DefaultTemplate?: Maybe<Scalars['String']['output']>;
  DefaultTemplatePublicView?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Formats?: Maybe<Scalars['Formats']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  IsDefault?: Maybe<Scalars['Boolean']['output']>;
  Locales?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Scalars['String']['output']>;
  NamedTemplates?: Maybe<Scalars['StringDictionary']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  Settings?: Maybe<SiteSettings>;
  ThemeName?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  URLMatches: Array<Maybe<Scalars['String']['output']>>;
};

export type SiteSettings = {
  __typename?: 'SiteSettings';
  HideListExportIcon?: Maybe<Scalars['Boolean']['output']>;
  ListAndChartLabels?: Maybe<ListAndChartLabels>;
  Logo?: Maybe<Scalars['String']['output']>;
  LogoClassName?: Maybe<Scalars['String']['output']>;
  MarketAppsThemeMode?: Maybe<Scalars['String']['output']>;
};

export type Slider = IDesignable & IEditable & IField & {
  __typename?: 'Slider';
  Analytics?: Maybe<Analytics>;
  /** The label of the slider. */
  AriaLabel?: Maybe<Scalars['String']['output']>;
  /** The id of the element containing a label for the slider. */
  AriaLabelledby?: Maybe<Scalars['String']['output']>;
  /** A string value that provides a user-friendly name for the current value of the slider. */
  AriaValuetext?: Maybe<Scalars['String']['output']>;
  Bindings?: Maybe<SliderBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  /** The color of the component. It supports both default and custom theme, which can be added as shown in the palette customization guide . */
  Color?: Maybe<Scalars['String']['output']>;
  DefaultValue?: Maybe<Scalars['Int']['output']>;
  /** If true , the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb. */
  DisableSwap?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the component is disabled. */
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Editable?: Maybe<Scalars['Boolean']['output']>;
  FieldType?: Maybe<FieldType>;
  Format?: Maybe<FieldFormat>;
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  /** Shorthand for marks, to set them and show labels at a give frequency. */
  MarkFrequency?: Maybe<MarkFrequency>;
  /** Marks indicate predetermined values to which the user can move the slider. If true the marks are spaced according the value of the step prop. If an array, it should contain objects with value and an optional label keys. */
  Marks?: Maybe<Scalars['SliderMarks']['output']>;
  /** The maximum allowed value of the slider. Should not be equal to min. */
  Max?: Maybe<Scalars['Float']['output']>;
  /** The minimum allowed value of the slider. Should not be equal to max. */
  Min?: Maybe<Scalars['Float']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  /** The component orientation. */
  Orientation?: Maybe<Scalars['String']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  /** The size of the slider. */
  Size?: Maybe<Scalars['String']['output']>;
  Step?: Maybe<Scalars['Float']['output']>;
  Style?: Maybe<StyleProperties>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
  ValueLabelDisplay?: Maybe<Scalars['String']['output']>;
  ValueLabelItem?: Maybe<LayoutItem>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type SliderBindings = {
  __typename?: 'SliderBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type SliderStyleConfigurations = {
  __typename?: 'SliderStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Slot = {
  __typename?: 'Slot';
  InputAdornment: Scalars['String']['output'];
  Position: Scalars['String']['output'];
};

export type Snackbar = {
  __typename?: 'Snackbar';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  AutoHideDuration?: Maybe<Scalars['Int']['output']>;
  /** Set to false if you do not want autohide.  By default it hides after 5 seconds AutoHideDuration milliseconds. */
  Autohide?: Maybe<Scalars['Boolean']['output']>;
  Bindings?: Maybe<SnackbarBindings>;
  Button?: Maybe<Button>;
  Id: Scalars['ID']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  Open?: Maybe<Scalars['Boolean']['output']>;
  Severity?: Maybe<Scalars['String']['output']>;
  ShowAnimation?: Maybe<Scalars['Boolean']['output']>;
};

export type SnackbarBindings = {
  __typename?: 'SnackbarBindings';
  Message?: Maybe<Scalars['String']['output']>;
  Open?: Maybe<Scalars['String']['output']>;
  Severity?: Maybe<Scalars['String']['output']>;
};

export type SocialLoginButton = {
  __typename?: 'SocialLoginButton';
  Icon: Image;
  Id: Scalars['ID']['output'];
  Label: Scalars['String']['output'];
  SocialNetwork: SocialNetwork;
};

export enum SocialNetwork {
  Apple = 'APPLE',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  Linkedin = 'LINKEDIN',
  Twitter = 'TWITTER'
}

export type SpreadsheetModeOptions = {
  __typename?: 'SpreadsheetModeOptions';
  Mode?: Maybe<Scalars['String']['output']>;
  ShowAddRowsButton?: Maybe<Scalars['Boolean']['output']>;
};

export type StateInspector = IDesignable & IField & {
  __typename?: 'StateInspector';
  Bindings?: Maybe<StateInspectorBindings>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Id: Scalars['ID']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type StateInspectorBindings = {
  __typename?: 'StateInspectorBindings';
  Visible?: Maybe<Scalars['String']['output']>;
};

export type StyleEditor = {
  __typename?: 'StyleEditor';
  Bindings?: Maybe<StyleEditorBindings>;
  ContextId?: Maybe<Scalars['String']['output']>;
  Id: Scalars['ID']['output'];
  Layout?: Maybe<Layout>;
  Name: Scalars['String']['output'];
  Type?: Maybe<Scalars['String']['output']>;
};

export type StyleEditorBindings = {
  __typename?: 'StyleEditorBindings';
  Layout?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

export type StyleProperties = {
  __typename?: 'StyleProperties';
  alignItems?: Maybe<Scalars['ResponsiveProperty']['output']>;
  alignSelf?: Maybe<Scalars['ResponsiveProperty']['output']>;
  backgroundColor?: Maybe<Scalars['ResponsiveProperty']['output']>;
  color?: Maybe<Scalars['ResponsiveProperty']['output']>;
  display?: Maybe<Scalars['ResponsiveProperty']['output']>;
  flex?: Maybe<Scalars['ResponsiveProperty']['output']>;
  flexDirection?: Maybe<Scalars['ResponsiveProperty']['output']>;
  fontDecoration?: Maybe<Scalars['ResponsiveProperty']['output']>;
  fontSize?: Maybe<Scalars['ResponsiveProperty']['output']>;
  fontStyle?: Maybe<Scalars['ResponsiveProperty']['output']>;
  fontType?: Maybe<Scalars['ResponsiveProperty']['output']>;
  fontWeight?: Maybe<Scalars['ResponsiveProperty']['output']>;
  gap?: Maybe<Scalars['ResponsiveProperty']['output']>;
  height?: Maybe<Scalars['ResponsiveProperty']['output']>;
  horizonalAlign?: Maybe<Scalars['ResponsiveProperty']['output']>;
  margin?: Maybe<Scalars['ResponsiveProperty']['output']>;
  marginBottom?: Maybe<Scalars['ResponsiveProperty']['output']>;
  marginLeft?: Maybe<Scalars['ResponsiveProperty']['output']>;
  marginRight?: Maybe<Scalars['ResponsiveProperty']['output']>;
  marginTop?: Maybe<Scalars['ResponsiveProperty']['output']>;
  maxHeight?: Maybe<Scalars['ResponsiveProperty']['output']>;
  maxWidth?: Maybe<Scalars['ResponsiveProperty']['output']>;
  minHeight?: Maybe<Scalars['ResponsiveProperty']['output']>;
  minWidth?: Maybe<Scalars['ResponsiveProperty']['output']>;
  padding?: Maybe<Scalars['ResponsiveProperty']['output']>;
  verticalAlign?: Maybe<Scalars['ResponsiveProperty']['output']>;
  width?: Maybe<Scalars['ResponsiveProperty']['output']>;
};

export type Switch = IDesignable & IEditable & IField & {
  __typename?: 'Switch';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Analytics?: Maybe<Analytics>;
  Bindings?: Maybe<SwitchBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  Checked?: Maybe<Scalars['Boolean']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  /** The color of the component. It supports both default and custom theme colors, which can be added as shown in the palette customization guide . */
  Color?: Maybe<Scalars['String']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  /** If true , the ripple effect is disabled. */
  DisableRipple?: Maybe<Scalars['Boolean']['output']>;
  /** If true , the component is disabled. */
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  /** If given, uses a negative margin to counteract the padding on one side (this is often helpful for aligning the left or right side of the icon with content above or below, without ruining the border size and shape). */
  Edge?: Maybe<Scalars['String']['output']>;
  Editable?: Maybe<Scalars['Boolean']['output']>;
  FieldType?: Maybe<FieldType>;
  Format?: Maybe<FieldFormat>;
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  /** Default label */
  Label?: Maybe<Scalars['String']['output']>;
  LabelPlacement?: Maybe<Scalars['String']['output']>;
  LabelStyle?: Maybe<StyleProperties>;
  LabelWhenOff?: Maybe<Scalars['String']['output']>;
  LabelWhenOn?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  /** If true , the input element is required. */
  Required?: Maybe<Scalars['Boolean']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  /** The size of the component. small is equivalent to the dense switch styling. */
  Size?: Maybe<Scalars['String']['output']>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
  Value?: Maybe<Scalars['Boolean']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type SwitchBindings = {
  __typename?: 'SwitchBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type SwitchStyleConfigurations = {
  __typename?: 'SwitchStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TabContainer = IDesignable & {
  __typename?: 'TabContainer';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  AriaLabel?: Maybe<Scalars['String']['output']>;
  Bindings?: Maybe<TabContainerBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  BoxStyle?: Maybe<StyleProperties>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  ContentClasses?: Maybe<Scalars['ClassSet']['output']>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  InReviewMode?: Maybe<Scalars['Boolean']['output']>;
  Items: Array<TabItemOrContainer>;
  MaxTabs?: Maybe<Scalars['Int']['output']>;
  MoreTabsText?: Maybe<Scalars['String']['output']>;
  Paper?: Maybe<Paper>;
  Resizable?: Maybe<ResizableProperties>;
  ReviewDialogOptions?: Maybe<ReviewDialog>;
  /** This is the Id of the selected tab.  If null, the first tab in the list is selected by default */
  SelectedTabId?: Maybe<Scalars['String']['output']>;
  SelectedTabTitle?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  TabClasses?: Maybe<Scalars['ClassSet']['output']>;
  TabIndicatorStyles?: Maybe<StyleProperties>;
  TabStyle?: Maybe<StyleProperties>;
  UniqueName?: Maybe<Scalars['String']['output']>;
  Variant?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type TabContainerBindings = {
  __typename?: 'TabContainerBindings';
  BoxStyle?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['String']['output']>;
  ContentClasses?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  InReviewMode?: Maybe<Scalars['String']['output']>;
  MaxTabs?: Maybe<Scalars['String']['output']>;
  SelectedTabId?: Maybe<Scalars['String']['output']>;
  SelectedTabTitle?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  TabClasses?: Maybe<Scalars['String']['output']>;
  TabIndicatorStyles?: Maybe<StyleProperties>;
  TabStyle?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type TabContainerStyleConfigurations = {
  __typename?: 'TabContainerStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TabItem = {
  __typename?: 'TabItem';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<TabItemBindings>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Icon?: Maybe<Icon>;
  Id: Scalars['ID']['output'];
  Items?: Maybe<Array<Maybe<Scalars['FlexLayoutItem']['output']>>>;
  Style?: Maybe<StyleProperties>;
  /** The items to render within the tab */
  TabClasses?: Maybe<Scalars['ClassSet']['output']>;
  TabIndex?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type TabItemBindings = {
  __typename?: 'TabItemBindings';
  Disabled?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  TabClasses?: Maybe<Scalars['String']['output']>;
  TabIndex?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type TabItemOrContainer = SimpleContainer | TabItem;

export type TabItemStyleConfigurations = {
  __typename?: 'TabItemStyleConfigurations';
  ControlType?: Maybe<Scalars['String']['output']>;
  ExternalControlType?: Maybe<Scalars['String']['output']>;
  Slots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TabLayout = IDesignable & {
  __typename?: 'TabLayout';
  AriaLabel?: Maybe<Scalars['String']['output']>;
  Bindings?: Maybe<TabLayoutBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  ContentClasses?: Maybe<Scalars['ClassSet']['output']>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  InReviewMode?: Maybe<Scalars['Boolean']['output']>;
  Paper?: Maybe<Paper>;
  ReviewDialogOptions?: Maybe<ReviewDialog>;
  /** This is the Id of the selected tab.  If null, the first tab in the list is selected by default */
  SelectedTabId?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  TabClasses?: Maybe<Scalars['ClassSet']['output']>;
  TabIndicatorStyles?: Maybe<StyleProperties>;
  Tabs: Array<TabItem>;
  UniqueName?: Maybe<Scalars['String']['output']>;
};

export type TabLayoutBindings = {
  __typename?: 'TabLayoutBindings';
  ContentClasses?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  InReviewMode?: Maybe<Scalars['String']['output']>;
  SelectedTabId?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  TabClasses?: Maybe<Scalars['String']['output']>;
  TabIndicatorStyles?: Maybe<StyleProperties>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type TableItemProps = {
  __typename?: 'TableItemProps';
  ItemId?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
};

export type TableLayout = {
  __typename?: 'TableLayout';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  CollapseIcon?: Maybe<Icon>;
  ContentItemsProps?: Maybe<Array<Maybe<TableItemProps>>>;
  ContextId?: Maybe<Scalars['String']['output']>;
  ExpandIcon?: Maybe<Icon>;
  Expandable?: Maybe<Scalars['Boolean']['output']>;
  HeaderItemsProps?: Maybe<Array<Maybe<TableItemProps>>>;
  HeaderRowStyle?: Maybe<StyleProperties>;
  Id?: Maybe<Scalars['ID']['output']>;
  LayoutItem?: Maybe<LayoutItem>;
  RowStyle?: Maybe<StyleProperties>;
  /** When creating a TableLayout for a form, this indicates which elements of the form go into the rows */
  RowsItems?: Maybe<Array<Array<Scalars['String']['output']>>>;
  TableStyle?: Maybe<StyleProperties>;
};

export type Theme = {
  __typename?: 'Theme';
  Styles?: Maybe<Scalars['StyleSet']['output']>;
};

export type TimePicker = IDesignable & IField & {
  __typename?: 'TimePicker';
  Analytics?: Maybe<Analytics>;
  Bindings?: Maybe<TimePickerBindings>;
  ClassName?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Id: Scalars['ID']['output'];
  Style?: Maybe<StyleProperties>;
  Value?: Maybe<Scalars['String']['output']>;
};

export type TimePickerBindings = {
  __typename?: 'TimePickerBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type TimeZonePicker = IDesignable & IField & {
  __typename?: 'TimeZonePicker';
  AutoSelect?: Maybe<Scalars['Boolean']['output']>;
  Bindings?: Maybe<TimePickerBindings>;
  ClassName?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  Id: Scalars['ID']['output'];
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
  Value?: Maybe<Scalars['String']['output']>;
};

export type TimeZonePickerBindings = {
  __typename?: 'TimeZonePickerBindings';
  AutoSelect?: Maybe<Scalars['String']['output']>;
  Classes?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type Transform = {
  __typename?: 'Transform';
  Bindings?: Maybe<TransformBindings>;
  CommandResult?: Maybe<Scalars['String']['output']>;
  DataTransformations?: Maybe<Scalars['BindingsDictionary']['output']>;
  InputData?: Maybe<Scalars['SampleData']['output']>;
  Options?: Maybe<Scalars['TransformMethodOptions']['output']>;
  TransformMethod: Scalars['String']['output'];
};

export type TransformBindings = {
  __typename?: 'TransformBindings';
  InputData?: Maybe<Scalars['String']['output']>;
  Options?: Maybe<Scalars['String']['output']>;
  TransformMethod?: Maybe<Scalars['String']['output']>;
};

export type TreeKeyConversion = {
  __typename?: 'TreeKeyConversion';
  Children?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
};

export type TreeList = IApplication & IDesignable & {
  __typename?: 'TreeList';
  /** Is set to true, the user can add items to the tree */
  AllowAdd?: Maybe<Scalars['Boolean']['output']>;
  /** Is set to true, the elements in the tree can be re-ordered (up&down) */
  AllowDelete?: Maybe<Scalars['Boolean']['output']>;
  /** Is set to true, the elements in the tree can be re-ordered (up&down) */
  AllowReordering?: Maybe<Scalars['Boolean']['output']>;
  Bindings?: Maybe<TreeListBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  /** The default icon used to collapse the node. */
  DefaultCollapseIcon?: Maybe<Icon>;
  /** The default icon displayed next to a end node. This is applied to all tree nodes and can be overridden by the TreeItem icon prop. */
  DefaultEndIcon?: Maybe<Icon>;
  /** The default icon used to expand the node. */
  DefaultExpandIcon?: Maybe<Icon>;
  /** The default icon displayed next to a parent node. This is applied to all parent nodes and can be overridden by the TreeItem icon prop. */
  DefaultParentIcon?: Maybe<Icon>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  /** If true selection is disabled. */
  DisableSelection?: Maybe<Scalars['Boolean']['output']>;
  /** If true, will allow focus on disabled items. */
  DisabledItemsFocusable?: Maybe<Scalars['Boolean']['output']>;
  /** If set to true, the tree is always expanded */
  ForceExpanded?: Maybe<Scalars['Boolean']['output']>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  /** How to convert from the data to the tree, i.e. id, label, children */
  KeyConversion: TreeKeyConversion;
  /** The default label of the new item when adding one */
  NewItemLabel?: Maybe<Scalars['String']['output']>;
  /** The typename of the new item when adding one, for example, FeatureSet */
  NewItemTypename?: Maybe<Scalars['String']['output']>;
  Service?: Maybe<Scalars['String']['output']>;
  /** The data field at the top level of the tree that contains the label */
  TopLevelLabelField?: Maybe<Scalars['String']['output']>;
  Typename?: Maybe<Scalars['String']['output']>;
  UniqueName: Scalars['String']['output'];
  getData?: Maybe<Scalars['Method']['output']>;
};

export type TreeListBindings = {
  __typename?: 'TreeListBindings';
  AllowAdd?: Maybe<Scalars['String']['output']>;
  AllowDelete?: Maybe<Scalars['String']['output']>;
  AllowReordering?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['String']['output']>;
  Loading?: Maybe<Scalars['String']['output']>;
  NodesExpanded?: Maybe<Scalars['String']['output']>;
  Rows?: Maybe<Scalars['String']['output']>;
  SelectedItem?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['String']['output']>;
};

export type TriggerAction = {
  __typename?: 'TriggerAction';
  Bindings?: Maybe<TriggerActionBindings>;
  CommandResult?: Maybe<Scalars['String']['output']>;
  Event?: Maybe<Scalars['String']['output']>;
  Form?: Maybe<Scalars['FormId']['output']>;
  TargetId?: Maybe<Scalars['LayoutItemId']['output']>;
  Trigger?: Maybe<Scalars['String']['output']>;
};

export type TriggerActionBindings = {
  __typename?: 'TriggerActionBindings';
  Event?: Maybe<Scalars['String']['output']>;
  Form?: Maybe<Scalars['String']['output']>;
  TargetId?: Maybe<Scalars['String']['output']>;
  Trigger?: Maybe<Scalars['String']['output']>;
};

export type TriggerPropagation = {
  __typename?: 'TriggerPropagation';
  PropagateOnFailure?: Maybe<Scalars['Boolean']['output']>;
  Trigger?: Maybe<Scalars['String']['output']>;
};

export type TypedBindingEditor = {
  __typename?: 'TypedBindingEditor';
  Id?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};

export type UndoRedoToolbar = IDesignable & IEditable & IField & {
  __typename?: 'UndoRedoToolbar';
  Actions?: Maybe<Array<Maybe<IActionTrigger>>>;
  Bindings?: Maybe<UndoRedoToolbarBindings>;
  BlockDelete?: Maybe<Scalars['Boolean']['output']>;
  CanBeDesigned?: Maybe<Scalars['Boolean']['output']>;
  Classes?: Maybe<Scalars['ClassSet']['output']>;
  DefaultValue?: Maybe<Scalars['String']['output']>;
  DisableKeyActions?: Maybe<Scalars['Boolean']['output']>;
  Editable?: Maybe<Scalars['Boolean']['output']>;
  FieldType?: Maybe<FieldType>;
  Format?: Maybe<FieldFormat>;
  Id: Scalars['ID']['output'];
  InDesignMode?: Maybe<Scalars['Boolean']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  Style?: Maybe<StyleProperties>;
  TrackedObject?: Maybe<Scalars['String']['output']>;
  ValidationRules?: Maybe<Array<Maybe<ValidationRule>>>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
  Width?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Method']['output']>;
};

export type UndoRedoToolbarBindings = {
  __typename?: 'UndoRedoToolbarBindings';
  Classes?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
  TrackedObject?: Maybe<Scalars['String']['output']>;
  Visible?: Maybe<Scalars['Boolean']['output']>;
};

export type Valid = {
  __typename?: 'Valid';
  reasons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ValidationRule = {
  __typename?: 'ValidationRule';
  ErrorMessage?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  Parameters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ValidationMethod: Scalars['String']['output'];
};

export enum ViewMode {
  Always = 'Always',
  Designer = 'Designer',
  Developer = 'Developer',
  Never = 'Never'
}

export type VisibleMenu = {
  __typename?: 'VisibleMenu';
  AllowNavigation?: Maybe<Scalars['Boolean']['output']>;
  Bindings?: Maybe<VisibleMenuBindings>;
  ButtonStyle?: Maybe<StyleProperties>;
  Data?: Maybe<Scalars['SampleData']['output']>;
  Id?: Maybe<Scalars['ID']['output']>;
  IsCollapsible?: Maybe<Scalars['Boolean']['output']>;
  Loading?: Maybe<Scalars['Boolean']['output']>;
  Sequence?: Maybe<Scalars['Int']['output']>;
  Service?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<StyleProperties>;
};

export type VisibleMenuBindings = {
  __typename?: 'VisibleMenuBindings';
  ButtonStyle?: Maybe<Scalars['String']['output']>;
  Data?: Maybe<Scalars['String']['output']>;
  Loading?: Maybe<Scalars['String']['output']>;
  Style?: Maybe<Scalars['String']['output']>;
};

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = ResolversObject<{
  Action: ( BecomeUser ) | ( CallPhone ) | ( CallService ) | ( ClearForm ) | ( CloseContextMenu ) | ( CloseModalPopup ) | ( CopyToClipboard ) | ( GenerateCode ) | ( GoBack ) | ( GoToBookmark ) | ( GoToPage ) | ( Login ) | ( Logout ) | ( OpenContextMenu ) | ( OpenModalPopup ) | ( PasteFromClipboard ) | ( ReloadPage ) | ( SendEmail ) | ( SendMessageToChild ) | ( SendMessageToParent ) | ( SendSms ) | ( SetState ) | ( Omit<Share, 'Component'> & { Component?: Maybe<_RefType['Component']> } ) | ( ShowMessage ) | ( ShowToast ) | ( Transform ) | ( TriggerAction );
  Container: ( Omit<SimpleContainer, 'Actions' | 'Context' | 'Items' | 'Layout' | 'ReviewDialogOptions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Context?: Maybe<Array<Maybe<_RefType['IField']>>>, Items?: Maybe<Array<_RefType['LayoutItem']>>, Layout?: Maybe<_RefType['Layout']>, ReviewDialogOptions?: Maybe<_RefType['ReviewDialog']> } ) | ( Omit<TabContainer, 'Actions' | 'Items' | 'ReviewDialogOptions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Items: Array<_RefType['TabItemOrContainer']>, ReviewDialogOptions?: Maybe<_RefType['ReviewDialog']> } );
  Control: ( AiDialog ) | ( Omit<ActionEditor, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( AudioPlayer ) | ( AudioRecorder ) | ( Omit<Avatar, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( BasicInput ) | ( Omit<Button, 'Actions' | 'ContextMenu'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ContextMenu?: Maybe<_RefType['ContextMenu']> } ) | ( Omit<ButtonGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Omit<Checkbox, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( CircularProgress ) | ( CodeEditor ) | ( Omit<ComponentLibrary, 'Actions' | 'Components'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Components: Array<Maybe<_RefType['LibraryItem']>> } ) | ( Omit<ContextAutocomplete, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Omit<ContextMenu, 'Bindings' | 'Content'> & { Bindings?: Maybe<_RefType['ContextMenuBindings']>, Content: _RefType['LayoutItem'] } ) | ( DatePicker ) | ( FileList ) | ( FileUpload ) | ( Html ) | ( IFrame ) | ( Icon ) | ( IconSelector ) | ( Omit<Image, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Omit<InputField, 'Actions' | 'ContextAutocomplete'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ContextAutocomplete?: Maybe<_RefType['ContextAutocomplete']> } ) | ( Omit<Label, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( LinearProgress ) | ( Link ) | ( Omit<ListClearAllButton, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( ListExportButton ) | ( Omit<ListQuickFilter, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Markdown ) | ( Omit<MultiSelect, 'Actions' | 'ServiceList'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ServiceList?: Maybe<_RefType['ServiceList']> } ) | ( Omit<Overlay, 'Actions' | 'Items'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Items?: Maybe<Array<_RefType['LayoutItem']>> } ) | ( ProportionalBar ) | ( Omit<RadioGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( ResolutionButtons ) | ( Omit<RichTextEditor, 'Actions' | 'ContextAutocomplete'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ContextAutocomplete?: Maybe<_RefType['ContextAutocomplete']> } ) | ( Omit<Slider, 'ValueLabelItem'> & { ValueLabelItem?: Maybe<_RefType['LayoutItem']> } ) | ( Omit<Snackbar, 'Actions' | 'Button'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Button?: Maybe<_RefType['Button']> } ) | ( Omit<StyleEditor, 'Layout'> & { Layout?: Maybe<_RefType['Layout']> } ) | ( Omit<Switch, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( VisibleMenu );
  Layout: ( Omit<AccordionLayout, 'Groups'> & { Groups: Array<_RefType['AccordionGroup']> } ) | ( Omit<FlexLayout, 'InnerLayouts' | 'LayoutItem'> & { InnerLayouts?: Maybe<Array<Maybe<_RefType['Layout']>>>, LayoutItem?: Maybe<_RefType['LayoutItem']> } ) | ( FragmentLayout ) | ( FreeFormLayout ) | ( Omit<GridStackLayout, 'Actions' | 'InnerLayouts' | 'LayoutItem'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, InnerLayouts?: Maybe<Array<Maybe<_RefType['Layout']>>>, LayoutItem?: Maybe<_RefType['LayoutItem']> } ) | ( Omit<LinearLayout, 'InnerLayouts' | 'LayoutItem'> & { InnerLayouts?: Maybe<Array<Maybe<_RefType['Layout']>>>, LayoutItem?: Maybe<_RefType['LayoutItem']> } ) | ( Omit<TabLayout, 'ReviewDialogOptions' | 'Tabs'> & { ReviewDialogOptions?: Maybe<_RefType['ReviewDialog']>, Tabs: Array<_RefType['TabItem']> } ) | ( Omit<TableLayout, 'Actions' | 'LayoutItem'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, LayoutItem?: Maybe<_RefType['LayoutItem']> } );
  LayoutItem: ( AiDialog ) | ( Omit<AccordionLayout, 'Groups'> & { Groups: Array<_RefType['AccordionGroup']> } ) | ( Omit<ActionEditor, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( AudioPlayer ) | ( AudioRecorder ) | ( Omit<Avatar, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( BasicInput ) | ( Omit<Button, 'Actions' | 'ContextMenu'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ContextMenu?: Maybe<_RefType['ContextMenu']> } ) | ( Omit<ButtonGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Chart ) | ( Omit<Checkbox, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( CircularProgress ) | ( CodeEditor ) | ( Omit<Component, 'Actions' | 'ComponentContainer' | 'HeaderItems' | 'ModalPopups' | 'ServiceSnapshots' | 'Services' | 'SharingInfo'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ComponentContainer?: Maybe<_RefType['Container']>, HeaderItems?: Maybe<Array<_RefType['LayoutItem']>>, ModalPopups?: Maybe<Array<Maybe<_RefType['Dialog']>>>, ServiceSnapshots?: Maybe<Array<Maybe<_RefType['Service']>>>, Services?: Maybe<Array<Maybe<_RefType['Service']>>>, SharingInfo?: Maybe<_RefType['SharingInfo']> } ) | ( Omit<ComponentLibrary, 'Actions' | 'Components'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Components: Array<Maybe<_RefType['LibraryItem']>> } ) | ( Omit<ContextAutocomplete, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Omit<ContextMenu, 'Bindings' | 'Content'> & { Bindings?: Maybe<_RefType['ContextMenuBindings']>, Content: _RefType['LayoutItem'] } ) | ( DatePicker ) | ( Omit<Dialog, 'Actions' | 'CommandSetOnCancel' | 'CommandSetOnClose' | 'CommandSetOnOk' | 'ContentContainer' | 'FooterContainer' | 'HeaderItem'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, CommandSetOnCancel?: Maybe<_RefType['CommandSet']>, CommandSetOnClose?: Maybe<_RefType['CommandSet']>, CommandSetOnOk?: Maybe<_RefType['CommandSet']>, ContentContainer?: Maybe<_RefType['Container']>, FooterContainer?: Maybe<_RefType['Container']>, HeaderItem?: Maybe<_RefType['LayoutItem']> } ) | ( Omit<Feed, 'Components' | 'FeedFooter' | 'FeedHeader' | 'ReviewDialogOptions'> & { Components?: Maybe<Array<_RefType['Component']>>, FeedFooter?: Maybe<_RefType['LayoutItem']>, FeedHeader?: Maybe<_RefType['LayoutItem']>, ReviewDialogOptions?: Maybe<_RefType['ReviewDialog']> } ) | ( FileList ) | ( FileUpload ) | ( Omit<FinApp, 'Actions' | 'Elements' | 'UserPrefs'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Elements?: Maybe<_RefType['Service']>, UserPrefs?: Maybe<_RefType['Service']> } ) | ( Omit<Form, 'Actions' | 'Items' | 'Layout'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Items?: Maybe<Array<_RefType['LayoutItem']>>, Layout?: Maybe<_RefType['Layout']> } ) | ( Html ) | ( IFrame ) | ( Icon ) | ( Omit<Image, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Omit<InputField, 'Actions' | 'ContextAutocomplete'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ContextAutocomplete?: Maybe<_RefType['ContextAutocomplete']> } ) | ( Omit<Label, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( LinearProgress ) | ( Link ) | ( Omit<List, 'Actions' | 'Columns' | 'Items' | 'ListColumns' | 'Service' | 'Toolbar'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Columns?: Maybe<Array<_RefType['ListColumn']>>, Items?: Maybe<Array<Maybe<_RefType['LayoutItem']>>>, ListColumns?: Maybe<Array<_RefType['ListColumn']>>, Service?: Maybe<_RefType['Service']>, Toolbar?: Maybe<_RefType['ListToolbar']> } ) | ( Omit<ListClearAllButton, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Omit<ListColumn, 'Actions' | 'CellLayout' | 'CellRendererItems'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, CellLayout?: Maybe<_RefType['LayoutItem']>, CellRendererItems?: Maybe<Array<Maybe<_RefType['LayoutItem']>>> } ) | ( ListExportButton ) | ( Omit<ListQuickFilter, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Markdown ) | ( Omit<MultiFilter, 'Actions' | 'Fields' | 'Items'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Fields?: Maybe<Array<Maybe<_RefType['IField']>>>, Items?: Maybe<Array<_RefType['LayoutItem']>> } ) | ( Omit<MultiSelect, 'Actions' | 'ServiceList'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ServiceList?: Maybe<_RefType['ServiceList']> } ) | ( Omit<Overlay, 'Actions' | 'Items'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Items?: Maybe<Array<_RefType['LayoutItem']>> } ) | ( Omit<Page, 'Actions' | 'Context' | 'Items' | 'Layout' | 'ModalPopups' | 'PageTemplate' | 'Services'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Context?: Maybe<Array<Maybe<_RefType['IField']>>>, Items?: Maybe<Array<_RefType['LayoutItem']>>, Layout?: Maybe<_RefType['Layout']>, ModalPopups?: Maybe<Array<Maybe<_RefType['Dialog']>>>, PageTemplate?: Maybe<_RefType['PageTemplate']>, Services?: Maybe<Array<Maybe<_RefType['Service']>>> } ) | ( Omit<PropertiesEditor, 'Actions' | 'HeaderItems'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, HeaderItems?: Maybe<Array<_RefType['LayoutItem']>> } ) | ( ProportionalBar ) | ( Omit<RadioGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Omit<Repeater, 'Content' | 'Details' | 'Header' | 'Items' | 'Layout' | 'Title'> & { Content?: Maybe<_RefType['Form']>, Details?: Maybe<_RefType['Form']>, Header?: Maybe<_RefType['LayoutItem']>, Items?: Maybe<Array<_RefType['LayoutItem']>>, Layout?: Maybe<_RefType['Layout']>, Title?: Maybe<_RefType['LayoutItem']> } ) | ( ResolutionButtons ) | ( Omit<RichTextEditor, 'Actions' | 'ContextAutocomplete'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ContextAutocomplete?: Maybe<_RefType['ContextAutocomplete']> } ) | ( RichTreeList ) | ( Omit<SimpleContainer, 'Actions' | 'Context' | 'Items' | 'Layout' | 'ReviewDialogOptions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Context?: Maybe<Array<Maybe<_RefType['IField']>>>, Items?: Maybe<Array<_RefType['LayoutItem']>>, Layout?: Maybe<_RefType['Layout']>, ReviewDialogOptions?: Maybe<_RefType['ReviewDialog']> } ) | ( Omit<Slider, 'ValueLabelItem'> & { ValueLabelItem?: Maybe<_RefType['LayoutItem']> } ) | ( Omit<Snackbar, 'Actions' | 'Button'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Button?: Maybe<_RefType['Button']> } ) | ( Omit<Switch, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Omit<TabContainer, 'Actions' | 'Items' | 'ReviewDialogOptions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Items: Array<_RefType['TabItemOrContainer']>, ReviewDialogOptions?: Maybe<_RefType['ReviewDialog']> } ) | ( Omit<TabLayout, 'ReviewDialogOptions' | 'Tabs'> & { ReviewDialogOptions?: Maybe<_RefType['ReviewDialog']>, Tabs: Array<_RefType['TabItem']> } ) | ( TreeList ) | ( VisibleMenu );
  TabItemOrContainer: ( Omit<SimpleContainer, 'Actions' | 'Context' | 'Items' | 'Layout' | 'ReviewDialogOptions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Context?: Maybe<Array<Maybe<_RefType['IField']>>>, Items?: Maybe<Array<_RefType['LayoutItem']>>, Layout?: Maybe<_RefType['Layout']>, ReviewDialogOptions?: Maybe<_RefType['ReviewDialog']> } ) | ( Omit<TabItem, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } );
}>;

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = ResolversObject<{
  IActionTrigger: never;
  IApplication: ( Omit<Feed, 'Components' | 'FeedFooter' | 'FeedHeader' | 'ReviewDialogOptions'> & { Components?: Maybe<Array<_RefType['Component']>>, FeedFooter?: Maybe<_RefType['LayoutItem']>, FeedHeader?: Maybe<_RefType['LayoutItem']>, ReviewDialogOptions?: Maybe<_RefType['ReviewDialog']> } ) | ( Omit<FinApp, 'Actions' | 'Elements' | 'UserPrefs'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Elements?: Maybe<_RefType['Service']>, UserPrefs?: Maybe<_RefType['Service']> } ) | ( Omit<Form, 'Actions' | 'Items' | 'Layout'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Items?: Maybe<Array<_RefType['LayoutItem']>>, Layout?: Maybe<_RefType['Layout']> } ) | ( Omit<List, 'Actions' | 'Columns' | 'Items' | 'ListColumns' | 'Service' | 'Toolbar'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Columns?: Maybe<Array<_RefType['ListColumn']>>, Items?: Maybe<Array<Maybe<_RefType['LayoutItem']>>>, ListColumns?: Maybe<Array<_RefType['ListColumn']>>, Service?: Maybe<_RefType['Service']>, Toolbar?: Maybe<_RefType['ListToolbar']> } ) | ( Omit<PropertiesEditor, 'Actions' | 'HeaderItems'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, HeaderItems?: Maybe<Array<_RefType['LayoutItem']>> } ) | ( Omit<Repeater, 'Content' | 'Details' | 'Header' | 'Items' | 'Layout' | 'Title'> & { Content?: Maybe<_RefType['Form']>, Details?: Maybe<_RefType['Form']>, Header?: Maybe<_RefType['LayoutItem']>, Items?: Maybe<Array<_RefType['LayoutItem']>>, Layout?: Maybe<_RefType['Layout']>, Title?: Maybe<_RefType['LayoutItem']> } ) | ( TreeList );
  IDesignable: ( AiDialog ) | ( Omit<AccordionGroup, 'Actions' | 'Header'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Header?: Maybe<_RefType['LayoutItem']> } ) | ( Omit<AccordionLayout, 'Groups'> & { Groups: Array<_RefType['AccordionGroup']> } ) | ( BasicInput ) | ( Omit<Button, 'Actions' | 'ContextMenu'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ContextMenu?: Maybe<_RefType['ContextMenu']> } ) | ( Omit<ButtonGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Chart ) | ( Omit<Checkbox, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( CircularProgress ) | ( DatePicker ) | ( DateTimePicker ) | ( Omit<DocumentViewer, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( DropDownButton ) | ( Omit<Feed, 'Components' | 'FeedFooter' | 'FeedHeader' | 'ReviewDialogOptions'> & { Components?: Maybe<Array<_RefType['Component']>>, FeedFooter?: Maybe<_RefType['LayoutItem']>, FeedHeader?: Maybe<_RefType['LayoutItem']>, ReviewDialogOptions?: Maybe<_RefType['ReviewDialog']> } ) | ( Omit<Form, 'Actions' | 'Items' | 'Layout'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Items?: Maybe<Array<_RefType['LayoutItem']>>, Layout?: Maybe<_RefType['Layout']> } ) | ( IFrame ) | ( Omit<InputField, 'Actions' | 'ContextAutocomplete'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ContextAutocomplete?: Maybe<_RefType['ContextAutocomplete']> } ) | ( JsonView ) | ( Omit<Label, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( LinearProgress ) | ( Link ) | ( Omit<ListColumn, 'Actions' | 'CellLayout' | 'CellRendererItems'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, CellLayout?: Maybe<_RefType['LayoutItem']>, CellRendererItems?: Maybe<Array<Maybe<_RefType['LayoutItem']>>> } ) | ( Omit<MultiSelect, 'Actions' | 'ServiceList'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ServiceList?: Maybe<_RefType['ServiceList']> } ) | ( Omit<Page, 'Actions' | 'Context' | 'Items' | 'Layout' | 'ModalPopups' | 'PageTemplate' | 'Services'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Context?: Maybe<Array<Maybe<_RefType['IField']>>>, Items?: Maybe<Array<_RefType['LayoutItem']>>, Layout?: Maybe<_RefType['Layout']>, ModalPopups?: Maybe<Array<Maybe<_RefType['Dialog']>>>, PageTemplate?: Maybe<_RefType['PageTemplate']>, Services?: Maybe<Array<Maybe<_RefType['Service']>>> } ) | ( Omit<RadioGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Omit<Repeater, 'Content' | 'Details' | 'Header' | 'Items' | 'Layout' | 'Title'> & { Content?: Maybe<_RefType['Form']>, Details?: Maybe<_RefType['Form']>, Header?: Maybe<_RefType['LayoutItem']>, Items?: Maybe<Array<_RefType['LayoutItem']>>, Layout?: Maybe<_RefType['Layout']>, Title?: Maybe<_RefType['LayoutItem']> } ) | ( ResolutionButtons ) | ( Omit<SimpleContainer, 'Actions' | 'Context' | 'Items' | 'Layout' | 'ReviewDialogOptions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Context?: Maybe<Array<Maybe<_RefType['IField']>>>, Items?: Maybe<Array<_RefType['LayoutItem']>>, Layout?: Maybe<_RefType['Layout']>, ReviewDialogOptions?: Maybe<_RefType['ReviewDialog']> } ) | ( Omit<Slider, 'ValueLabelItem'> & { ValueLabelItem?: Maybe<_RefType['LayoutItem']> } ) | ( StateInspector ) | ( Omit<Switch, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Omit<TabContainer, 'Actions' | 'Items' | 'ReviewDialogOptions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, Items: Array<_RefType['TabItemOrContainer']>, ReviewDialogOptions?: Maybe<_RefType['ReviewDialog']> } ) | ( Omit<TabLayout, 'ReviewDialogOptions' | 'Tabs'> & { ReviewDialogOptions?: Maybe<_RefType['ReviewDialog']>, Tabs: Array<_RefType['TabItem']> } ) | ( TimePicker ) | ( TimeZonePicker ) | ( TreeList ) | ( Omit<UndoRedoToolbar, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } );
  IEditable: ( AiDialog ) | ( BasicInput ) | ( Omit<ButtonGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Chart ) | ( Omit<Checkbox, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( IFrame ) | ( Omit<InputField, 'Actions' | 'ContextAutocomplete'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ContextAutocomplete?: Maybe<_RefType['ContextAutocomplete']> } ) | ( Omit<ListColumn, 'Actions' | 'CellLayout' | 'CellRendererItems'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, CellLayout?: Maybe<_RefType['LayoutItem']>, CellRendererItems?: Maybe<Array<Maybe<_RefType['LayoutItem']>>> } ) | ( Omit<MultiSelect, 'Actions' | 'ServiceList'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ServiceList?: Maybe<_RefType['ServiceList']> } ) | ( Omit<RadioGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( ResolutionButtons ) | ( Omit<Slider, 'ValueLabelItem'> & { ValueLabelItem?: Maybe<_RefType['LayoutItem']> } ) | ( Omit<Switch, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Omit<UndoRedoToolbar, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } );
  IField: ( AiDialog ) | ( BasicInput ) | ( Omit<ButtonGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Chart ) | ( ChartField ) | ( Omit<Checkbox, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( CircularProgress ) | ( DatePicker ) | ( DateTimePicker ) | ( Omit<DocumentViewer, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( IFrame ) | ( Omit<InputField, 'Actions' | 'ContextAutocomplete'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ContextAutocomplete?: Maybe<_RefType['ContextAutocomplete']> } ) | ( JsonView ) | ( Omit<Label, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( LinearProgress ) | ( Link ) | ( Omit<ListColumn, 'Actions' | 'CellLayout' | 'CellRendererItems'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, CellLayout?: Maybe<_RefType['LayoutItem']>, CellRendererItems?: Maybe<Array<Maybe<_RefType['LayoutItem']>>> } ) | ( Omit<MultiSelect, 'Actions' | 'ServiceList'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ServiceList?: Maybe<_RefType['ServiceList']> } ) | ( Omit<RadioGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( ResolutionButtons ) | ( Omit<Slider, 'ValueLabelItem'> & { ValueLabelItem?: Maybe<_RefType['LayoutItem']> } ) | ( StateInspector ) | ( Omit<Switch, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( TimePicker ) | ( TimeZonePicker ) | ( Omit<UndoRedoToolbar, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } );
  IInstruction: never;
  IParameter: never;
  IParameterWithValues: never;
  ISelectFromList: ( Omit<ButtonGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } ) | ( Omit<MultiSelect, 'Actions' | 'ServiceList'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>>, ServiceList?: Maybe<_RefType['ServiceList']> } ) | ( Omit<RadioGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<_RefType['IActionTrigger']>>> } );
}>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  AIDialog: ResolverTypeWrapper<AiDialog>;
  AIDialogBindings: ResolverTypeWrapper<AiDialogBindings>;
  AccordionGroup: ResolverTypeWrapper<Omit<AccordionGroup, 'Actions' | 'Header'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, Header?: Maybe<ResolversTypes['LayoutItem']> }>;
  AccordionGroupBindings: ResolverTypeWrapper<AccordionGroupBindings>;
  AccordionGroupStyleConfigurations: ResolverTypeWrapper<AccordionGroupStyleConfigurations>;
  AccordionLayout: ResolverTypeWrapper<Omit<AccordionLayout, 'Groups'> & { Groups: Array<ResolversTypes['AccordionGroup']> }>;
  AccordionLayoutBindings: ResolverTypeWrapper<AccordionLayoutBindings>;
  Action: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Action']>;
  ActionEditor: ResolverTypeWrapper<Omit<ActionEditor, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  ActionEditorBindings: ResolverTypeWrapper<ActionEditorBindings>;
  Adornment: ResolverTypeWrapper<Adornment>;
  Analytics: ResolverTypeWrapper<Analytics>;
  AnalyticsBindings: ResolverTypeWrapper<AnalyticsBindings>;
  AppBar: ResolverTypeWrapper<Omit<AppBar, 'Menu'> & { Menu?: Maybe<ResolversTypes['Menu']> }>;
  AppBarBindings: ResolverTypeWrapper<AppBarBindings>;
  AppCategory: AppCategory;
  AppRating: AppRating;
  AppSubCategory: AppSubCategory;
  Attribute: ResolverTypeWrapper<Attribute>;
  AttributeType: AttributeType;
  Audio: ResolverTypeWrapper<Scalars['Audio']['output']>;
  AudioPlayer: ResolverTypeWrapper<AudioPlayer>;
  AudioPlayerBindings: ResolverTypeWrapper<AudioPlayerBindings>;
  AudioRecorder: ResolverTypeWrapper<AudioRecorder>;
  AudioRecorderBindings: ResolverTypeWrapper<AudioRecorderBindings>;
  Avatar: ResolverTypeWrapper<Omit<Avatar, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  AvatarBindings: ResolverTypeWrapper<AvatarBindings>;
  BasicInput: ResolverTypeWrapper<BasicInput>;
  BecomeUser: ResolverTypeWrapper<BecomeUser>;
  BecomeUserBindings: ResolverTypeWrapper<BecomeUserBindings>;
  BindingEditor: ResolverTypeWrapper<BindingEditor>;
  BindingsDictionary: ResolverTypeWrapper<Scalars['BindingsDictionary']['output']>;
  BookmarkId: ResolverTypeWrapper<Scalars['BookmarkId']['output']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BooleanFormat: ResolverTypeWrapper<BooleanFormat>;
  Button: ResolverTypeWrapper<Omit<Button, 'Actions' | 'ContextMenu'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ContextMenu?: Maybe<ResolversTypes['ContextMenu']> }>;
  ButtonBindings: ResolverTypeWrapper<ButtonBindings>;
  ButtonGroup: ResolverTypeWrapper<Omit<ButtonGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  ButtonGroupBindings: ResolverTypeWrapper<ButtonGroupBindings>;
  ButtonStyleConfigurations: ResolverTypeWrapper<ButtonStyleConfigurations>;
  CallPhone: ResolverTypeWrapper<CallPhone>;
  CallPhoneBindings: ResolverTypeWrapper<CallPhoneBindings>;
  CallService: ResolverTypeWrapper<CallService>;
  CallServiceBindings: ResolverTypeWrapper<CallServiceBindings>;
  Cardinality: Cardinality;
  Chart: ResolverTypeWrapper<Chart>;
  ChartBindings: ResolverTypeWrapper<ChartBindings>;
  ChartField: ResolverTypeWrapper<ChartField>;
  ChartMetadata: ResolverTypeWrapper<Scalars['ChartMetadata']['output']>;
  Checkbox: ResolverTypeWrapper<Omit<Checkbox, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  CheckboxBindings: ResolverTypeWrapper<CheckboxBindings>;
  CheckboxStyleConfigurations: ResolverTypeWrapper<CheckboxStyleConfigurations>;
  CircularProgress: ResolverTypeWrapper<CircularProgress>;
  CircularProgressBindings: ResolverTypeWrapper<CircularProgressBindings>;
  CircularProgressVariant: CircularProgressVariant;
  ClassSet: ResolverTypeWrapper<Scalars['ClassSet']['output']>;
  ClearForm: ResolverTypeWrapper<ClearForm>;
  CloseContextMenu: ResolverTypeWrapper<CloseContextMenu>;
  CloseContextMenuBindings: ResolverTypeWrapper<CloseContextMenuBindings>;
  CloseModalPopup: ResolverTypeWrapper<CloseModalPopup>;
  CodeEditor: ResolverTypeWrapper<CodeEditor>;
  CodeEditorBindings: ResolverTypeWrapper<CodeEditorBindings>;
  CodeEditorOptions: ResolverTypeWrapper<Scalars['CodeEditorOptions']['output']>;
  Command: ResolverTypeWrapper<Omit<Command, 'Instruction' | 'Parameters'> & { Instruction?: Maybe<ResolversTypes['IInstruction']>, Parameters?: Maybe<Array<Maybe<ResolversTypes['IParameterWithValues']>>> }>;
  CommandSet: ResolverTypeWrapper<Omit<CommandSet, 'Commands'> & { Commands?: Maybe<Array<Maybe<ResolversTypes['Command']>>> }>;
  Component: ResolverTypeWrapper<Omit<Component, 'Actions' | 'ComponentContainer' | 'HeaderItems' | 'ModalPopups' | 'ServiceSnapshots' | 'Services' | 'SharingInfo'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ComponentContainer?: Maybe<ResolversTypes['Container']>, HeaderItems?: Maybe<Array<ResolversTypes['LayoutItem']>>, ModalPopups?: Maybe<Array<Maybe<ResolversTypes['Dialog']>>>, ServiceSnapshots?: Maybe<Array<Maybe<ResolversTypes['Service']>>>, Services?: Maybe<Array<Maybe<ResolversTypes['Service']>>>, SharingInfo?: Maybe<ResolversTypes['SharingInfo']> }>;
  ComponentBindings: ResolverTypeWrapper<ComponentBindings>;
  ComponentId: ResolverTypeWrapper<Scalars['ComponentId']['output']>;
  ComponentLibrary: ResolverTypeWrapper<Omit<ComponentLibrary, 'Actions' | 'Components'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, Components: Array<Maybe<ResolversTypes['LibraryItem']>> }>;
  ComponentLibraryBindings: ResolverTypeWrapper<ComponentLibraryBindings>;
  ConfigurationEditor: ResolverTypeWrapper<ConfigurationEditor>;
  ConfigurationEditorBindings: ResolverTypeWrapper<ConfigurationEditorBindings>;
  Container: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Container']>;
  ContextAutocomplete: ResolverTypeWrapper<Omit<ContextAutocomplete, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  ContextAutocompleteBindings: ResolverTypeWrapper<ContextAutocompleteBindings>;
  ContextMenu: ResolverTypeWrapper<Omit<ContextMenu, 'Bindings' | 'Content'> & { Bindings?: Maybe<ResolversTypes['ContextMenuBindings']>, Content: ResolversTypes['LayoutItem'] }>;
  ContextMenuBindings: ResolverTypeWrapper<ContextMenuBindings>;
  ContextMenuId: ResolverTypeWrapper<Scalars['ContextMenuId']['output']>;
  Control: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Control']>;
  CopyToClipboard: ResolverTypeWrapper<CopyToClipboard>;
  CopyToClipboardBindings: ResolverTypeWrapper<CopyToClipboardBindings>;
  Country: ResolverTypeWrapper<Country>;
  CssClass: ResolverTypeWrapper<CssClass>;
  CssObject: ResolverTypeWrapper<Scalars['CssObject']['output']>;
  CssParamsBindings: ResolverTypeWrapper<Scalars['CssParamsBindings']['output']>;
  CustomLabel: ResolverTypeWrapper<CustomLabel>;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateFormat: ResolverTypeWrapper<DateFormat>;
  DatePicker: ResolverTypeWrapper<DatePicker>;
  DatePickerBindings: ResolverTypeWrapper<DatePickerBindings>;
  DatePickerStyleConfigurations: ResolverTypeWrapper<DatePickerStyleConfigurations>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DateTimePicker: ResolverTypeWrapper<DateTimePicker>;
  DateTimePickerBindings: ResolverTypeWrapper<DateTimePickerBindings>;
  Dialog: ResolverTypeWrapper<Omit<Dialog, 'Actions' | 'CommandSetOnCancel' | 'CommandSetOnClose' | 'CommandSetOnOk' | 'ContentContainer' | 'FooterContainer' | 'HeaderItem'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, CommandSetOnCancel?: Maybe<ResolversTypes['CommandSet']>, CommandSetOnClose?: Maybe<ResolversTypes['CommandSet']>, CommandSetOnOk?: Maybe<ResolversTypes['CommandSet']>, ContentContainer?: Maybe<ResolversTypes['Container']>, FooterContainer?: Maybe<ResolversTypes['Container']>, HeaderItem?: Maybe<ResolversTypes['LayoutItem']> }>;
  DialogBindings: ResolverTypeWrapper<DialogBindings>;
  Document: ResolverTypeWrapper<Scalars['Document']['output']>;
  DocumentViewer: ResolverTypeWrapper<Omit<DocumentViewer, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  DocumentViewerBindings: ResolverTypeWrapper<DocumentViewerBindings>;
  DocumentViewerStyleConfigurations: ResolverTypeWrapper<DocumentViewerStyleConfigurations>;
  Drawer: ResolverTypeWrapper<Omit<Drawer, 'Content'> & { Content?: Maybe<ResolversTypes['Page']> }>;
  DropDownButton: ResolverTypeWrapper<DropDownButton>;
  Entity: ResolverTypeWrapper<Entity>;
  EventData: ResolverTypeWrapper<Scalars['EventData']['output']>;
  Feature: ResolverTypeWrapper<Omit<Feature, 'Actions' | 'Features'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, Features?: Maybe<Array<ResolversTypes['Feature']>> }>;
  FeatureBindings: ResolverTypeWrapper<FeatureBindings>;
  Feed: ResolverTypeWrapper<Omit<Feed, 'Components' | 'FeedFooter' | 'FeedHeader' | 'ReviewDialogOptions'> & { Components?: Maybe<Array<ResolversTypes['Component']>>, FeedFooter?: Maybe<ResolversTypes['LayoutItem']>, FeedHeader?: Maybe<ResolversTypes['LayoutItem']>, ReviewDialogOptions?: Maybe<ResolversTypes['ReviewDialog']> }>;
  FeedBindings: ResolverTypeWrapper<FeedBindings>;
  FieldFormat: ResolverTypeWrapper<FieldFormat>;
  FieldList: ResolverTypeWrapper<FieldList>;
  FieldType: FieldType;
  FieldValueExpression: ResolverTypeWrapper<Scalars['FieldValueExpression']['output']>;
  FileList: ResolverTypeWrapper<FileList>;
  FileListBindings: ResolverTypeWrapper<FileListBindings>;
  FileUpload: ResolverTypeWrapper<FileUpload>;
  FileUploadBindings: ResolverTypeWrapper<FileUploadBindings>;
  FilterCriteria: FilterCriteria;
  FilterParams: ResolverTypeWrapper<FilterParams>;
  FinApp: ResolverTypeWrapper<Omit<FinApp, 'Actions' | 'Elements' | 'UserPrefs'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, Elements?: Maybe<ResolversTypes['Service']>, UserPrefs?: Maybe<ResolversTypes['Service']> }>;
  FinAppBindings: ResolverTypeWrapper<FinAppBindings>;
  FinAppStyleConfigurations: ResolverTypeWrapper<FinAppStyleConfigurations>;
  FlexLayout: ResolverTypeWrapper<Omit<FlexLayout, 'InnerLayouts' | 'LayoutItem'> & { InnerLayouts?: Maybe<Array<Maybe<ResolversTypes['Layout']>>>, LayoutItem?: Maybe<ResolversTypes['LayoutItem']> }>;
  FlexLayoutBindings: ResolverTypeWrapper<FlexLayoutBindings>;
  FlexLayoutItem: ResolverTypeWrapper<Scalars['FlexLayoutItem']['output']>;
  FlexProperties: ResolverTypeWrapper<FlexProperties>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  Form: ResolverTypeWrapper<Omit<Form, 'Actions' | 'Items' | 'Layout'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, Items?: Maybe<Array<ResolversTypes['LayoutItem']>>, Layout?: Maybe<ResolversTypes['Layout']> }>;
  FormBindings: ResolverTypeWrapper<FormBindings>;
  FormId: ResolverTypeWrapper<Scalars['FormId']['output']>;
  FormStyleConfigurations: ResolverTypeWrapper<FormStyleConfigurations>;
  FormatName: ResolverTypeWrapper<Scalars['FormatName']['output']>;
  Formats: ResolverTypeWrapper<Scalars['Formats']['output']>;
  FragmentLayout: ResolverTypeWrapper<FragmentLayout>;
  FragmentLayoutBindings: ResolverTypeWrapper<FragmentLayoutBindings>;
  FreeFormLayout: ResolverTypeWrapper<FreeFormLayout>;
  FreeFormLayoutBindings: ResolverTypeWrapper<FreeFormLayoutBindings>;
  GenerateCode: ResolverTypeWrapper<GenerateCode>;
  GoBack: ResolverTypeWrapper<GoBack>;
  GoToBookmark: ResolverTypeWrapper<GoToBookmark>;
  GoToBookmarkBindings: ResolverTypeWrapper<GoToBookmarkBindings>;
  GoToPage: ResolverTypeWrapper<GoToPage>;
  GoToPageBindings: ResolverTypeWrapper<GoToPageBindings>;
  GoogleAnalytics: ResolverTypeWrapper<GoogleAnalytics>;
  GridEditor: ResolverTypeWrapper<GridEditor>;
  GridEditorBindings: ResolverTypeWrapper<GridEditorBindings>;
  GridStackLayout: ResolverTypeWrapper<Omit<GridStackLayout, 'Actions' | 'InnerLayouts' | 'LayoutItem'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, InnerLayouts?: Maybe<Array<Maybe<ResolversTypes['Layout']>>>, LayoutItem?: Maybe<ResolversTypes['LayoutItem']> }>;
  GroupProp: GroupProp;
  Html: ResolverTypeWrapper<Html>;
  HtmlBindings: ResolverTypeWrapper<HtmlBindings>;
  IActionTrigger: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['IActionTrigger']>;
  IApplication: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['IApplication']>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  IDesignable: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['IDesignable']>;
  IEditable: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['IEditable']>;
  IField: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['IField']>;
  IFrame: ResolverTypeWrapper<IFrame>;
  IFrameBindings: ResolverTypeWrapper<IFrameBindings>;
  IInstruction: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['IInstruction']>;
  IParameter: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['IParameter']>;
  IParameterWithValues: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['IParameterWithValues']>;
  ISelectFromList: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ISelectFromList']>;
  Icon: ResolverTypeWrapper<Icon>;
  IconBindings: ResolverTypeWrapper<IconBindings>;
  IconSelector: ResolverTypeWrapper<IconSelector>;
  IconSelectorBindings: ResolverTypeWrapper<IconSelectorBindings>;
  IconStyleConfigurations: ResolverTypeWrapper<IconStyleConfigurations>;
  Image: ResolverTypeWrapper<Omit<Image, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  ImageBindings: ResolverTypeWrapper<ImageBindings>;
  InputBinding: ResolverTypeWrapper<Scalars['InputBinding']['output']>;
  InputData: ResolverTypeWrapper<InputData>;
  InputField: ResolverTypeWrapper<Omit<InputField, 'Actions' | 'ContextAutocomplete'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ContextAutocomplete?: Maybe<ResolversTypes['ContextAutocomplete']> }>;
  InputFieldBindings: ResolverTypeWrapper<InputFieldBindings>;
  InputFieldStyleConfigurations: ResolverTypeWrapper<InputFieldStyleConfigurations>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  JsonView: ResolverTypeWrapper<JsonView>;
  JsonViewBindings: ResolverTypeWrapper<JsonViewBindings>;
  Label: ResolverTypeWrapper<Omit<Label, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  LabelBindings: ResolverTypeWrapper<LabelBindings>;
  LabelStyleConfigurations: ResolverTypeWrapper<LabelStyleConfigurations>;
  Language: Language;
  Layout: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Layout']>;
  LayoutItem: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['LayoutItem']>;
  LayoutItemId: ResolverTypeWrapper<Scalars['LayoutItemId']['output']>;
  LibraryItem: ResolverTypeWrapper<Omit<LibraryItem, 'Template'> & { Template?: Maybe<ResolversTypes['LayoutItem']> }>;
  LinearLayout: ResolverTypeWrapper<Omit<LinearLayout, 'InnerLayouts' | 'LayoutItem'> & { InnerLayouts?: Maybe<Array<Maybe<ResolversTypes['Layout']>>>, LayoutItem?: Maybe<ResolversTypes['LayoutItem']> }>;
  LinearProgress: ResolverTypeWrapper<LinearProgress>;
  LinearProgressBindings: ResolverTypeWrapper<LinearProgressBindings>;
  LinearProgressVariant: LinearProgressVariant;
  Link: ResolverTypeWrapper<Link>;
  LinkBindings: ResolverTypeWrapper<LinkBindings>;
  List: ResolverTypeWrapper<Omit<List, 'Actions' | 'Columns' | 'Items' | 'ListColumns' | 'Service' | 'Toolbar'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, Columns?: Maybe<Array<ResolversTypes['ListColumn']>>, Items?: Maybe<Array<Maybe<ResolversTypes['LayoutItem']>>>, ListColumns?: Maybe<Array<ResolversTypes['ListColumn']>>, Service?: Maybe<ResolversTypes['Service']>, Toolbar?: Maybe<ResolversTypes['ListToolbar']> }>;
  ListAndChartLabels: ResolverTypeWrapper<ListAndChartLabels>;
  ListBindings: ResolverTypeWrapper<ListBindings>;
  ListClearAllButton: ResolverTypeWrapper<Omit<ListClearAllButton, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  ListClearAllButtonBindings: ResolverTypeWrapper<ListClearAllButtonBindings>;
  ListColumn: ResolverTypeWrapper<Omit<ListColumn, 'Actions' | 'CellLayout' | 'CellRendererItems'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, CellLayout?: Maybe<ResolversTypes['LayoutItem']>, CellRendererItems?: Maybe<Array<Maybe<ResolversTypes['LayoutItem']>>> }>;
  ListColumnBindings: ResolverTypeWrapper<ListColumnBindings>;
  ListColumnStyleConfigurations: ResolverTypeWrapper<ListColumnStyleConfigurations>;
  ListExportButton: ResolverTypeWrapper<ListExportButton>;
  ListExportButtonBindings: ResolverTypeWrapper<ListExportButtonBindings>;
  ListPageInfo: ResolverTypeWrapper<ListPageInfo>;
  ListQuickFilter: ResolverTypeWrapper<Omit<ListQuickFilter, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  ListQuickFilterBindings: ResolverTypeWrapper<ListQuickFilterBindings>;
  ListStyleConfigurations: ResolverTypeWrapper<ListStyleConfigurations>;
  ListToolbar: ResolverTypeWrapper<Omit<ListToolbar, 'Items'> & { Items?: Maybe<Array<ResolversTypes['Button']>> }>;
  LocalizedAppInfo: ResolverTypeWrapper<LocalizedAppInfo>;
  Login: ResolverTypeWrapper<Login>;
  LoginBindings: ResolverTypeWrapper<LoginBindings>;
  LoginPage: ResolverTypeWrapper<Omit<LoginPage, 'BackgroundImage' | 'LoginButtonImage' | 'Logo' | 'SocialLoginButtons'> & { BackgroundImage: ResolversTypes['Image'], LoginButtonImage: ResolversTypes['Image'], Logo: ResolversTypes['Image'], SocialLoginButtons?: Maybe<Array<Maybe<ResolversTypes['SocialLoginButton']>>> }>;
  Logout: ResolverTypeWrapper<Logout>;
  Mapping: ResolverTypeWrapper<Mapping>;
  MarkFrequency: ResolverTypeWrapper<MarkFrequency>;
  Markdown: ResolverTypeWrapper<Markdown>;
  MarkdownBindings: ResolverTypeWrapper<MarkdownBindings>;
  Menu: ResolverTypeWrapper<Omit<Menu, 'Bindings' | 'Features'> & { Bindings?: Maybe<ResolversTypes['MenuBindings']>, Features: Array<Maybe<ResolversTypes['Feature']>> }>;
  MenuBindings: ResolverTypeWrapper<MenuBindings>;
  Method: ResolverTypeWrapper<Scalars['Method']['output']>;
  ModalPopupEditor: ResolverTypeWrapper<ModalPopupEditor>;
  ModalPopupEditorBindings: ResolverTypeWrapper<ModalPopupEditorBindings>;
  Model: ResolverTypeWrapper<Model>;
  MultiFilter: ResolverTypeWrapper<Omit<MultiFilter, 'Actions' | 'Fields' | 'Items'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, Fields?: Maybe<Array<Maybe<ResolversTypes['IField']>>>, Items?: Maybe<Array<ResolversTypes['LayoutItem']>> }>;
  MultiFilterBindings: ResolverTypeWrapper<MultiFilterBindings>;
  MultiSelect: ResolverTypeWrapper<Omit<MultiSelect, 'Actions' | 'ServiceList'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ServiceList?: Maybe<ResolversTypes['ServiceList']> }>;
  MultiSelectBindings: ResolverTypeWrapper<MultiSelectBindings>;
  MultiSelectObject: ResolverTypeWrapper<Scalars['MultiSelectObject']['output']>;
  MultiSelectStyleConfigurations: ResolverTypeWrapper<MultiSelectStyleConfigurations>;
  NativeApplication: ResolverTypeWrapper<Omit<NativeApplication, 'Icon' | 'Screenshots'> & { Icon: ResolversTypes['Image'], Screenshots: Array<Maybe<ResolversTypes['Image']>> }>;
  NumberFormat: ResolverTypeWrapper<NumberFormat>;
  OpenContextMenu: ResolverTypeWrapper<OpenContextMenu>;
  OpenContextMenuBindings: ResolverTypeWrapper<OpenContextMenuBindings>;
  OpenModalPopup: ResolverTypeWrapper<OpenModalPopup>;
  Overlay: ResolverTypeWrapper<Omit<Overlay, 'Actions' | 'Items'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, Items?: Maybe<Array<ResolversTypes['LayoutItem']>> }>;
  OverlayBindings: ResolverTypeWrapper<OverlayBindings>;
  Page: ResolverTypeWrapper<Omit<Page, 'Actions' | 'Context' | 'Items' | 'Layout' | 'ModalPopups' | 'PageTemplate' | 'Services'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, Context?: Maybe<Array<Maybe<ResolversTypes['IField']>>>, Items?: Maybe<Array<ResolversTypes['LayoutItem']>>, Layout?: Maybe<ResolversTypes['Layout']>, ModalPopups?: Maybe<Array<Maybe<ResolversTypes['Dialog']>>>, PageTemplate?: Maybe<ResolversTypes['PageTemplate']>, Services?: Maybe<Array<Maybe<ResolversTypes['Service']>>> }>;
  PageBindings: ResolverTypeWrapper<PageBindings>;
  PageTemplate: ResolverTypeWrapper<Omit<PageTemplate, 'BottomAppBar' | 'Footer' | 'Header' | 'LeftSidebar' | 'RightSidebar' | 'TopAppBar'> & { BottomAppBar?: Maybe<ResolversTypes['AppBar']>, Footer?: Maybe<ResolversTypes['Drawer']>, Header?: Maybe<ResolversTypes['Drawer']>, LeftSidebar?: Maybe<ResolversTypes['Drawer']>, RightSidebar?: Maybe<ResolversTypes['Drawer']>, TopAppBar?: Maybe<ResolversTypes['AppBar']> }>;
  Paper: ResolverTypeWrapper<Paper>;
  ParameterType: ParameterType;
  PasteFromClipboard: ResolverTypeWrapper<PasteFromClipboard>;
  Position: ResolverTypeWrapper<Position>;
  PropertiesEditor: ResolverTypeWrapper<Omit<PropertiesEditor, 'Actions' | 'HeaderItems'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, HeaderItems?: Maybe<Array<ResolversTypes['LayoutItem']>> }>;
  PropertiesEditorBindings: ResolverTypeWrapper<PropertiesEditorBindings>;
  ProportionalBar: ResolverTypeWrapper<ProportionalBar>;
  ProportionalBarBindings: ResolverTypeWrapper<ProportionalBarBindings>;
  Query: ResolverTypeWrapper<{}>;
  RadioGroup: ResolverTypeWrapper<Omit<RadioGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  RadioGroupBindings: ResolverTypeWrapper<RadioGroupBindings>;
  Reference: ResolverTypeWrapper<Omit<Reference, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  ReferenceBindings: ResolverTypeWrapper<ReferenceBindings>;
  ReferenceStyleConfigurations: ResolverTypeWrapper<ReferenceStyleConfigurations>;
  RefreshGrid: ResolverTypeWrapper<Scalars['RefreshGrid']['output']>;
  ReloadPage: ResolverTypeWrapper<ReloadPage>;
  Repeater: ResolverTypeWrapper<Omit<Repeater, 'Content' | 'Details' | 'Header' | 'Items' | 'Layout' | 'Title'> & { Content?: Maybe<ResolversTypes['Form']>, Details?: Maybe<ResolversTypes['Form']>, Header?: Maybe<ResolversTypes['LayoutItem']>, Items?: Maybe<Array<ResolversTypes['LayoutItem']>>, Layout?: Maybe<ResolversTypes['Layout']>, Title?: Maybe<ResolversTypes['LayoutItem']> }>;
  RepeaterBindings: ResolverTypeWrapper<RepeaterBindings>;
  RepeaterStyleConfigurations: ResolverTypeWrapper<RepeaterStyleConfigurations>;
  ResizableProperties: ResolverTypeWrapper<ResizableProperties>;
  ResolutionButtons: ResolverTypeWrapper<ResolutionButtons>;
  ResolutionButtonsBindings: ResolverTypeWrapper<ResolutionButtonsBindings>;
  ResponsiveProperty: ResolverTypeWrapper<Scalars['ResponsiveProperty']['output']>;
  ResponsivePropertyObject: ResolverTypeWrapper<ResponsivePropertyObject>;
  ReviewDialog: ResolverTypeWrapper<Omit<ReviewDialog, 'Actions' | 'Data' | 'Item'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, Data?: Maybe<ResolversTypes['ReviewDialogData']>, Item?: Maybe<ResolversTypes['LayoutItem']> }>;
  ReviewDialogBindings: ResolverTypeWrapper<ReviewDialogBindings>;
  ReviewDialogData: ResolverTypeWrapper<Omit<ReviewDialogData, 'Item' | 'Notes'> & { Item?: Maybe<ResolversTypes['LayoutItem']>, Notes?: Maybe<Array<Maybe<ResolversTypes['ReviewNote']>>> }>;
  ReviewNote: ResolverTypeWrapper<Omit<ReviewNote, 'Screenshot'> & { Screenshot?: Maybe<ResolversTypes['Image']> }>;
  RichTextEditor: ResolverTypeWrapper<Omit<RichTextEditor, 'Actions' | 'ContextAutocomplete'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ContextAutocomplete?: Maybe<ResolversTypes['ContextAutocomplete']> }>;
  RichTextEditorBindings: ResolverTypeWrapper<RichTextEditorBindings>;
  RichTextEditorStyleConfigurations: ResolverTypeWrapper<RichTextEditorStyleConfigurations>;
  RichTreeList: ResolverTypeWrapper<RichTreeList>;
  RichTreeListBindings: ResolverTypeWrapper<RichTreeListBindings>;
  SampleData: ResolverTypeWrapper<Scalars['SampleData']['output']>;
  ScrollToTop: ResolverTypeWrapper<ScrollToTop>;
  SendEmail: ResolverTypeWrapper<SendEmail>;
  SendEmailBindings: ResolverTypeWrapper<SendEmailBindings>;
  SendMessageToChild: ResolverTypeWrapper<SendMessageToChild>;
  SendMessageToChildBindings: ResolverTypeWrapper<SendMessageToChildBindings>;
  SendMessageToParent: ResolverTypeWrapper<SendMessageToParent>;
  SendSMS: ResolverTypeWrapper<SendSms>;
  SendSMSBindings: ResolverTypeWrapper<SendSmsBindings>;
  Service: ResolverTypeWrapper<Omit<Service, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  ServiceBinding: ResolverTypeWrapper<Scalars['ServiceBinding']['output']>;
  ServiceField: ResolverTypeWrapper<ServiceField>;
  ServiceFieldBindings: ResolverTypeWrapper<ServiceFieldBindings>;
  ServiceLibrary: ResolverTypeWrapper<Omit<ServiceLibrary, 'ServiceSets'> & { ServiceSets?: Maybe<Array<Maybe<ResolversTypes['ServiceSet']>>> }>;
  ServiceLibraryBindings: ResolverTypeWrapper<ServiceLibraryBindings>;
  ServiceList: ResolverTypeWrapper<Omit<ServiceList, 'Fields'> & { Fields?: Maybe<Array<Maybe<ResolversTypes['IField']>>> }>;
  ServiceSet: ResolverTypeWrapper<Omit<ServiceSet, 'LibraryServices'> & { LibraryServices?: Maybe<Array<Maybe<ResolversTypes['Service']>>> }>;
  ServiceSnapshotOptions: ResolverTypeWrapper<ServiceSnapshotOptions>;
  ServiceSnapshotOptionsDictionary: ResolverTypeWrapper<Scalars['ServiceSnapshotOptionsDictionary']['output']>;
  SetState: ResolverTypeWrapper<SetState>;
  Share: ResolverTypeWrapper<Omit<Share, 'Component'> & { Component?: Maybe<ResolversTypes['Component']> }>;
  ShareBindings: ResolverTypeWrapper<ShareBindings>;
  ShareDialog: ResolverTypeWrapper<Omit<ShareDialog, 'Data'> & { Data?: Maybe<ResolversTypes['ShareDialogData']> }>;
  ShareDialogBindings: ResolverTypeWrapper<ShareDialogBindings>;
  ShareDialogData: ResolverTypeWrapper<Omit<ShareDialogData, 'Item'> & { Item?: Maybe<ResolversTypes['LayoutItem']> }>;
  ShareSource: ResolverTypeWrapper<ShareSource>;
  SharingInfo: ResolverTypeWrapper<Omit<SharingInfo, 'ServiceSnapshots'> & { ServiceSnapshots?: Maybe<Array<Maybe<ResolversTypes['Service']>>> }>;
  SharingOptions: ResolverTypeWrapper<SharingOptions>;
  ShowMessage: ResolverTypeWrapper<ShowMessage>;
  ShowMessageBindings: ResolverTypeWrapper<ShowMessageBindings>;
  ShowToast: ResolverTypeWrapper<ShowToast>;
  SimpleContainer: ResolverTypeWrapper<Omit<SimpleContainer, 'Actions' | 'Context' | 'Items' | 'Layout' | 'ReviewDialogOptions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, Context?: Maybe<Array<Maybe<ResolversTypes['IField']>>>, Items?: Maybe<Array<ResolversTypes['LayoutItem']>>, Layout?: Maybe<ResolversTypes['Layout']>, ReviewDialogOptions?: Maybe<ResolversTypes['ReviewDialog']> }>;
  SimpleContainerBindings: ResolverTypeWrapper<SimpleContainerBindings>;
  SimpleContainerStyleConfigurations: ResolverTypeWrapper<SimpleContainerStyleConfigurations>;
  SingleMapping: ResolverTypeWrapper<Scalars['SingleMapping']['output']>;
  SiteConfiguration: ResolverTypeWrapper<SiteConfiguration>;
  SiteSettings: ResolverTypeWrapper<SiteSettings>;
  Slider: ResolverTypeWrapper<Omit<Slider, 'ValueLabelItem'> & { ValueLabelItem?: Maybe<ResolversTypes['LayoutItem']> }>;
  SliderBindings: ResolverTypeWrapper<SliderBindings>;
  SliderMarks: ResolverTypeWrapper<Scalars['SliderMarks']['output']>;
  SliderStyleConfigurations: ResolverTypeWrapper<SliderStyleConfigurations>;
  Slot: ResolverTypeWrapper<Slot>;
  Snackbar: ResolverTypeWrapper<Omit<Snackbar, 'Actions' | 'Button'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, Button?: Maybe<ResolversTypes['Button']> }>;
  SnackbarBindings: ResolverTypeWrapper<SnackbarBindings>;
  SocialLoginButton: ResolverTypeWrapper<Omit<SocialLoginButton, 'Icon'> & { Icon: ResolversTypes['Image'] }>;
  SocialNetwork: SocialNetwork;
  SpreadsheetModeOptions: ResolverTypeWrapper<SpreadsheetModeOptions>;
  State: ResolverTypeWrapper<Scalars['State']['output']>;
  StateInspector: ResolverTypeWrapper<StateInspector>;
  StateInspectorBindings: ResolverTypeWrapper<StateInspectorBindings>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  StringDictionary: ResolverTypeWrapper<Scalars['StringDictionary']['output']>;
  StyleEditor: ResolverTypeWrapper<Omit<StyleEditor, 'Layout'> & { Layout?: Maybe<ResolversTypes['Layout']> }>;
  StyleEditorBindings: ResolverTypeWrapper<StyleEditorBindings>;
  StyleProperties: ResolverTypeWrapper<StyleProperties>;
  StylePropertiesDictionary: ResolverTypeWrapper<Scalars['StylePropertiesDictionary']['output']>;
  StyleSet: ResolverTypeWrapper<Scalars['StyleSet']['output']>;
  Switch: ResolverTypeWrapper<Omit<Switch, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  SwitchBindings: ResolverTypeWrapper<SwitchBindings>;
  SwitchStyleConfigurations: ResolverTypeWrapper<SwitchStyleConfigurations>;
  TabContainer: ResolverTypeWrapper<Omit<TabContainer, 'Actions' | 'Items' | 'ReviewDialogOptions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, Items: Array<ResolversTypes['TabItemOrContainer']>, ReviewDialogOptions?: Maybe<ResolversTypes['ReviewDialog']> }>;
  TabContainerBindings: ResolverTypeWrapper<TabContainerBindings>;
  TabContainerStyleConfigurations: ResolverTypeWrapper<TabContainerStyleConfigurations>;
  TabItem: ResolverTypeWrapper<Omit<TabItem, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  TabItemBindings: ResolverTypeWrapper<TabItemBindings>;
  TabItemOrContainer: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['TabItemOrContainer']>;
  TabItemStyleConfigurations: ResolverTypeWrapper<TabItemStyleConfigurations>;
  TabLayout: ResolverTypeWrapper<Omit<TabLayout, 'ReviewDialogOptions' | 'Tabs'> & { ReviewDialogOptions?: Maybe<ResolversTypes['ReviewDialog']>, Tabs: Array<ResolversTypes['TabItem']> }>;
  TabLayoutBindings: ResolverTypeWrapper<TabLayoutBindings>;
  TableItemProps: ResolverTypeWrapper<TableItemProps>;
  TableLayout: ResolverTypeWrapper<Omit<TableLayout, 'Actions' | 'LayoutItem'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, LayoutItem?: Maybe<ResolversTypes['LayoutItem']> }>;
  TagSet: ResolverTypeWrapper<Scalars['TagSet']['output']>;
  Theme: ResolverTypeWrapper<Theme>;
  TimePicker: ResolverTypeWrapper<TimePicker>;
  TimePickerBindings: ResolverTypeWrapper<TimePickerBindings>;
  TimeZonePicker: ResolverTypeWrapper<TimeZonePicker>;
  TimeZonePickerBindings: ResolverTypeWrapper<TimeZonePickerBindings>;
  Transform: ResolverTypeWrapper<Transform>;
  TransformBindings: ResolverTypeWrapper<TransformBindings>;
  TransformMethodOptions: ResolverTypeWrapper<Scalars['TransformMethodOptions']['output']>;
  TreeKeyConversion: ResolverTypeWrapper<TreeKeyConversion>;
  TreeList: ResolverTypeWrapper<TreeList>;
  TreeListBindings: ResolverTypeWrapper<TreeListBindings>;
  TriggerAction: ResolverTypeWrapper<TriggerAction>;
  TriggerActionBindings: ResolverTypeWrapper<TriggerActionBindings>;
  TriggerPropagation: ResolverTypeWrapper<TriggerPropagation>;
  TypedBindingEditor: ResolverTypeWrapper<TypedBindingEditor>;
  UndoRedoToolbar: ResolverTypeWrapper<Omit<UndoRedoToolbar, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>> }>;
  UndoRedoToolbarBindings: ResolverTypeWrapper<UndoRedoToolbarBindings>;
  User: ResolverTypeWrapper<Scalars['User']['output']>;
  Valid: ResolverTypeWrapper<Valid>;
  ValidationRule: ResolverTypeWrapper<ValidationRule>;
  Video: ResolverTypeWrapper<Scalars['Video']['output']>;
  ViewMode: ViewMode;
  VisibleMenu: ResolverTypeWrapper<VisibleMenu>;
  VisibleMenuBindings: ResolverTypeWrapper<VisibleMenuBindings>;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  AIDialog: AiDialog;
  AIDialogBindings: AiDialogBindings;
  AccordionGroup: Omit<AccordionGroup, 'Actions' | 'Header'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, Header?: Maybe<ResolversParentTypes['LayoutItem']> };
  AccordionGroupBindings: AccordionGroupBindings;
  AccordionGroupStyleConfigurations: AccordionGroupStyleConfigurations;
  AccordionLayout: Omit<AccordionLayout, 'Groups'> & { Groups: Array<ResolversParentTypes['AccordionGroup']> };
  AccordionLayoutBindings: AccordionLayoutBindings;
  Action: ResolversUnionTypes<ResolversParentTypes>['Action'];
  ActionEditor: Omit<ActionEditor, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  ActionEditorBindings: ActionEditorBindings;
  Adornment: Adornment;
  Analytics: Analytics;
  AnalyticsBindings: AnalyticsBindings;
  AppBar: Omit<AppBar, 'Menu'> & { Menu?: Maybe<ResolversParentTypes['Menu']> };
  AppBarBindings: AppBarBindings;
  Attribute: Attribute;
  Audio: Scalars['Audio']['output'];
  AudioPlayer: AudioPlayer;
  AudioPlayerBindings: AudioPlayerBindings;
  AudioRecorder: AudioRecorder;
  AudioRecorderBindings: AudioRecorderBindings;
  Avatar: Omit<Avatar, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  AvatarBindings: AvatarBindings;
  BasicInput: BasicInput;
  BecomeUser: BecomeUser;
  BecomeUserBindings: BecomeUserBindings;
  BindingEditor: BindingEditor;
  BindingsDictionary: Scalars['BindingsDictionary']['output'];
  BookmarkId: Scalars['BookmarkId']['output'];
  Boolean: Scalars['Boolean']['output'];
  BooleanFormat: BooleanFormat;
  Button: Omit<Button, 'Actions' | 'ContextMenu'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, ContextMenu?: Maybe<ResolversParentTypes['ContextMenu']> };
  ButtonBindings: ButtonBindings;
  ButtonGroup: Omit<ButtonGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  ButtonGroupBindings: ButtonGroupBindings;
  ButtonStyleConfigurations: ButtonStyleConfigurations;
  CallPhone: CallPhone;
  CallPhoneBindings: CallPhoneBindings;
  CallService: CallService;
  CallServiceBindings: CallServiceBindings;
  Chart: Chart;
  ChartBindings: ChartBindings;
  ChartField: ChartField;
  ChartMetadata: Scalars['ChartMetadata']['output'];
  Checkbox: Omit<Checkbox, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  CheckboxBindings: CheckboxBindings;
  CheckboxStyleConfigurations: CheckboxStyleConfigurations;
  CircularProgress: CircularProgress;
  CircularProgressBindings: CircularProgressBindings;
  ClassSet: Scalars['ClassSet']['output'];
  ClearForm: ClearForm;
  CloseContextMenu: CloseContextMenu;
  CloseContextMenuBindings: CloseContextMenuBindings;
  CloseModalPopup: CloseModalPopup;
  CodeEditor: CodeEditor;
  CodeEditorBindings: CodeEditorBindings;
  CodeEditorOptions: Scalars['CodeEditorOptions']['output'];
  Command: Omit<Command, 'Instruction' | 'Parameters'> & { Instruction?: Maybe<ResolversParentTypes['IInstruction']>, Parameters?: Maybe<Array<Maybe<ResolversParentTypes['IParameterWithValues']>>> };
  CommandSet: Omit<CommandSet, 'Commands'> & { Commands?: Maybe<Array<Maybe<ResolversParentTypes['Command']>>> };
  Component: Omit<Component, 'Actions' | 'ComponentContainer' | 'HeaderItems' | 'ModalPopups' | 'ServiceSnapshots' | 'Services' | 'SharingInfo'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, ComponentContainer?: Maybe<ResolversParentTypes['Container']>, HeaderItems?: Maybe<Array<ResolversParentTypes['LayoutItem']>>, ModalPopups?: Maybe<Array<Maybe<ResolversParentTypes['Dialog']>>>, ServiceSnapshots?: Maybe<Array<Maybe<ResolversParentTypes['Service']>>>, Services?: Maybe<Array<Maybe<ResolversParentTypes['Service']>>>, SharingInfo?: Maybe<ResolversParentTypes['SharingInfo']> };
  ComponentBindings: ComponentBindings;
  ComponentId: Scalars['ComponentId']['output'];
  ComponentLibrary: Omit<ComponentLibrary, 'Actions' | 'Components'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, Components: Array<Maybe<ResolversParentTypes['LibraryItem']>> };
  ComponentLibraryBindings: ComponentLibraryBindings;
  ConfigurationEditor: ConfigurationEditor;
  ConfigurationEditorBindings: ConfigurationEditorBindings;
  Container: ResolversUnionTypes<ResolversParentTypes>['Container'];
  ContextAutocomplete: Omit<ContextAutocomplete, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  ContextAutocompleteBindings: ContextAutocompleteBindings;
  ContextMenu: Omit<ContextMenu, 'Bindings' | 'Content'> & { Bindings?: Maybe<ResolversParentTypes['ContextMenuBindings']>, Content: ResolversParentTypes['LayoutItem'] };
  ContextMenuBindings: ContextMenuBindings;
  ContextMenuId: Scalars['ContextMenuId']['output'];
  Control: ResolversUnionTypes<ResolversParentTypes>['Control'];
  CopyToClipboard: CopyToClipboard;
  CopyToClipboardBindings: CopyToClipboardBindings;
  Country: Country;
  CssClass: CssClass;
  CssObject: Scalars['CssObject']['output'];
  CssParamsBindings: Scalars['CssParamsBindings']['output'];
  CustomLabel: CustomLabel;
  Date: Scalars['Date']['output'];
  DateFormat: DateFormat;
  DatePicker: DatePicker;
  DatePickerBindings: DatePickerBindings;
  DatePickerStyleConfigurations: DatePickerStyleConfigurations;
  DateTime: Scalars['DateTime']['output'];
  DateTimePicker: DateTimePicker;
  DateTimePickerBindings: DateTimePickerBindings;
  Dialog: Omit<Dialog, 'Actions' | 'CommandSetOnCancel' | 'CommandSetOnClose' | 'CommandSetOnOk' | 'ContentContainer' | 'FooterContainer' | 'HeaderItem'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, CommandSetOnCancel?: Maybe<ResolversParentTypes['CommandSet']>, CommandSetOnClose?: Maybe<ResolversParentTypes['CommandSet']>, CommandSetOnOk?: Maybe<ResolversParentTypes['CommandSet']>, ContentContainer?: Maybe<ResolversParentTypes['Container']>, FooterContainer?: Maybe<ResolversParentTypes['Container']>, HeaderItem?: Maybe<ResolversParentTypes['LayoutItem']> };
  DialogBindings: DialogBindings;
  Document: Scalars['Document']['output'];
  DocumentViewer: Omit<DocumentViewer, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  DocumentViewerBindings: DocumentViewerBindings;
  DocumentViewerStyleConfigurations: DocumentViewerStyleConfigurations;
  Drawer: Omit<Drawer, 'Content'> & { Content?: Maybe<ResolversParentTypes['Page']> };
  DropDownButton: DropDownButton;
  Entity: Entity;
  EventData: Scalars['EventData']['output'];
  Feature: Omit<Feature, 'Actions' | 'Features'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, Features?: Maybe<Array<ResolversParentTypes['Feature']>> };
  FeatureBindings: FeatureBindings;
  Feed: Omit<Feed, 'Components' | 'FeedFooter' | 'FeedHeader' | 'ReviewDialogOptions'> & { Components?: Maybe<Array<ResolversParentTypes['Component']>>, FeedFooter?: Maybe<ResolversParentTypes['LayoutItem']>, FeedHeader?: Maybe<ResolversParentTypes['LayoutItem']>, ReviewDialogOptions?: Maybe<ResolversParentTypes['ReviewDialog']> };
  FeedBindings: FeedBindings;
  FieldFormat: FieldFormat;
  FieldList: FieldList;
  FieldValueExpression: Scalars['FieldValueExpression']['output'];
  FileList: FileList;
  FileListBindings: FileListBindings;
  FileUpload: FileUpload;
  FileUploadBindings: FileUploadBindings;
  FilterParams: FilterParams;
  FinApp: Omit<FinApp, 'Actions' | 'Elements' | 'UserPrefs'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, Elements?: Maybe<ResolversParentTypes['Service']>, UserPrefs?: Maybe<ResolversParentTypes['Service']> };
  FinAppBindings: FinAppBindings;
  FinAppStyleConfigurations: FinAppStyleConfigurations;
  FlexLayout: Omit<FlexLayout, 'InnerLayouts' | 'LayoutItem'> & { InnerLayouts?: Maybe<Array<Maybe<ResolversParentTypes['Layout']>>>, LayoutItem?: Maybe<ResolversParentTypes['LayoutItem']> };
  FlexLayoutBindings: FlexLayoutBindings;
  FlexLayoutItem: Scalars['FlexLayoutItem']['output'];
  FlexProperties: FlexProperties;
  Float: Scalars['Float']['output'];
  Form: Omit<Form, 'Actions' | 'Items' | 'Layout'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, Items?: Maybe<Array<ResolversParentTypes['LayoutItem']>>, Layout?: Maybe<ResolversParentTypes['Layout']> };
  FormBindings: FormBindings;
  FormId: Scalars['FormId']['output'];
  FormStyleConfigurations: FormStyleConfigurations;
  FormatName: Scalars['FormatName']['output'];
  Formats: Scalars['Formats']['output'];
  FragmentLayout: FragmentLayout;
  FragmentLayoutBindings: FragmentLayoutBindings;
  FreeFormLayout: FreeFormLayout;
  FreeFormLayoutBindings: FreeFormLayoutBindings;
  GenerateCode: GenerateCode;
  GoBack: GoBack;
  GoToBookmark: GoToBookmark;
  GoToBookmarkBindings: GoToBookmarkBindings;
  GoToPage: GoToPage;
  GoToPageBindings: GoToPageBindings;
  GoogleAnalytics: GoogleAnalytics;
  GridEditor: GridEditor;
  GridEditorBindings: GridEditorBindings;
  GridStackLayout: Omit<GridStackLayout, 'Actions' | 'InnerLayouts' | 'LayoutItem'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, InnerLayouts?: Maybe<Array<Maybe<ResolversParentTypes['Layout']>>>, LayoutItem?: Maybe<ResolversParentTypes['LayoutItem']> };
  Html: Html;
  HtmlBindings: HtmlBindings;
  IActionTrigger: ResolversInterfaceTypes<ResolversParentTypes>['IActionTrigger'];
  IApplication: ResolversInterfaceTypes<ResolversParentTypes>['IApplication'];
  ID: Scalars['ID']['output'];
  IDesignable: ResolversInterfaceTypes<ResolversParentTypes>['IDesignable'];
  IEditable: ResolversInterfaceTypes<ResolversParentTypes>['IEditable'];
  IField: ResolversInterfaceTypes<ResolversParentTypes>['IField'];
  IFrame: IFrame;
  IFrameBindings: IFrameBindings;
  IInstruction: ResolversInterfaceTypes<ResolversParentTypes>['IInstruction'];
  IParameter: ResolversInterfaceTypes<ResolversParentTypes>['IParameter'];
  IParameterWithValues: ResolversInterfaceTypes<ResolversParentTypes>['IParameterWithValues'];
  ISelectFromList: ResolversInterfaceTypes<ResolversParentTypes>['ISelectFromList'];
  Icon: Icon;
  IconBindings: IconBindings;
  IconSelector: IconSelector;
  IconSelectorBindings: IconSelectorBindings;
  IconStyleConfigurations: IconStyleConfigurations;
  Image: Omit<Image, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  ImageBindings: ImageBindings;
  InputBinding: Scalars['InputBinding']['output'];
  InputData: InputData;
  InputField: Omit<InputField, 'Actions' | 'ContextAutocomplete'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, ContextAutocomplete?: Maybe<ResolversParentTypes['ContextAutocomplete']> };
  InputFieldBindings: InputFieldBindings;
  InputFieldStyleConfigurations: InputFieldStyleConfigurations;
  Int: Scalars['Int']['output'];
  JsonView: JsonView;
  JsonViewBindings: JsonViewBindings;
  Label: Omit<Label, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  LabelBindings: LabelBindings;
  LabelStyleConfigurations: LabelStyleConfigurations;
  Layout: ResolversUnionTypes<ResolversParentTypes>['Layout'];
  LayoutItem: ResolversUnionTypes<ResolversParentTypes>['LayoutItem'];
  LayoutItemId: Scalars['LayoutItemId']['output'];
  LibraryItem: Omit<LibraryItem, 'Template'> & { Template?: Maybe<ResolversParentTypes['LayoutItem']> };
  LinearLayout: Omit<LinearLayout, 'InnerLayouts' | 'LayoutItem'> & { InnerLayouts?: Maybe<Array<Maybe<ResolversParentTypes['Layout']>>>, LayoutItem?: Maybe<ResolversParentTypes['LayoutItem']> };
  LinearProgress: LinearProgress;
  LinearProgressBindings: LinearProgressBindings;
  Link: Link;
  LinkBindings: LinkBindings;
  List: Omit<List, 'Actions' | 'Columns' | 'Items' | 'ListColumns' | 'Service' | 'Toolbar'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, Columns?: Maybe<Array<ResolversParentTypes['ListColumn']>>, Items?: Maybe<Array<Maybe<ResolversParentTypes['LayoutItem']>>>, ListColumns?: Maybe<Array<ResolversParentTypes['ListColumn']>>, Service?: Maybe<ResolversParentTypes['Service']>, Toolbar?: Maybe<ResolversParentTypes['ListToolbar']> };
  ListAndChartLabels: ListAndChartLabels;
  ListBindings: ListBindings;
  ListClearAllButton: Omit<ListClearAllButton, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  ListClearAllButtonBindings: ListClearAllButtonBindings;
  ListColumn: Omit<ListColumn, 'Actions' | 'CellLayout' | 'CellRendererItems'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, CellLayout?: Maybe<ResolversParentTypes['LayoutItem']>, CellRendererItems?: Maybe<Array<Maybe<ResolversParentTypes['LayoutItem']>>> };
  ListColumnBindings: ListColumnBindings;
  ListColumnStyleConfigurations: ListColumnStyleConfigurations;
  ListExportButton: ListExportButton;
  ListExportButtonBindings: ListExportButtonBindings;
  ListPageInfo: ListPageInfo;
  ListQuickFilter: Omit<ListQuickFilter, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  ListQuickFilterBindings: ListQuickFilterBindings;
  ListStyleConfigurations: ListStyleConfigurations;
  ListToolbar: Omit<ListToolbar, 'Items'> & { Items?: Maybe<Array<ResolversParentTypes['Button']>> };
  LocalizedAppInfo: LocalizedAppInfo;
  Login: Login;
  LoginBindings: LoginBindings;
  LoginPage: Omit<LoginPage, 'BackgroundImage' | 'LoginButtonImage' | 'Logo' | 'SocialLoginButtons'> & { BackgroundImage: ResolversParentTypes['Image'], LoginButtonImage: ResolversParentTypes['Image'], Logo: ResolversParentTypes['Image'], SocialLoginButtons?: Maybe<Array<Maybe<ResolversParentTypes['SocialLoginButton']>>> };
  Logout: Logout;
  Mapping: Mapping;
  MarkFrequency: MarkFrequency;
  Markdown: Markdown;
  MarkdownBindings: MarkdownBindings;
  Menu: Omit<Menu, 'Bindings' | 'Features'> & { Bindings?: Maybe<ResolversParentTypes['MenuBindings']>, Features: Array<Maybe<ResolversParentTypes['Feature']>> };
  MenuBindings: MenuBindings;
  Method: Scalars['Method']['output'];
  ModalPopupEditor: ModalPopupEditor;
  ModalPopupEditorBindings: ModalPopupEditorBindings;
  Model: Model;
  MultiFilter: Omit<MultiFilter, 'Actions' | 'Fields' | 'Items'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, Fields?: Maybe<Array<Maybe<ResolversParentTypes['IField']>>>, Items?: Maybe<Array<ResolversParentTypes['LayoutItem']>> };
  MultiFilterBindings: MultiFilterBindings;
  MultiSelect: Omit<MultiSelect, 'Actions' | 'ServiceList'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, ServiceList?: Maybe<ResolversParentTypes['ServiceList']> };
  MultiSelectBindings: MultiSelectBindings;
  MultiSelectObject: Scalars['MultiSelectObject']['output'];
  MultiSelectStyleConfigurations: MultiSelectStyleConfigurations;
  NativeApplication: Omit<NativeApplication, 'Icon' | 'Screenshots'> & { Icon: ResolversParentTypes['Image'], Screenshots: Array<Maybe<ResolversParentTypes['Image']>> };
  NumberFormat: NumberFormat;
  OpenContextMenu: OpenContextMenu;
  OpenContextMenuBindings: OpenContextMenuBindings;
  OpenModalPopup: OpenModalPopup;
  Overlay: Omit<Overlay, 'Actions' | 'Items'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, Items?: Maybe<Array<ResolversParentTypes['LayoutItem']>> };
  OverlayBindings: OverlayBindings;
  Page: Omit<Page, 'Actions' | 'Context' | 'Items' | 'Layout' | 'ModalPopups' | 'PageTemplate' | 'Services'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, Context?: Maybe<Array<Maybe<ResolversParentTypes['IField']>>>, Items?: Maybe<Array<ResolversParentTypes['LayoutItem']>>, Layout?: Maybe<ResolversParentTypes['Layout']>, ModalPopups?: Maybe<Array<Maybe<ResolversParentTypes['Dialog']>>>, PageTemplate?: Maybe<ResolversParentTypes['PageTemplate']>, Services?: Maybe<Array<Maybe<ResolversParentTypes['Service']>>> };
  PageBindings: PageBindings;
  PageTemplate: Omit<PageTemplate, 'BottomAppBar' | 'Footer' | 'Header' | 'LeftSidebar' | 'RightSidebar' | 'TopAppBar'> & { BottomAppBar?: Maybe<ResolversParentTypes['AppBar']>, Footer?: Maybe<ResolversParentTypes['Drawer']>, Header?: Maybe<ResolversParentTypes['Drawer']>, LeftSidebar?: Maybe<ResolversParentTypes['Drawer']>, RightSidebar?: Maybe<ResolversParentTypes['Drawer']>, TopAppBar?: Maybe<ResolversParentTypes['AppBar']> };
  Paper: Paper;
  PasteFromClipboard: PasteFromClipboard;
  Position: Position;
  PropertiesEditor: Omit<PropertiesEditor, 'Actions' | 'HeaderItems'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, HeaderItems?: Maybe<Array<ResolversParentTypes['LayoutItem']>> };
  PropertiesEditorBindings: PropertiesEditorBindings;
  ProportionalBar: ProportionalBar;
  ProportionalBarBindings: ProportionalBarBindings;
  Query: {};
  RadioGroup: Omit<RadioGroup, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  RadioGroupBindings: RadioGroupBindings;
  Reference: Omit<Reference, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  ReferenceBindings: ReferenceBindings;
  ReferenceStyleConfigurations: ReferenceStyleConfigurations;
  RefreshGrid: Scalars['RefreshGrid']['output'];
  ReloadPage: ReloadPage;
  Repeater: Omit<Repeater, 'Content' | 'Details' | 'Header' | 'Items' | 'Layout' | 'Title'> & { Content?: Maybe<ResolversParentTypes['Form']>, Details?: Maybe<ResolversParentTypes['Form']>, Header?: Maybe<ResolversParentTypes['LayoutItem']>, Items?: Maybe<Array<ResolversParentTypes['LayoutItem']>>, Layout?: Maybe<ResolversParentTypes['Layout']>, Title?: Maybe<ResolversParentTypes['LayoutItem']> };
  RepeaterBindings: RepeaterBindings;
  RepeaterStyleConfigurations: RepeaterStyleConfigurations;
  ResizableProperties: ResizableProperties;
  ResolutionButtons: ResolutionButtons;
  ResolutionButtonsBindings: ResolutionButtonsBindings;
  ResponsiveProperty: Scalars['ResponsiveProperty']['output'];
  ResponsivePropertyObject: ResponsivePropertyObject;
  ReviewDialog: Omit<ReviewDialog, 'Actions' | 'Data' | 'Item'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, Data?: Maybe<ResolversParentTypes['ReviewDialogData']>, Item?: Maybe<ResolversParentTypes['LayoutItem']> };
  ReviewDialogBindings: ReviewDialogBindings;
  ReviewDialogData: Omit<ReviewDialogData, 'Item' | 'Notes'> & { Item?: Maybe<ResolversParentTypes['LayoutItem']>, Notes?: Maybe<Array<Maybe<ResolversParentTypes['ReviewNote']>>> };
  ReviewNote: Omit<ReviewNote, 'Screenshot'> & { Screenshot?: Maybe<ResolversParentTypes['Image']> };
  RichTextEditor: Omit<RichTextEditor, 'Actions' | 'ContextAutocomplete'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, ContextAutocomplete?: Maybe<ResolversParentTypes['ContextAutocomplete']> };
  RichTextEditorBindings: RichTextEditorBindings;
  RichTextEditorStyleConfigurations: RichTextEditorStyleConfigurations;
  RichTreeList: RichTreeList;
  RichTreeListBindings: RichTreeListBindings;
  SampleData: Scalars['SampleData']['output'];
  ScrollToTop: ScrollToTop;
  SendEmail: SendEmail;
  SendEmailBindings: SendEmailBindings;
  SendMessageToChild: SendMessageToChild;
  SendMessageToChildBindings: SendMessageToChildBindings;
  SendMessageToParent: SendMessageToParent;
  SendSMS: SendSms;
  SendSMSBindings: SendSmsBindings;
  Service: Omit<Service, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  ServiceBinding: Scalars['ServiceBinding']['output'];
  ServiceField: ServiceField;
  ServiceFieldBindings: ServiceFieldBindings;
  ServiceLibrary: Omit<ServiceLibrary, 'ServiceSets'> & { ServiceSets?: Maybe<Array<Maybe<ResolversParentTypes['ServiceSet']>>> };
  ServiceLibraryBindings: ServiceLibraryBindings;
  ServiceList: Omit<ServiceList, 'Fields'> & { Fields?: Maybe<Array<Maybe<ResolversParentTypes['IField']>>> };
  ServiceSet: Omit<ServiceSet, 'LibraryServices'> & { LibraryServices?: Maybe<Array<Maybe<ResolversParentTypes['Service']>>> };
  ServiceSnapshotOptions: ServiceSnapshotOptions;
  ServiceSnapshotOptionsDictionary: Scalars['ServiceSnapshotOptionsDictionary']['output'];
  SetState: SetState;
  Share: Omit<Share, 'Component'> & { Component?: Maybe<ResolversParentTypes['Component']> };
  ShareBindings: ShareBindings;
  ShareDialog: Omit<ShareDialog, 'Data'> & { Data?: Maybe<ResolversParentTypes['ShareDialogData']> };
  ShareDialogBindings: ShareDialogBindings;
  ShareDialogData: Omit<ShareDialogData, 'Item'> & { Item?: Maybe<ResolversParentTypes['LayoutItem']> };
  ShareSource: ShareSource;
  SharingInfo: Omit<SharingInfo, 'ServiceSnapshots'> & { ServiceSnapshots?: Maybe<Array<Maybe<ResolversParentTypes['Service']>>> };
  SharingOptions: SharingOptions;
  ShowMessage: ShowMessage;
  ShowMessageBindings: ShowMessageBindings;
  ShowToast: ShowToast;
  SimpleContainer: Omit<SimpleContainer, 'Actions' | 'Context' | 'Items' | 'Layout' | 'ReviewDialogOptions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, Context?: Maybe<Array<Maybe<ResolversParentTypes['IField']>>>, Items?: Maybe<Array<ResolversParentTypes['LayoutItem']>>, Layout?: Maybe<ResolversParentTypes['Layout']>, ReviewDialogOptions?: Maybe<ResolversParentTypes['ReviewDialog']> };
  SimpleContainerBindings: SimpleContainerBindings;
  SimpleContainerStyleConfigurations: SimpleContainerStyleConfigurations;
  SingleMapping: Scalars['SingleMapping']['output'];
  SiteConfiguration: SiteConfiguration;
  SiteSettings: SiteSettings;
  Slider: Omit<Slider, 'ValueLabelItem'> & { ValueLabelItem?: Maybe<ResolversParentTypes['LayoutItem']> };
  SliderBindings: SliderBindings;
  SliderMarks: Scalars['SliderMarks']['output'];
  SliderStyleConfigurations: SliderStyleConfigurations;
  Slot: Slot;
  Snackbar: Omit<Snackbar, 'Actions' | 'Button'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, Button?: Maybe<ResolversParentTypes['Button']> };
  SnackbarBindings: SnackbarBindings;
  SocialLoginButton: Omit<SocialLoginButton, 'Icon'> & { Icon: ResolversParentTypes['Image'] };
  SpreadsheetModeOptions: SpreadsheetModeOptions;
  State: Scalars['State']['output'];
  StateInspector: StateInspector;
  StateInspectorBindings: StateInspectorBindings;
  String: Scalars['String']['output'];
  StringDictionary: Scalars['StringDictionary']['output'];
  StyleEditor: Omit<StyleEditor, 'Layout'> & { Layout?: Maybe<ResolversParentTypes['Layout']> };
  StyleEditorBindings: StyleEditorBindings;
  StyleProperties: StyleProperties;
  StylePropertiesDictionary: Scalars['StylePropertiesDictionary']['output'];
  StyleSet: Scalars['StyleSet']['output'];
  Switch: Omit<Switch, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  SwitchBindings: SwitchBindings;
  SwitchStyleConfigurations: SwitchStyleConfigurations;
  TabContainer: Omit<TabContainer, 'Actions' | 'Items' | 'ReviewDialogOptions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, Items: Array<ResolversParentTypes['TabItemOrContainer']>, ReviewDialogOptions?: Maybe<ResolversParentTypes['ReviewDialog']> };
  TabContainerBindings: TabContainerBindings;
  TabContainerStyleConfigurations: TabContainerStyleConfigurations;
  TabItem: Omit<TabItem, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  TabItemBindings: TabItemBindings;
  TabItemOrContainer: ResolversUnionTypes<ResolversParentTypes>['TabItemOrContainer'];
  TabItemStyleConfigurations: TabItemStyleConfigurations;
  TabLayout: Omit<TabLayout, 'ReviewDialogOptions' | 'Tabs'> & { ReviewDialogOptions?: Maybe<ResolversParentTypes['ReviewDialog']>, Tabs: Array<ResolversParentTypes['TabItem']> };
  TabLayoutBindings: TabLayoutBindings;
  TableItemProps: TableItemProps;
  TableLayout: Omit<TableLayout, 'Actions' | 'LayoutItem'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>>, LayoutItem?: Maybe<ResolversParentTypes['LayoutItem']> };
  TagSet: Scalars['TagSet']['output'];
  Theme: Theme;
  TimePicker: TimePicker;
  TimePickerBindings: TimePickerBindings;
  TimeZonePicker: TimeZonePicker;
  TimeZonePickerBindings: TimeZonePickerBindings;
  Transform: Transform;
  TransformBindings: TransformBindings;
  TransformMethodOptions: Scalars['TransformMethodOptions']['output'];
  TreeKeyConversion: TreeKeyConversion;
  TreeList: TreeList;
  TreeListBindings: TreeListBindings;
  TriggerAction: TriggerAction;
  TriggerActionBindings: TriggerActionBindings;
  TriggerPropagation: TriggerPropagation;
  TypedBindingEditor: TypedBindingEditor;
  UndoRedoToolbar: Omit<UndoRedoToolbar, 'Actions'> & { Actions?: Maybe<Array<Maybe<ResolversParentTypes['IActionTrigger']>>> };
  UndoRedoToolbarBindings: UndoRedoToolbarBindings;
  User: Scalars['User']['output'];
  Valid: Valid;
  ValidationRule: ValidationRule;
  Video: Scalars['Video']['output'];
  VisibleMenu: VisibleMenu;
  VisibleMenuBindings: VisibleMenuBindings;
}>;

export type ConstantDirectiveArgs = {
  value?: Maybe<Scalars['String']['input']>;
};

export type ConstantDirectiveResolver<Result, Parent, ContextType = any, Args = ConstantDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type EditorPropsDirectiveArgs = {
  group?: Maybe<Scalars['String']['input']>;
  groupProp?: Maybe<GroupProp>;
  mode?: Maybe<ViewMode>;
  sequence?: Maybe<Scalars['Int']['input']>;
};

export type EditorPropsDirectiveResolver<Result, Parent, ContextType = any, Args = EditorPropsDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ExpressionDirectiveArgs = { };

export type ExpressionDirectiveResolver<Result, Parent, ContextType = any, Args = ExpressionDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type LocalizableDirectiveArgs = { };

export type LocalizableDirectiveResolver<Result, Parent, ContextType = any, Args = LocalizableDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type MappingsDirectiveArgs = {
  value?: Maybe<Scalars['StringDictionary']['input']>;
};

export type MappingsDirectiveResolver<Result, Parent, ContextType = any, Args = MappingsDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type RecommendedValuesDirectiveArgs = {
  values?: Maybe<Array<Maybe<Scalars['String']['input']>>>;
};

export type RecommendedValuesDirectiveResolver<Result, Parent, ContextType = any, Args = RecommendedValuesDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type RuntimeOnlyDirectiveArgs = { };

export type RuntimeOnlyDirectiveResolver<Result, Parent, ContextType = any, Args = RuntimeOnlyDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ServiceDirectiveArgs = { };

export type ServiceDirectiveResolver<Result, Parent, ContextType = any, Args = ServiceDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ThemeColorDirectiveArgs = { };

export type ThemeColorDirectiveResolver<Result, Parent, ContextType = any, Args = ThemeColorDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type UniqueDirectiveArgs = { };

export type UniqueDirectiveResolver<Result, Parent, ContextType = any, Args = UniqueDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AiDialogResolvers<ContextType = any, ParentType extends ResolversParentTypes['AIDialog'] = ResolversParentTypes['AIDialog']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['AIDialogBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FieldFormat']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  InputBoxHeight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Margin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MaxRows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MinRows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Multiline?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ResponseBoxHeight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Rows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ShowHistory?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AiDialogBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AIDialogBindings'] = ResolversParentTypes['AIDialogBindings']> = ResolversObject<{
  Loading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccordionGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccordionGroup'] = ResolversParentTypes['AccordionGroup']> = ResolversObject<{
  AccordionContainerStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['AccordionGroupBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Elevation?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ExpandDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Expanded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Header?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  HideExpandIcon?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FlexLayoutItem']>>>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Square?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  ToggleExpanded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccordionGroupBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccordionGroupBindings'] = ResolversParentTypes['AccordionGroupBindings']> = ResolversObject<{
  AccordionContainerStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExpandDisabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Expanded?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  HideExpandIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ToggleExpanded?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccordionGroupStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccordionGroupStyleConfigurations'] = ResolversParentTypes['AccordionGroupStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalChildren?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccordionLayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccordionLayout'] = ResolversParentTypes['AccordionLayout']> = ResolversObject<{
  AriaLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Groups?: Resolver<Array<ResolversTypes['AccordionGroup']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  UniqueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccordionLayoutBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccordionLayoutBindings'] = ResolversParentTypes['AccordionLayoutBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Groups?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Action'] = ResolversParentTypes['Action']> = ResolversObject<{
  __resolveType: TypeResolveFn<'BecomeUser' | 'CallPhone' | 'CallService' | 'ClearForm' | 'CloseContextMenu' | 'CloseModalPopup' | 'CopyToClipboard' | 'GenerateCode' | 'GoBack' | 'GoToBookmark' | 'GoToPage' | 'Login' | 'Logout' | 'OpenContextMenu' | 'OpenModalPopup' | 'PasteFromClipboard' | 'ReloadPage' | 'SendEmail' | 'SendMessageToChild' | 'SendMessageToParent' | 'SendSMS' | 'SetState' | 'Share' | 'ShowMessage' | 'ShowToast' | 'Transform' | 'TriggerAction', ParentType, ContextType>;
}>;

export type ActionEditorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActionEditor'] = ResolversParentTypes['ActionEditor']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ActionEditorBindings']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ActionEditorBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActionEditorBindings'] = ResolversParentTypes['ActionEditorBindings']> = ResolversObject<{
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AdornmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Adornment'] = ResolversParentTypes['Adornment']> = ResolversObject<{
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Position?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AnalyticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Analytics'] = ResolversParentTypes['Analytics']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['AnalyticsBindings']>, ParentType, ContextType>;
  EventCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  EventName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Metadata?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AnalyticsBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnalyticsBindings'] = ResolversParentTypes['AnalyticsBindings']> = ResolversObject<{
  EventCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  EventName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Metadata?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AppBarResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppBar'] = ResolversParentTypes['AppBar']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['AppBarBindings']>, ParentType, ContextType>;
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LogoAltText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LogoHeight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LogoLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LogoLinkTarget?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LogoWidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MarginBottom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MarginLeft?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MarginRight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MarginTop?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Menu?: Resolver<Maybe<ResolversTypes['Menu']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UniqueName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AppBarBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppBarBindings'] = ResolversParentTypes['AppBarBindings']> = ResolversObject<{
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Attribute'] = ResolversParentTypes['Attribute']> = ResolversObject<{
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Entity?: Resolver<Maybe<ResolversTypes['Entity']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  IsRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  IsUnique?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Type?: Resolver<ResolversTypes['AttributeType'], ParentType, ContextType>;
  Values?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface AudioScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Audio'], any> {
  name: 'Audio';
}

export type AudioPlayerResolvers<ContextType = any, ParentType extends ResolversParentTypes['AudioPlayer'] = ResolversParentTypes['AudioPlayer']> = ResolversObject<{
  AllowDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['AudioPlayerBindings']>, ParentType, ContextType>;
  DestinationBucket?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  RenderAsVideoPlayer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TranscriptStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AudioPlayerBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AudioPlayerBindings'] = ResolversParentTypes['AudioPlayerBindings']> = ResolversObject<{
  Text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AudioRecorderResolvers<ContextType = any, ParentType extends ResolversParentTypes['AudioRecorder'] = ResolversParentTypes['AudioRecorder']> = ResolversObject<{
  AllowDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AudiPlayerOptions?: Resolver<Maybe<ResolversTypes['AudioPlayer']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['AudioRecorderBindings']>, ParentType, ContextType>;
  DestinationBucket?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DisplayPlayerAfterRecording?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AudioRecorderBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AudioRecorderBindings'] = ResolversParentTypes['AudioRecorderBindings']> = ResolversObject<{
  Text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AvatarResolvers<ContextType = any, ParentType extends ResolversParentTypes['Avatar'] = ResolversParentTypes['Avatar']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  AlternativeText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ImageBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AvatarBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvatarBindings'] = ResolversParentTypes['AvatarBindings']> = ResolversObject<{
  AlternativeText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BasicInputResolvers<ContextType = any, ParentType extends ResolversParentTypes['BasicInput'] = ResolversParentTypes['BasicInput']> = ResolversObject<{
  AutoComplete?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AutoFocus?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DisableUnderline?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Error?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FieldFormat']>, ParentType, ContextType>;
  FullWidth?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Margin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MaxRows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MinRows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Multiline?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ReadOnly?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Rows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BecomeUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['BecomeUser'] = ResolversParentTypes['BecomeUser']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['BecomeUserBindings']>, ParentType, ContextType>;
  TargetDomain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TargetPage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BecomeUserBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BecomeUserBindings'] = ResolversParentTypes['BecomeUserBindings']> = ResolversObject<{
  TargetDomain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TargetPage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BindingEditorResolvers<ContextType = any, ParentType extends ResolversParentTypes['BindingEditor'] = ResolversParentTypes['BindingEditor']> = ResolversObject<{
  Id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface BindingsDictionaryScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BindingsDictionary'], any> {
  name: 'BindingsDictionary';
}

export interface BookmarkIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BookmarkId'], any> {
  name: 'BookmarkId';
}

export type BooleanFormatResolvers<ContextType = any, ParentType extends ResolversParentTypes['BooleanFormat'] = ResolversParentTypes['BooleanFormat']> = ResolversObject<{
  FalseValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TrueValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ButtonResolvers<ContextType = any, ParentType extends ResolversParentTypes['Button'] = ResolversParentTypes['Button']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType>;
  BadgeMaximum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  BadgeValue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ButtonBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  BottomIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CenterRipple?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ContextId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ContextMenu?: Resolver<Maybe<ResolversTypes['ContextMenu']>, ParentType, ContextType>;
  DisableElevation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DisableFocusRipple?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DisableRipple?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DisableTouchRipple?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  EndIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  FocusRipple?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FocusVisibleClassName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FullWidth?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  HasBadge?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Shape?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StartIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TopIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  TouchRippleRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  getData?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ButtonBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ButtonBindings'] = ResolversParentTypes['ButtonBindings']> = ResolversObject<{
  BadgeMaximum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  BadgeValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  HasBadge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ButtonGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['ButtonGroup'] = ResolversParentTypes['ButtonGroup']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ButtonGroupBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Exclusive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FieldFormat']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  LabelExpression?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MultiSelectFilter?: Resolver<Maybe<ResolversTypes['FilterCriteria']>, ParentType, ContextType>;
  MultiSelectPossibleValues?: Resolver<Maybe<Array<Maybe<ResolversTypes['MultiSelectObject']>>>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValueExpression?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValueType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ButtonGroupBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ButtonGroupBindings'] = ResolversParentTypes['ButtonGroupBindings']> = ResolversObject<{
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MultiSelectPossibleValues?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ButtonStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ButtonStyleConfigurations'] = ResolversParentTypes['ButtonStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CallPhoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['CallPhone'] = ResolversParentTypes['CallPhone']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['CallPhoneBindings']>, ParentType, ContextType>;
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CallPhoneBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CallPhoneBindings'] = ResolversParentTypes['CallPhoneBindings']> = ResolversObject<{
  Number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CallServiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CallService'] = ResolversParentTypes['CallService']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['CallServiceBindings']>, ParentType, ContextType>;
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Component?: Resolver<Maybe<ResolversTypes['ComponentId']>, ParentType, ContextType>;
  Fields?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Form?: Resolver<Maybe<ResolversTypes['FormId']>, ParentType, ContextType>;
  Service?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ServiceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CallServiceBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CallServiceBindings'] = ResolversParentTypes['CallServiceBindings']> = ResolversObject<{
  Component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Fields?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Form?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Service?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ServiceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChartResolvers<ContextType = any, ParentType extends ResolversParentTypes['Chart'] = ResolversParentTypes['Chart']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['ChartBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ChartFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChartField']>>>, ParentType, ContextType>;
  ChartLibrary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ChartMetadata?: Resolver<Maybe<ResolversTypes['ChartMetadata']>, ParentType, ContextType>;
  Colors?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Rows?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  Service?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TransposeRowLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TransposeRowNames?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  TransposeRowValueFrom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TransposeRowsToSeries?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Typename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UniqueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  getData?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChartBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChartBindings'] = ResolversParentTypes['ChartBindings']> = ResolversObject<{
  Colors?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Loading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Rows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TransposeRowLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TransposeRowNames?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TransposeRowValueFrom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TransposeRowsToSeries?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChartFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChartField'] = ResolversParentTypes['ChartField']> = ResolversObject<{
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FieldFormat']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface ChartMetadataScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ChartMetadata'], any> {
  name: 'ChartMetadata';
}

export type CheckboxResolvers<ContextType = any, ParentType extends ResolversParentTypes['Checkbox'] = ResolversParentTypes['Checkbox']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['CheckboxBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Checked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DefaultChecked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DisableRipple?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FieldFormat']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  IconWhenChecked?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  IconWhenUnchecked?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Indeterminate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelPlacement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  LabelWhenOff?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelWhenOn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CheckboxBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckboxBindings'] = ResolversParentTypes['CheckboxBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Required?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CheckboxStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckboxStyleConfigurations'] = ResolversParentTypes['CheckboxStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CircularProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['CircularProgress'] = ResolversParentTypes['CircularProgress']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['CircularProgressBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  DisableShrink?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShowValue?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Thickness?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  Value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  Variant?: Resolver<Maybe<ResolversTypes['CircularProgressVariant']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CircularProgressBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CircularProgressBindings'] = ResolversParentTypes['CircularProgressBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DisableShrink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShowValue?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Thickness?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Variant?: Resolver<Maybe<ResolversTypes['CircularProgressVariant']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface ClassSetScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ClassSet'], any> {
  name: 'ClassSet';
}

export type ClearFormResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClearForm'] = ResolversParentTypes['ClearForm']> = ResolversObject<{
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Component?: Resolver<Maybe<ResolversTypes['ComponentId']>, ParentType, ContextType>;
  Form?: Resolver<Maybe<ResolversTypes['FormId']>, ParentType, ContextType>;
  Purge?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CloseContextMenuResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloseContextMenu'] = ResolversParentTypes['CloseContextMenu']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['CloseContextMenuBindings']>, ParentType, ContextType>;
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Component?: Resolver<Maybe<ResolversTypes['ComponentId']>, ParentType, ContextType>;
  ContextMenuId?: Resolver<Maybe<ResolversTypes['ContextMenuId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CloseContextMenuBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloseContextMenuBindings'] = ResolversParentTypes['CloseContextMenuBindings']> = ResolversObject<{
  ContextMenuId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CloseModalPopupResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloseModalPopup'] = ResolversParentTypes['CloseModalPopup']> = ResolversObject<{
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Component?: Resolver<Maybe<ResolversTypes['ComponentId']>, ParentType, ContextType>;
  ModalPopupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CodeEditorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CodeEditor'] = ResolversParentTypes['CodeEditor']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['CodeEditorBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FieldFormat']>, ParentType, ContextType>;
  Height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Language?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MultiLine?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NumberOfLines?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Options?: Resolver<Maybe<ResolversTypes['CodeEditorOptions']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CodeEditorBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CodeEditorBindings'] = ResolversParentTypes['CodeEditorBindings']> = ResolversObject<{
  Language?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface CodeEditorOptionsScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CodeEditorOptions'], any> {
  name: 'CodeEditorOptions';
}

export type CommandResolvers<ContextType = any, ParentType extends ResolversParentTypes['Command'] = ResolversParentTypes['Command']> = ResolversObject<{
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  Instruction?: Resolver<Maybe<ResolversTypes['IInstruction']>, ParentType, ContextType>;
  NextCommand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NextCommandIdOnFailure?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NextCommandIdOnSuccess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Parameters?: Resolver<Maybe<Array<Maybe<ResolversTypes['IParameterWithValues']>>>, ParentType, ContextType>;
  SkipCommand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StopExecution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CommandSetResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommandSet'] = ResolversParentTypes['CommandSet']> = ResolversObject<{
  Commands?: Resolver<Maybe<Array<Maybe<ResolversTypes['Command']>>>, ParentType, ContextType>;
  ExecuteCommandsInParallel?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FirstCommandId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ComponentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Component'] = ResolversParentTypes['Component']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ComponentBindings']>, ParentType, ContextType>;
  Category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ComponentContainer?: Resolver<Maybe<ResolversTypes['Container']>, ParentType, ContextType>;
  ComponentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Events?: Resolver<Maybe<ResolversTypes['EventData']>, ParentType, ContextType>;
  HeaderItems?: Resolver<Maybe<Array<ResolversTypes['LayoutItem']>>, ParentType, ContextType>;
  HideTitle?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InReviewMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  IncludeInCatalog?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  InitialHeight?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  InitialWidth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Inputs?: Resolver<Maybe<ResolversTypes['InputData']>, ParentType, ContextType>;
  InstanceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LargeImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ModalPopups?: Resolver<Maybe<Array<Maybe<ResolversTypes['Dialog']>>>, ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  SampleData?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  SerialNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ServiceSnapshots?: Resolver<Maybe<Array<Maybe<ResolversTypes['Service']>>>, ParentType, ContextType>;
  Services?: Resolver<Maybe<Array<Maybe<ResolversTypes['Service']>>>, ParentType, ContextType>;
  SharingInfo?: Resolver<Maybe<ResolversTypes['SharingInfo']>, ParentType, ContextType>;
  SharingOptions?: Resolver<Maybe<ResolversTypes['SharingOptions']>, ParentType, ContextType>;
  SmallImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  State?: Resolver<Maybe<ResolversTypes['State']>, ParentType, ContextType>;
  Styles?: Resolver<Maybe<ResolversTypes['StyleSet']>, ParentType, ContextType>;
  SubCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Tags?: Resolver<Maybe<ResolversTypes['TagSet']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TitleClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  UseSampleDataToInitializeState?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ComponentBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentBindings'] = ResolversParentTypes['ComponentBindings']> = ResolversObject<{
  InReviewMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface ComponentIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ComponentId'], any> {
  name: 'ComponentId';
}

export type ComponentLibraryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentLibrary'] = ResolversParentTypes['ComponentLibrary']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ComponentLibraryBindings']>, ParentType, ContextType>;
  Components?: Resolver<Array<Maybe<ResolversTypes['LibraryItem']>>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ComponentLibraryBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ComponentLibraryBindings'] = ResolversParentTypes['ComponentLibraryBindings']> = ResolversObject<{
  Components?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Enabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigurationEditorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigurationEditor'] = ResolversParentTypes['ConfigurationEditor']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['ConfigurationEditorBindings']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigurationEditorBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigurationEditorBindings'] = ResolversParentTypes['ConfigurationEditorBindings']> = ResolversObject<{
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContainerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Container'] = ResolversParentTypes['Container']> = ResolversObject<{
  __resolveType: TypeResolveFn<'SimpleContainer' | 'TabContainer', ParentType, ContextType>;
}>;

export type ContextAutocompleteResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContextAutocomplete'] = ResolversParentTypes['ContextAutocomplete']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ContextAutocompleteBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Model?: Resolver<Maybe<ResolversTypes['Model']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContextAutocompleteBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContextAutocompleteBindings'] = ResolversParentTypes['ContextAutocompleteBindings']> = ResolversObject<{
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContextMenuResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContextMenu'] = ResolversParentTypes['ContextMenu']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['ContextMenuBindings']>, ParentType, ContextType>;
  ClassName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Content?: Resolver<ResolversTypes['LayoutItem'], ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContextMenuBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContextMenuBindings'] = ResolversParentTypes['ContextMenuBindings']> = ResolversObject<{
  Enabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface ContextMenuIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ContextMenuId'], any> {
  name: 'ContextMenuId';
}

export type ControlResolvers<ContextType = any, ParentType extends ResolversParentTypes['Control'] = ResolversParentTypes['Control']> = ResolversObject<{
  __resolveType: TypeResolveFn<'AIDialog' | 'ActionEditor' | 'AudioPlayer' | 'AudioRecorder' | 'Avatar' | 'BasicInput' | 'Button' | 'ButtonGroup' | 'Checkbox' | 'CircularProgress' | 'CodeEditor' | 'ComponentLibrary' | 'ContextAutocomplete' | 'ContextMenu' | 'DatePicker' | 'FileList' | 'FileUpload' | 'Html' | 'IFrame' | 'Icon' | 'IconSelector' | 'Image' | 'InputField' | 'Label' | 'LinearProgress' | 'Link' | 'ListClearAllButton' | 'ListExportButton' | 'ListQuickFilter' | 'Markdown' | 'MultiSelect' | 'Overlay' | 'ProportionalBar' | 'RadioGroup' | 'ResolutionButtons' | 'RichTextEditor' | 'Slider' | 'Snackbar' | 'StyleEditor' | 'Switch' | 'VisibleMenu', ParentType, ContextType>;
}>;

export type CopyToClipboardResolvers<ContextType = any, ParentType extends ResolversParentTypes['CopyToClipboard'] = ResolversParentTypes['CopyToClipboard']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['CopyToClipboardBindings']>, ParentType, ContextType>;
  Options?: Resolver<Maybe<ResolversTypes['TransformMethodOptions']>, ParentType, ContextType>;
  TransformMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CopyToClipboardBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CopyToClipboardBindings'] = ResolversParentTypes['CopyToClipboardBindings']> = ResolversObject<{
  ClipboardContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Options?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TransformMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CountryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Country'] = ResolversParentTypes['Country']> = ResolversObject<{
  Code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CssClassResolvers<ContextType = any, ParentType extends ResolversParentTypes['CssClass'] = ResolversParentTypes['CssClass']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['CssParamsBindings']>, ParentType, ContextType>;
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['CssObject']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface CssObjectScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CssObject'], any> {
  name: 'CssObject';
}

export interface CssParamsBindingsScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CssParamsBindings'], any> {
  name: 'CssParamsBindings';
}

export type CustomLabelResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomLabel'] = ResolversParentTypes['CustomLabel']> = ResolversObject<{
  CaseSensitive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ReplaceBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export type DateFormatResolvers<ContextType = any, ParentType extends ResolversParentTypes['DateFormat'] = ResolversParentTypes['DateFormat']> = ResolversObject<{
  DateStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Day?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Hour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Hour12?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Minute?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Month?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Second?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TimeStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TimeZone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DatePickerResolvers<ContextType = any, ParentType extends ResolversParentTypes['DatePicker'] = ResolversParentTypes['DatePicker']> = ResolversObject<{
  Analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['DatePickerBindings']>, ParentType, ContextType>;
  ClassName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  DisableClearable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MaxDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MinDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<ResolversTypes['Slot']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DatePickerBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DatePickerBindings'] = ResolversParentTypes['DatePickerBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MaxDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MinDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DatePickerStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DatePickerStyleConfigurations'] = ResolversParentTypes['DatePickerStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DateTimePickerResolvers<ContextType = any, ParentType extends ResolversParentTypes['DateTimePicker'] = ResolversParentTypes['DateTimePicker']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['DateTimePickerBindings']>, ParentType, ContextType>;
  ClassName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DateTimePickerBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DateTimePickerBindings'] = ResolversParentTypes['DateTimePickerBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DialogResolvers<ContextType = any, ParentType extends ResolversParentTypes['Dialog'] = ResolversParentTypes['Dialog']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['DialogBindings']>, ParentType, ContextType>;
  ButtonClicked?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  CommandSetOnCancel?: Resolver<Maybe<ResolversTypes['CommandSet']>, ParentType, ContextType>;
  CommandSetOnClose?: Resolver<Maybe<ResolversTypes['CommandSet']>, ParentType, ContextType>;
  CommandSetOnOk?: Resolver<Maybe<ResolversTypes['CommandSet']>, ParentType, ContextType>;
  ContentClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  ContentContainer?: Resolver<Maybe<ResolversTypes['Container']>, ParentType, ContextType>;
  ContentStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  ContentText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Draggable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FooterContainer?: Resolver<Maybe<ResolversTypes['Container']>, ParentType, ContextType>;
  FullCustom?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FullScreen?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  HeaderItem?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InnerDialogClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  InnerDialogStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  ShowCancelButton?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowCloseButton?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowOkButton?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TitleContainerStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  TitleStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DialogBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DialogBindings'] = ResolversParentTypes['DialogBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ContentClasses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ContentStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ContentText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FullCustom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FullScreen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShowCancelButton?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShowCloseButton?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShowOkButton?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TitleStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  open?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface DocumentScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Document'], any> {
  name: 'Document';
}

export type DocumentViewerResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentViewer'] = ResolversParentTypes['DocumentViewer']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  AuxiliaryButtonClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  AuxiliaryButtonStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['DocumentViewerBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ButtonClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  ButtonStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  DocumentFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DocumentMaxWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  Documents?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType>;
  ErrorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FallbackImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InfiniteMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  InfiniteStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  LoadAllPage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  MaxLoadingTimeSeconds?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NavigationButtonSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NumPages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  PathExpression?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PreviewMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Scale?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType>;
  ValueExpression?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ZoomHorizontalPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ZoomVerticalPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DocumentViewerBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentViewerBindings'] = ResolversParentTypes['DocumentViewerBindings']> = ResolversObject<{
  AuxiliaryButtonClasses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AuxiliaryButtonStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ButtonClasses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ButtonStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DocumentFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Documents?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ErrorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  InfiniteMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MaxLoadingTimeSeconds?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NavigationButtonSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PathExpression?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValueExpression?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DocumentViewerStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentViewerStyleConfigurations'] = ResolversParentTypes['DocumentViewerStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalChildren?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DrawerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Drawer'] = ResolversParentTypes['Drawer']> = ResolversObject<{
  Anchor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  ComponentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Content?: Resolver<Maybe<ResolversTypes['Page']>, ParentType, ContextType>;
  Height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  HideBackdrop?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  MarginBottom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MarginLeft?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MarginRight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MarginTop?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Open?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  TransitionDuration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UniqueName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Variant?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DropDownButtonResolvers<ContextType = any, ParentType extends ResolversParentTypes['DropDownButton'] = ResolversParentTypes['DropDownButton']> = ResolversObject<{
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Entity'] = ResolversParentTypes['Entity']> = ResolversObject<{
  Attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Attribute']>>>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Model?: Resolver<Maybe<ResolversTypes['Model']>, ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface EventDataScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['EventData'], any> {
  name: 'EventData';
}

export type FeatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['Feature'] = ResolversParentTypes['Feature']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  AllowNavigation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['FeatureBindings']>, ParentType, ContextType>;
  BottomIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  ButtonStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  ContextId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  EndIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  ExternalUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Features?: Resolver<Maybe<Array<ResolversTypes['Feature']>>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StartIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  TopIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  UrlOpenTarget?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeatureBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureBindings'] = ResolversParentTypes['FeatureBindings']> = ResolversObject<{
  ButtonStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeedResolvers<ContextType = any, ParentType extends ResolversParentTypes['Feed'] = ResolversParentTypes['Feed']> = ResolversObject<{
  AddHeaders?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['FeedBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Components?: Resolver<Maybe<Array<ResolversTypes['Component']>>, ParentType, ContextType>;
  ComponentsStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FeedFooter?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  FeedHeader?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  InReviewMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ReviewDialogOptions?: Resolver<Maybe<ResolversTypes['ReviewDialog']>, ParentType, ContextType>;
  Service?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Typename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UniqueName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  getData?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeedBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeedBindings'] = ResolversParentTypes['FeedBindings']> = ResolversObject<{
  Components?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  InReviewMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Loading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Reviews?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectedItem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FieldFormatResolvers<ContextType = any, ParentType extends ResolversParentTypes['FieldFormat'] = ResolversParentTypes['FieldFormat']> = ResolversObject<{
  EditableMask?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  ReadOnlyDisplayMask?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FieldListResolvers<ContextType = any, ParentType extends ResolversParentTypes['FieldList'] = ResolversParentTypes['FieldList']> = ResolversObject<{
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface FieldValueExpressionScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['FieldValueExpression'], any> {
  name: 'FieldValueExpression';
}

export type FileListResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileList'] = ResolversParentTypes['FileList']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['FileListBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  IconSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  ViewMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FileListBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileListBindings'] = ResolversParentTypes['FileListBindings']> = ResolversObject<{
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  IconSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Rows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ViewMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FileUploadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileUpload'] = ResolversParentTypes['FileUpload']> = ResolversObject<{
  AllowBrowse?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AllowDirectoriesOnly?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AllowDrop?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AllowMultiple?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AllowPaste?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AllowProcess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AllowReorder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AllowReplace?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AllowRevert?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['FileUploadBindings']>, ParentType, ContextType>;
  CheckValidity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ChunkForce?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ChunkRetryDelays?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  ChunkSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ChunkUploads?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DropOnElement?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DropOnPage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DropValidation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FileSizeBase?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ForceRevert?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  IconDone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  IconProcess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  IconRemove?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  IconRetry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  IconUndo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  IgnoredFiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  InstantUpload?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ItemInsertInterval?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ItemInsertLocation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ItemInsertLocationFreedom?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  LabelButtonAbortItemLoad?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelButtonAbortItemProcessing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelButtonProcessItem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelButtonRemoveItem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelButtonRetryItemLoad?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelButtonRetryItemProcessing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelButtonUndoItemProcessing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelDecimalSeparator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelFileAdded?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelFileCountPlural?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelFileCountSingular?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelFileLoadError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelFileLoading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelFileProcessing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelFileProcessingAborted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelFileProcessingComplete?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelFileProcessingError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelFileProcessingRevertError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelFileRemoveError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelFileRemoved?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelFileSizeNotAvailable?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelFileWaitingForSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelIdle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelInvalidField?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelTapToCancel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelTapToRetry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelTapToUndo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelThousandsSeparator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MaxFiles?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  MaxParallelUploads?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShowButtonProcessItem?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowButtonRemoveItem?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowLoadIndicator?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowProgressIndicator?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  StoreAsFile?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  StyleButtonProcessItemAlign?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StyleButtonProcessItemPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StyleButtonProcessItemSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StyleButtonRemoveItemAlign?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  StyleButtonRemoveItemPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StyleButtonRemoveItemSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StyleItemPanelAspectRatio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StyleLoadIndicatorPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StyleLoadIndicatorSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StylePanelAspectRatio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StylePanelLayout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StyleProgressIndicatorPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StyleProgressIndicatorSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FileUploadBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileUploadBindings'] = ResolversParentTypes['FileUploadBindings']> = ResolversObject<{
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FilterParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FilterParams'] = ResolversParentTypes['FilterParams']> = ResolversObject<{
  values?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FinAppResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinApp'] = ResolversParentTypes['FinApp']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  AppConfigId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['FinAppBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  ComparisonList?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  Elements?: Resolver<Maybe<ResolversTypes['Service']>, ParentType, ContextType>;
  EventCount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Exchange?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  HideElements?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  HideLoader?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Indices?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  LimitColumns?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  MarketIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ModelId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  RankingType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectedCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShouldShowConfiguration?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowInternational?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowLinks?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Symbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Typename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UserPrefs?: Resolver<Maybe<ResolversTypes['Service']>, ParentType, ContextType>;
  View?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  XID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  XIDs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FinAppBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinAppBindings'] = ResolversParentTypes['FinAppBindings']> = ResolversObject<{
  AppConfigId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ComparisonList?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Elements?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  EventCount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Exchange?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  HideElements?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  HideLoader?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Indices?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LimitColumns?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  MarketIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ModelId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  RankingType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectedCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShouldShowConfiguration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShowInternational?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShowLinks?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Symbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UserPrefs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  View?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  XID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  XIDs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FinAppStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinAppStyleConfigurations'] = ResolversParentTypes['FinAppStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FlexLayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexLayout'] = ResolversParentTypes['FlexLayout']> = ResolversObject<{
  AlignContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AlignItems?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AlignSelf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['FlexLayoutBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  ColumnGap?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ColumnSpacing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Columns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ContextId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Direction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExtraLarge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExtraSmall?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FlexWrap?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  InnerLayouts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Layout']>>>, ParentType, ContextType>;
  IsFlexContainer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  IsLeaf?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ItemStyles?: Resolver<Maybe<ResolversTypes['StylePropertiesDictionary']>, ParentType, ContextType>;
  Items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FlexLayoutItem']>>>, ParentType, ContextType>;
  JustifyContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Large?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LayoutItem?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  Medium?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  RowGap?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  RowSpacing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SetAsBookmark?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Small?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Spacing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Wrap?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FlexLayoutBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexLayoutBindings'] = ResolversParentTypes['FlexLayoutBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface FlexLayoutItemScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['FlexLayoutItem'], any> {
  name: 'FlexLayoutItem';
}

export type FlexPropertiesResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlexProperties'] = ResolversParentTypes['FlexProperties']> = ResolversObject<{
  AlignSelf?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  FlexBasis?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  FlexGrow?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  FlexShrink?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  FlexWrap?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  ItemId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  TextAlign?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FormResolvers<ContextType = any, ParentType extends ResolversParentTypes['Form'] = ResolversParentTypes['Form']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['FormBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ContextId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  Enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FormId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Items?: Resolver<Maybe<Array<ResolversTypes['LayoutItem']>>, ParentType, ContextType>;
  Layout?: Resolver<Maybe<ResolversTypes['Layout']>, ParentType, ContextType>;
  Paper?: Resolver<Maybe<ResolversTypes['Paper']>, ParentType, ContextType>;
  Service?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SetAsBookmark?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowBindingField?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  StopPropagation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Typename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UniqueName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  getData?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FormBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FormBindings'] = ResolversParentTypes['FormBindings']> = ResolversObject<{
  Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Enabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Items?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface FormIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['FormId'], any> {
  name: 'FormId';
}

export type FormStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FormStyleConfigurations'] = ResolversParentTypes['FormStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface FormatNameScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['FormatName'], any> {
  name: 'FormatName';
}

export interface FormatsScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Formats'], any> {
  name: 'Formats';
}

export type FragmentLayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['FragmentLayout'] = ResolversParentTypes['FragmentLayout']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['FragmentLayoutBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  ContextId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FragmentLayoutBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FragmentLayoutBindings'] = ResolversParentTypes['FragmentLayoutBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FreeFormLayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['FreeFormLayout'] = ResolversParentTypes['FreeFormLayout']> = ResolversObject<{
  Bottom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  ContextId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ItemStyles?: Resolver<Maybe<ResolversTypes['StylePropertiesDictionary']>, ParentType, ContextType>;
  Items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FlexLayoutItem']>>>, ParentType, ContextType>;
  Left?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Right?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Top?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ZIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FreeFormLayoutBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FreeFormLayoutBindings'] = ResolversParentTypes['FreeFormLayoutBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  InReviewMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateCode'] = ResolversParentTypes['GenerateCode']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['BindingsDictionary']>, ParentType, ContextType>;
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DataTransformations?: Resolver<Maybe<ResolversTypes['BindingsDictionary']>, ParentType, ContextType>;
  GenerationType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  InputData?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  Options?: Resolver<Maybe<ResolversTypes['TransformMethodOptions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GoBackResolvers<ContextType = any, ParentType extends ResolversParentTypes['GoBack'] = ResolversParentTypes['GoBack']> = ResolversObject<{
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GoToBookmarkResolvers<ContextType = any, ParentType extends ResolversParentTypes['GoToBookmark'] = ResolversParentTypes['GoToBookmark']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['GoToBookmarkBindings']>, ParentType, ContextType>;
  Bookmark?: Resolver<Maybe<ResolversTypes['BookmarkId']>, ParentType, ContextType>;
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GoToBookmarkBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GoToBookmarkBindings'] = ResolversParentTypes['GoToBookmarkBindings']> = ResolversObject<{
  Bookmark?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GoToPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['GoToPage'] = ResolversParentTypes['GoToPage']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['GoToPageBindings']>, ParentType, ContextType>;
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  IgnoreSessionPrefix?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  OpenInNewWindow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  QueryStringBindings?: Resolver<Maybe<ResolversTypes['BindingsDictionary']>, ParentType, ContextType>;
  URLBindings?: Resolver<Maybe<ResolversTypes['BindingsDictionary']>, ParentType, ContextType>;
  Url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UseNativeRedirect?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GoToPageBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GoToPageBindings'] = ResolversParentTypes['GoToPageBindings']> = ResolversObject<{
  Url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GoogleAnalyticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GoogleAnalytics'] = ResolversParentTypes['GoogleAnalytics']> = ResolversObject<{
  IsEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  TagId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GridEditorResolvers<ContextType = any, ParentType extends ResolversParentTypes['GridEditor'] = ResolversParentTypes['GridEditor']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['GridEditorBindings']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectedIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UseFormDialog?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GridEditorBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GridEditorBindings'] = ResolversParentTypes['GridEditorBindings']> = ResolversObject<{
  Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectedIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UseFormDialog?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GridStackLayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['GridStackLayout'] = ResolversParentTypes['GridStackLayout']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  AutoPosition?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  FitToContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  H?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  InnerLayouts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Layout']>>>, ParentType, ContextType>;
  LayoutItem?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  MaxH?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  MaxW?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  MinH?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  MinW?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  W?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  X?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Y?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HtmlResolvers<ContextType = any, ParentType extends ResolversParentTypes['Html'] = ResolversParentTypes['Html']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['HtmlBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HtmlBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['HtmlBindings'] = ResolversParentTypes['HtmlBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IActionTriggerResolvers<ContextType = any, ParentType extends ResolversParentTypes['IActionTrigger'] = ResolversParentTypes['IActionTrigger']> = ResolversObject<{
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
  CommandSet?: Resolver<Maybe<ResolversTypes['CommandSet']>, ParentType, ContextType>;
  ListenTo?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  PropagateToParent?: Resolver<Maybe<ResolversTypes['TriggerPropagation']>, ParentType, ContextType>;
  SkipAction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StopPropagation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Trigger?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postHandler?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  preHandler?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
}>;

export type IApplicationResolvers<ContextType = any, ParentType extends ResolversParentTypes['IApplication'] = ResolversParentTypes['IApplication']> = ResolversObject<{
  __resolveType: TypeResolveFn<'Feed' | 'FinApp' | 'Form' | 'List' | 'PropertiesEditor' | 'Repeater' | 'TreeList', ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Service?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Typename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UniqueName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  getData?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
}>;

export type IDesignableResolvers<ContextType = any, ParentType extends ResolversParentTypes['IDesignable'] = ResolversParentTypes['IDesignable']> = ResolversObject<{
  __resolveType: TypeResolveFn<'AIDialog' | 'AccordionGroup' | 'AccordionLayout' | 'BasicInput' | 'Button' | 'ButtonGroup' | 'Chart' | 'Checkbox' | 'CircularProgress' | 'DatePicker' | 'DateTimePicker' | 'DocumentViewer' | 'DropDownButton' | 'Feed' | 'Form' | 'IFrame' | 'InputField' | 'JsonView' | 'Label' | 'LinearProgress' | 'Link' | 'ListColumn' | 'MultiSelect' | 'Page' | 'RadioGroup' | 'Repeater' | 'ResolutionButtons' | 'SimpleContainer' | 'Slider' | 'StateInspector' | 'Switch' | 'TabContainer' | 'TabLayout' | 'TimePicker' | 'TimeZonePicker' | 'TreeList' | 'UndoRedoToolbar', ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type IEditableResolvers<ContextType = any, ParentType extends ResolversParentTypes['IEditable'] = ResolversParentTypes['IEditable']> = ResolversObject<{
  __resolveType: TypeResolveFn<'AIDialog' | 'BasicInput' | 'ButtonGroup' | 'Chart' | 'Checkbox' | 'IFrame' | 'InputField' | 'ListColumn' | 'MultiSelect' | 'RadioGroup' | 'ResolutionButtons' | 'Slider' | 'Switch' | 'UndoRedoToolbar', ParentType, ContextType>;
  Editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
}>;

export type IFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['IField'] = ResolversParentTypes['IField']> = ResolversObject<{
  __resolveType: TypeResolveFn<'AIDialog' | 'BasicInput' | 'ButtonGroup' | 'Chart' | 'ChartField' | 'Checkbox' | 'CircularProgress' | 'DatePicker' | 'DateTimePicker' | 'DocumentViewer' | 'IFrame' | 'InputField' | 'JsonView' | 'Label' | 'LinearProgress' | 'Link' | 'ListColumn' | 'MultiSelect' | 'RadioGroup' | 'ResolutionButtons' | 'Slider' | 'StateInspector' | 'Switch' | 'TimePicker' | 'TimeZonePicker' | 'UndoRedoToolbar', ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FieldFormat']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
}>;

export type IFrameResolvers<ContextType = any, ParentType extends ResolversParentTypes['IFrame'] = ResolversParentTypes['IFrame']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['IFrameBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FieldFormat']>, ParentType, ContextType>;
  Height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IFrameBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['IFrameBindings'] = ResolversParentTypes['IFrameBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Reload?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IInstructionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IInstruction'] = ResolversParentTypes['IInstruction']> = ResolversObject<{
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ParameterTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['IParameter']>>>, ParentType, ContextType>;
}>;

export type IParameterResolvers<ContextType = any, ParentType extends ResolversParentTypes['IParameter'] = ResolversParentTypes['IParameter']> = ResolversObject<{
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  IsMandatory?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ParameterType?: Resolver<Maybe<ResolversTypes['ParameterType']>, ParentType, ContextType>;
}>;

export type IParameterWithValuesResolvers<ContextType = any, ParentType extends ResolversParentTypes['IParameterWithValues'] = ResolversParentTypes['IParameterWithValues']> = ResolversObject<{
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['FieldValueExpression']>, ParentType, ContextType>;
}>;

export type ISelectFromListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ISelectFromList'] = ResolversParentTypes['ISelectFromList']> = ResolversObject<{
  __resolveType: TypeResolveFn<'ButtonGroup' | 'MultiSelect' | 'RadioGroup', ParentType, ContextType>;
  MultiSelectFilter?: Resolver<Maybe<ResolversTypes['FilterCriteria']>, ParentType, ContextType>;
  MultiSelectPossibleValues?: Resolver<Maybe<Array<Maybe<ResolversTypes['MultiSelectObject']>>>, ParentType, ContextType>;
  ServiceList?: Resolver<Maybe<ResolversTypes['ServiceList']>, ParentType, ContextType>;
}>;

export type IconResolvers<ContextType = any, ParentType extends ResolversParentTypes['Icon'] = ResolversParentTypes['Icon']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['IconBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ContextId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  IconLibrary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  IconName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IconBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['IconBindings'] = ResolversParentTypes['IconBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  IconName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IconSelectorResolvers<ContextType = any, ParentType extends ResolversParentTypes['IconSelector'] = ResolversParentTypes['IconSelector']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['IconSelectorBindings']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IconSelectorBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['IconSelectorBindings'] = ResolversParentTypes['IconSelectorBindings']> = ResolversObject<{
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IconStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['IconStyleConfigurations'] = ResolversParentTypes['IconStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Image'] = ResolversParentTypes['Image']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  AlternativeText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType>;
  BgColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ImageBindings']>, ParentType, ContextType>;
  ClassName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Distance?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Easing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ErrorIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  FallbackImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Fit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  HideOnError?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  IconWrapperClassName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Shift?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShiftDuration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ShowLoading?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  WrapperClassName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ImageBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImageBindings'] = ResolversParentTypes['ImageBindings']> = ResolversObject<{
  AlternativeText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface InputBindingScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['InputBinding'], any> {
  name: 'InputBinding';
}

export type InputDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['InputData'] = ResolversParentTypes['InputData']> = ResolversObject<{
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['FieldValueExpression']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InputFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['InputField'] = ResolversParentTypes['InputField']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Adornment?: Resolver<Maybe<ResolversTypes['Adornment']>, ParentType, ContextType>;
  Analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType>;
  AutoComplete?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AutoFocus?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['InputFieldBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  ClearValueOnEnter?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ContextAutocomplete?: Resolver<Maybe<ResolversTypes['ContextAutocomplete']>, ParentType, ContextType>;
  Debounce?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Error?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  FocusOnDisplay?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FormatName']>, ParentType, ContextType>;
  FullWidth?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  InputType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Margin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  MaxLength?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MaxRows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  MinRows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Multiline?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  MultilineAutosize?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Resize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Rows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Select?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  SetAsBookmark?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  TransformToString?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Valid?: Resolver<Maybe<ResolversTypes['Valid']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InputFieldBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['InputFieldBindings'] = ResolversParentTypes['InputFieldBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  InputType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MaxLength?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MaxRows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MinRows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Multiline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Rows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Valid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InputFieldStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['InputFieldStyleConfigurations'] = ResolversParentTypes['InputFieldStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalChildren?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JsonViewResolvers<ContextType = any, ParentType extends ResolversParentTypes['JsonView'] = ResolversParentTypes['JsonView']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['JsonViewBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DataName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Expanded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Search?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type JsonViewBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['JsonViewBindings'] = ResolversParentTypes['JsonViewBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DataName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Expanded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Search?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LabelResolvers<ContextType = any, ParentType extends ResolversParentTypes['Label'] = ResolversParentTypes['Label']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['LabelBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  BooleanFormat?: Resolver<Maybe<ResolversTypes['BooleanFormat']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ChipClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  ClassName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DateFormat?: Resolver<Maybe<ResolversTypes['DateFormat']>, ParentType, ContextType>;
  DisableAnimation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DisplayAsChip?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  EllipsisOnOverflow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  EndIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Error?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Filled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Focused?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FieldFormat']>, ParentType, ContextType>;
  FormatName?: Resolver<Maybe<ResolversTypes['FormatName']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ListSeparator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Margin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MultiLine?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NumberFormat?: Resolver<Maybe<ResolversTypes['NumberFormat']>, ParentType, ContextType>;
  NumberOfLines?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  SetAsBookmark?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Shrink?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StartIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  getData?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LabelBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LabelBindings'] = ResolversParentTypes['LabelBindings']> = ResolversObject<{
  ChipClasses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FormatName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LabelStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LabelStyleConfigurations'] = ResolversParentTypes['LabelStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['Layout'] = ResolversParentTypes['Layout']> = ResolversObject<{
  __resolveType: TypeResolveFn<'AccordionLayout' | 'FlexLayout' | 'FragmentLayout' | 'FreeFormLayout' | 'GridStackLayout' | 'LinearLayout' | 'TabLayout' | 'TableLayout', ParentType, ContextType>;
}>;

export type LayoutItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LayoutItem'] = ResolversParentTypes['LayoutItem']> = ResolversObject<{
  __resolveType: TypeResolveFn<'AIDialog' | 'AccordionLayout' | 'ActionEditor' | 'AudioPlayer' | 'AudioRecorder' | 'Avatar' | 'BasicInput' | 'Button' | 'ButtonGroup' | 'Chart' | 'Checkbox' | 'CircularProgress' | 'CodeEditor' | 'Component' | 'ComponentLibrary' | 'ContextAutocomplete' | 'ContextMenu' | 'DatePicker' | 'Dialog' | 'Feed' | 'FileList' | 'FileUpload' | 'FinApp' | 'Form' | 'Html' | 'IFrame' | 'Icon' | 'Image' | 'InputField' | 'Label' | 'LinearProgress' | 'Link' | 'List' | 'ListClearAllButton' | 'ListColumn' | 'ListExportButton' | 'ListQuickFilter' | 'Markdown' | 'MultiFilter' | 'MultiSelect' | 'Overlay' | 'Page' | 'PropertiesEditor' | 'ProportionalBar' | 'RadioGroup' | 'Repeater' | 'ResolutionButtons' | 'RichTextEditor' | 'RichTreeList' | 'SimpleContainer' | 'Slider' | 'Snackbar' | 'Switch' | 'TabContainer' | 'TabLayout' | 'TreeList' | 'VisibleMenu', ParentType, ContextType>;
}>;

export interface LayoutItemIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LayoutItemId'], any> {
  name: 'LayoutItemId';
}

export type LibraryItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LibraryItem'] = ResolversParentTypes['LibraryItem']> = ResolversObject<{
  Category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  InitialHeight?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  InitialWidth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  SerialNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SubCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Template?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LinearLayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinearLayout'] = ResolversParentTypes['LinearLayout']> = ResolversObject<{
  AlignItems?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  Direction?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  InnerLayouts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Layout']>>>, ParentType, ContextType>;
  ItemAlignment?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  LayoutItem?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  LayoutItemIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  LayoutItemProps?: Resolver<Maybe<Array<Maybe<ResolversTypes['FlexProperties']>>>, ParentType, ContextType>;
  Spacing?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LinearProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinearProgress'] = ResolversParentTypes['LinearProgress']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['LinearProgressBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  ValueBuffer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  Variant?: Resolver<Maybe<ResolversTypes['LinearProgressVariant']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LinearProgressBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinearProgressBindings'] = ResolversParentTypes['LinearProgressBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValueBuffer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Variant?: Resolver<Maybe<ResolversTypes['CircularProgressVariant']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['Link'] = ResolversParentTypes['Link']> = ResolversObject<{
  Analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['LinkBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  FileExtension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Target?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  URL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LinkBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkBindings'] = ResolversParentTypes['LinkBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FileExtension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Target?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  URL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListResolvers<ContextType = any, ParentType extends ResolversParentTypes['List'] = ResolversParentTypes['List']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ListBindings']>, ParentType, ContextType>;
  ClearGridState?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Columns?: Resolver<Maybe<Array<ResolversTypes['ListColumn']>>, ParentType, ContextType>;
  ColumnsClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  ColumnsHeaderClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  DisabledColumnGrouping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  EditMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  EnableCellSelection?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  EnableEditing?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  EnableRowClickSelection?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  EnableSideBar?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  GridHeight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GridLayout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GroupingClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  GroupingHeaderClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  GroupingsCollapsed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Items?: Resolver<Maybe<Array<Maybe<ResolversTypes['LayoutItem']>>>, ParentType, ContextType>;
  ListColumns?: Resolver<Maybe<Array<ResolversTypes['ListColumn']>>, ParentType, ContextType>;
  Loading?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  PaginationAutoPageSize?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  PivotMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  QuickFilterText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ReadOnlyEdit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Refresh?: Resolver<Maybe<ResolversTypes['RefreshGrid']>, ParentType, ContextType>;
  RowGroupDisplayType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  RowGroupName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  RowHeight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  Rows?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  RowsAutoSizeStrategy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  RowsPerPage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  SelectionMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Service?: Resolver<Maybe<ResolversTypes['Service']>, ParentType, ContextType>;
  ShowAddRowsButton?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowAdvancedFilter?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowCheckboxSelection?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowClearAllFilters?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowExport?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowFloatingFilter?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowGroupingPanel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShowPageSizeSelector?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowPagination?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowQuickFilter?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  SideBarOpenByDefault?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  SpreadsheetModeOptions?: Resolver<Maybe<ResolversTypes['SpreadsheetModeOptions']>, ParentType, ContextType>;
  Toolbar?: Resolver<Maybe<ResolversTypes['ListToolbar']>, ParentType, ContextType>;
  Typename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  getData?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListAndChartLabelsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListAndChartLabels'] = ResolversParentTypes['ListAndChartLabels']> = ResolversObject<{
  ApplyFilter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Area?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AreaChart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AreaGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AriaChecked?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AriaHidden?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AriaUnchecked?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AriaVisible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AutosizeAllColumns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AutosizeThisColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Average?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Axis?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Background?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  BarChart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  BarGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Blanks?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Blur?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Bold?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  BoldItalic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Bottom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Bubble?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  BubbleTooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Callout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Categories?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Chart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ChartRange?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  CollapseAll?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ColumnChart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ColumnGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Contains?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Copy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  CopyWithHeaders?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Count?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  CsvExport?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  CtrlC?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  CtrlV?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Doughnut?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DoughnutTooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  EndsWith?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Equals?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExcelExport?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExpandAll?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Export?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FillOpacity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FilterOoo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  First?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Font?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GreaterThan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GreaterThanOrEqual?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GroupBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GroupedAreaTooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GroupedBar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GroupedBarTooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GroupedColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GroupedColumnTooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  HistogramBinCount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  HistogramChart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  HistogramGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  HistogramTooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  InRange?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Italic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ItemPaddingX?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ItemPaddingY?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Labels?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Last?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Left?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Legend?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Length?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LessThan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LessThanOrEqual?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Line?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LineGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LineTooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LineWidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LoadingOoo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MarkerPadding?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MarkerSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MarkerStroke?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Markers?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Max?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Min?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  More?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Next?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NoDataToChart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NoMatches?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NoPin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  None?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Normal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NormalizedArea?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NormalizedAreaTooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NormalizedBar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NormalizedBarTooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NormalizedColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NormalizedColumnTooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NotContains?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NotEqual?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Of?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Offset?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Padding?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Page?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Paste?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Pie?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PieChart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PieGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PieTooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PinColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PinLeft?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PinRight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PivotChart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PivotChartAndPivotMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PivotChartRequiresPivotMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PivotChartTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Previous?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  RangeChartTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ResetColumns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Right?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Scatter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ScatterGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ScatterTooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SearchOoo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectAll?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Series?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Settings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Shadow?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StackedArea?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StackedAreaTooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StackedBar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StackedBarTooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StackedColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StackedColumnTooltip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StartsWith?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StrokeOpacity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StrokeWidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Sum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Thickness?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Ticks?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  To?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ToolPanel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Tooltips?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Top?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UngroupBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValueAggregation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  XOffset?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  XRotation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  XYChart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  YOffset?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  YRotation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListBindings'] = ResolversParentTypes['ListBindings']> = ResolversObject<{
  ClearGridState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Columns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  EditMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ListColumns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Loading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PageInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  QuickFilterText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Refresh?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  RowModesModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Rows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  RowsPerPage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListClearAllButtonResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListClearAllButton'] = ResolversParentTypes['ListClearAllButton']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ListClearAllButtonBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StartIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListClearAllButtonBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListClearAllButtonBindings'] = ResolversParentTypes['ListClearAllButtonBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListColumnResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListColumn'] = ResolversParentTypes['ListColumn']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  AggFunc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AutoSize?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ListColumnBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CellLayout?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  CellRendererItems?: Resolver<Maybe<Array<Maybe<ResolversTypes['LayoutItem']>>>, ParentType, ContextType>;
  ChipClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  ColSpan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ColumnFixedWidth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ColumnMinimumWidth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  DataType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DisableFiltering?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DisableGrouping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DisableSorting?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DisplayAsChip?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  FilterParams?: Resolver<Maybe<ResolversTypes['FilterParams']>, ParentType, ContextType>;
  Flex?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  FormatName?: Resolver<Maybe<ResolversTypes['FormatName']>, ParentType, ContextType>;
  HeaderName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  IsPrimaryKey?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Pinned?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Pivot?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Resizable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  RowGroup?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Sort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SortingOrder?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  SuppressHeaderMenu?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __typename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListColumnBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListColumnBindings'] = ResolversParentTypes['ListColumnBindings']> = ResolversObject<{
  RowGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListColumnStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListColumnStyleConfigurations'] = ResolversParentTypes['ListColumnStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListExportButtonResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListExportButton'] = ResolversParentTypes['ListExportButton']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['ListExportButtonBindings']>, ParentType, ContextType>;
  CSVDelimiter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  EnableCSV?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  EnableExcel?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  EnablePrint?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ExcelSheetName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PrintHideFooter?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  PrintHideToolbar?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListExportButtonBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListExportButtonBindings'] = ResolversParentTypes['ListExportButtonBindings']> = ResolversObject<{
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListPageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListPageInfo'] = ResolversParentTypes['ListPageInfo']> = ResolversObject<{
  hasNextPage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListQuickFilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListQuickFilter'] = ResolversParentTypes['ListQuickFilter']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Adornment?: Resolver<Maybe<ResolversTypes['Adornment']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ListQuickFilterBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PlaceholderText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  onInput?: Resolver<Maybe<ResolversTypes['EventData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListQuickFilterBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListQuickFilterBindings'] = ResolversParentTypes['ListQuickFilterBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListStyleConfigurations'] = ResolversParentTypes['ListStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListToolbarResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListToolbar'] = ResolversParentTypes['ListToolbar']> = ResolversObject<{
  Items?: Resolver<Maybe<Array<ResolversTypes['Button']>>, ParentType, ContextType>;
  ShowExport?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LocalizedAppInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocalizedAppInfo'] = ResolversParentTypes['LocalizedAppInfo']> = ResolversObject<{
  Description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Keywords?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  Language?: Resolver<ResolversTypes['Language'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LoginResolvers<ContextType = any, ParentType extends ResolversParentTypes['Login'] = ResolversParentTypes['Login']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['LoginBindings']>, ParentType, ContextType>;
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SuccessRedirect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LoginBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginBindings'] = ResolversParentTypes['LoginBindings']> = ResolversObject<{
  Email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LoginPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginPage'] = ResolversParentTypes['LoginPage']> = ResolversObject<{
  AllowFaceId?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  AllowRememberMe?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  BackgroundImage?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  BiometricsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ForgotPasswordLinkText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LoginButtonImage?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  LoginButtonText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Logo?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  PasswordLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PasswordPlaceholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShowForgotPasswordLink?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ShowSignupLink?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  SignUpLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SocialLoginButtons?: Resolver<Maybe<Array<Maybe<ResolversTypes['SocialLoginButton']>>>, ParentType, ContextType>;
  Subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  UsernameLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UsernamePlaceholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LogoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['Logout'] = ResolversParentTypes['Logout']> = ResolversObject<{
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MappingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mapping'] = ResolversParentTypes['Mapping']> = ResolversObject<{
  Source?: Resolver<Maybe<ResolversTypes['SingleMapping']>, ParentType, ContextType>;
  Target?: Resolver<Maybe<ResolversTypes['SingleMapping']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarkFrequencyResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarkFrequency'] = ResolversParentTypes['MarkFrequency']> = ResolversObject<{
  Label?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  Value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarkdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['Markdown'] = ResolversParentTypes['Markdown']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['MarkdownBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShowTypingIndicator?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  StreamUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  TypingIndicatorIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarkdownBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarkdownBindings'] = ResolversParentTypes['MarkdownBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  StreamUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MenuResolvers<ContextType = any, ParentType extends ResolversParentTypes['Menu'] = ResolversParentTypes['Menu']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['MenuBindings']>, ParentType, ContextType>;
  ButtonStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ContextId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Features?: Resolver<Array<Maybe<ResolversTypes['Feature']>>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LandingPageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Loading?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  SerialNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  SubCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MenuBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MenuBindings'] = ResolversParentTypes['MenuBindings']> = ResolversObject<{
  ButtonStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Loading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface MethodScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Method'], any> {
  name: 'Method';
}

export type ModalPopupEditorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModalPopupEditor'] = ResolversParentTypes['ModalPopupEditor']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['ModalPopupEditorBindings']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ModalPopupEditorBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModalPopupEditorBindings'] = ResolversParentTypes['ModalPopupEditorBindings']> = ResolversObject<{
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['Model'] = ResolversParentTypes['Model']> = ResolversObject<{
  Entities?: Resolver<Maybe<Array<Maybe<ResolversTypes['Entity']>>>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MultiFilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['MultiFilter'] = ResolversParentTypes['MultiFilter']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['MultiFilterBindings']>, ParentType, ContextType>;
  ButtonClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  Fields?: Resolver<Maybe<Array<Maybe<ResolversTypes['IField']>>>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Items?: Resolver<Maybe<Array<ResolversTypes['LayoutItem']>>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MultiFilterBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MultiFilterBindings'] = ResolversParentTypes['MultiFilterBindings']> = ResolversObject<{
  Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Fields?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MultiSelectResolvers<ContextType = any, ParentType extends ResolversParentTypes['MultiSelect'] = ResolversParentTypes['MultiSelect']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Adornment?: Resolver<Maybe<ResolversTypes['Adornment']>, ParentType, ContextType>;
  Analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType>;
  AutoComplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AutoHighlight?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AutoSelect?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AutoselectFirstOption?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['MultiSelectBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  BlurOnSelect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CaptionClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  CaptionTemplate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  CheckboxMultiSelect?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  ClearAfterSelect?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ClearInterval?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DisableClearable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FieldFormat']>, ParentType, ContextType>;
  FreeSolo?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  GroupBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GroupClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  LabelExpression?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MultiSelectFilter?: Resolver<Maybe<ResolversTypes['FilterCriteria']>, ParentType, ContextType>;
  MultiSelectPossibleValues?: Resolver<Maybe<Array<Maybe<ResolversTypes['MultiSelectObject']>>>, ParentType, ContextType>;
  Multiple?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NoOptionsText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Options?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  OptionsLabelExpression?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SearchFilter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ServiceList?: Resolver<Maybe<ResolversTypes['ServiceList']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  UseGroupBy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValueExpression?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MultiSelectBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MultiSelectBindings'] = ResolversParentTypes['MultiSelectBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ClearAfterSelect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  GroupBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MultiSelectPossibleValues?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NoOptionsText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SearchFilter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UseGroupBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface MultiSelectObjectScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['MultiSelectObject'], any> {
  name: 'MultiSelectObject';
}

export type MultiSelectStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MultiSelectStyleConfigurations'] = ResolversParentTypes['MultiSelectStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalChildren?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NativeApplicationResolvers<ContextType = any, ParentType extends ResolversParentTypes['NativeApplication'] = ResolversParentTypes['NativeApplication']> = ResolversObject<{
  Availability?: Resolver<Array<Maybe<ResolversTypes['Country']>>, ParentType, ContextType>;
  BiometricEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  BundleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Category?: Resolver<ResolversTypes['AppCategory'], ParentType, ContextType>;
  Description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Icon?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Keywords?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  LastUpdatedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  LocalizedInfo?: Resolver<Maybe<Array<Maybe<ResolversTypes['LocalizedAppInfo']>>>, ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  PrimaryLanguage?: Resolver<ResolversTypes['Language'], ParentType, ContextType>;
  PrivacyPolicyURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ReleaseDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  Screenshots?: Resolver<Array<Maybe<ResolversTypes['Image']>>, ParentType, ContextType>;
  SubCategory?: Resolver<Maybe<ResolversTypes['AppSubCategory']>, ParentType, ContextType>;
  SupportURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NumberFormatResolvers<ContextType = any, ParentType extends ResolversParentTypes['NumberFormat'] = ResolversParentTypes['NumberFormat']> = ResolversObject<{
  Currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MaximumFractionDigits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  MinimumFractionDigits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SignDisplay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OpenContextMenuResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenContextMenu'] = ResolversParentTypes['OpenContextMenu']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['OpenContextMenuBindings']>, ParentType, ContextType>;
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Component?: Resolver<Maybe<ResolversTypes['ComponentId']>, ParentType, ContextType>;
  ContextMenuId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Form?: Resolver<Maybe<ResolversTypes['FormId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OpenContextMenuBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenContextMenuBindings'] = ResolversParentTypes['OpenContextMenuBindings']> = ResolversObject<{
  Component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ContextMenuId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OpenModalPopupResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenModalPopup'] = ResolversParentTypes['OpenModalPopup']> = ResolversObject<{
  Component?: Resolver<Maybe<ResolversTypes['ComponentId']>, ParentType, ContextType>;
  Message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ModalPopupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShowCancelButton?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowCloseButton?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowOkButton?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OverlayResolvers<ContextType = any, ParentType extends ResolversParentTypes['Overlay'] = ResolversParentTypes['Overlay']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['OverlayBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Draggable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  Items?: Resolver<Maybe<Array<ResolversTypes['LayoutItem']>>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Position?: Resolver<Maybe<ResolversTypes['Position']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OverlayBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OverlayBindings'] = ResolversParentTypes['OverlayBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Page'] = ResolversParentTypes['Page']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  BackgroundColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['PageBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ComponentReferenceIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  Context?: Resolver<Maybe<Array<Maybe<ResolversTypes['IField']>>>, ParentType, ContextType>;
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Items?: Resolver<Maybe<Array<ResolversTypes['LayoutItem']>>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Layout?: Resolver<Maybe<ResolversTypes['Layout']>, ParentType, ContextType>;
  ModalPopups?: Resolver<Maybe<Array<Maybe<ResolversTypes['Dialog']>>>, ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  PageTemplate?: Resolver<Maybe<ResolversTypes['PageTemplate']>, ParentType, ContextType>;
  PageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SampleData?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  SerialNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ServiceReferenceIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  Services?: Resolver<Maybe<Array<Maybe<ResolversTypes['Service']>>>, ParentType, ContextType>;
  State?: Resolver<Maybe<ResolversTypes['State']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Styles?: Resolver<Maybe<ResolversTypes['StylePropertiesDictionary']>, ParentType, ContextType>;
  SubCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Theme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UseSampleDataToInitializeState?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageBindings'] = ResolversParentTypes['PageBindings']> = ResolversObject<{
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Loading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Styles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Theme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageTemplate'] = ResolversParentTypes['PageTemplate']> = ResolversObject<{
  BottomAppBar?: Resolver<Maybe<ResolversTypes['AppBar']>, ParentType, ContextType>;
  BottomAppBarHeight?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Footer?: Resolver<Maybe<ResolversTypes['Drawer']>, ParentType, ContextType>;
  FooterHeight?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  Header?: Resolver<Maybe<ResolversTypes['Drawer']>, ParentType, ContextType>;
  HeaderHeight?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  LeftSidebar?: Resolver<Maybe<ResolversTypes['Drawer']>, ParentType, ContextType>;
  LeftSidebarWidth?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  RightSidebar?: Resolver<Maybe<ResolversTypes['Drawer']>, ParentType, ContextType>;
  RightSidebarWidth?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  TopAppBar?: Resolver<Maybe<ResolversTypes['AppBar']>, ParentType, ContextType>;
  TopAppBarHeight?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaperResolvers<ContextType = any, ParentType extends ResolversParentTypes['Paper'] = ResolversParentTypes['Paper']> = ResolversObject<{
  Elevation?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Square?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PasteFromClipboardResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasteFromClipboard'] = ResolversParentTypes['PasteFromClipboard']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['BindingsDictionary']>, ParentType, ContextType>;
  Options?: Resolver<Maybe<ResolversTypes['TransformMethodOptions']>, ParentType, ContextType>;
  TransformMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PositionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Position'] = ResolversParentTypes['Position']> = ResolversObject<{
  bottom?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  left?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  right?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  top?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertiesEditorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertiesEditor'] = ResolversParentTypes['PropertiesEditor']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  AddAncillaryButtons?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['PropertiesEditorBindings']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  DefaultTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FieldTypes?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  FieldWidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FieldsReadOnly?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  FormId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  HeaderItems?: Resolver<Maybe<Array<ResolversTypes['LayoutItem']>>, ParentType, ContextType>;
  HideIndividualBindings?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  IgnoreLocalState?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  LabelWidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Resizable?: Resolver<Maybe<ResolversTypes['ResizableProperties']>, ParentType, ContextType>;
  SearchPropInput?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Service?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShowBindingField?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  ToggleExpanded?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Typename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UniqueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UseFieldGroups?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ViewMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  WrapperLayoutType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  getData?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  isSubComponent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertiesEditorBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertiesEditorBindings'] = ResolversParentTypes['PropertiesEditorBindings']> = ResolversObject<{
  Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Enabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  FieldTypes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProportionalBarResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProportionalBar'] = ResolversParentTypes['ProportionalBar']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['ProportionalBarBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Colors?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  DataSeparator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  getData?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProportionalBarBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProportionalBarBindings'] = ResolversParentTypes['ProportionalBarBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Rows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  getComponentLibrary?: Resolver<Maybe<ResolversTypes['ComponentLibrary']>, ParentType, ContextType, Partial<QueryGetComponentLibraryArgs>>;
  getDialog?: Resolver<Maybe<ResolversTypes['Dialog']>, ParentType, ContextType, Partial<QueryGetDialogArgs>>;
  getMenu?: Resolver<Maybe<ResolversTypes['Menu']>, ParentType, ContextType, Partial<QueryGetMenuArgs>>;
  getPage?: Resolver<Maybe<ResolversTypes['Page']>, ParentType, ContextType, Partial<QueryGetPageArgs>>;
  getSiteConfiguration?: Resolver<Maybe<ResolversTypes['SiteConfiguration']>, ParentType, ContextType, Partial<QueryGetSiteConfigurationArgs>>;
  queryComponentLibrary?: Resolver<Maybe<Array<ResolversTypes['ComponentLibrary']>>, ParentType, ContextType>;
  queryDialog?: Resolver<Maybe<Array<ResolversTypes['Dialog']>>, ParentType, ContextType>;
  queryMenu?: Resolver<Maybe<Array<ResolversTypes['Menu']>>, ParentType, ContextType>;
  queryPage?: Resolver<Maybe<Array<ResolversTypes['Page']>>, ParentType, ContextType>;
  querySiteConfiguration?: Resolver<Maybe<Array<ResolversTypes['SiteConfiguration']>>, ParentType, ContextType>;
}>;

export type RadioGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['RadioGroup'] = ResolversParentTypes['RadioGroup']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['RadioGroupBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FieldFormat']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  LabelExpression?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MultiSelectFilter?: Resolver<Maybe<ResolversTypes['FilterCriteria']>, ParentType, ContextType>;
  MultiSelectPossibleValues?: Resolver<Maybe<Array<Maybe<ResolversTypes['MultiSelectObject']>>>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValueExpression?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValueType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RadioGroupBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RadioGroupBindings'] = ResolversParentTypes['RadioGroupBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MultiSelectPossibleValues?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Reference'] = ResolversParentTypes['Reference']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ReferenceBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Inputs?: Resolver<Maybe<ResolversTypes['InputBinding']>, ParentType, ContextType>;
  ReferenceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ReferenceSource?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ReferenceType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReferenceBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferenceBindings'] = ResolversParentTypes['ReferenceBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ReferenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ReferenceSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ReferenceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReferenceStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferenceStyleConfigurations'] = ResolversParentTypes['ReferenceStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface RefreshGridScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['RefreshGrid'], any> {
  name: 'RefreshGrid';
}

export type ReloadPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReloadPage'] = ResolversParentTypes['ReloadPage']> = ResolversObject<{
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RepeaterResolvers<ContextType = any, ParentType extends ResolversParentTypes['Repeater'] = ResolversParentTypes['Repeater']> = ResolversObject<{
  AllowAdd?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AllowDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AllowReordering?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['RepeaterBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  CollapseIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Content?: Resolver<Maybe<ResolversTypes['Form']>, ParentType, ContextType>;
  Details?: Resolver<Maybe<ResolversTypes['Form']>, ParentType, ContextType>;
  DisableGutters?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ExcludeFromForm?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ExpandIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Expanded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Fields?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  Header?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Items?: Resolver<Maybe<Array<ResolversTypes['LayoutItem']>>, ParentType, ContextType>;
  Layout?: Resolver<Maybe<ResolversTypes['Layout']>, ParentType, ContextType>;
  Rows?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  ScrollToLast?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  Typename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UseVirtualization?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  VituralizationHeight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  getData?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RepeaterBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RepeaterBindings'] = ResolversParentTypes['RepeaterBindings']> = ResolversObject<{
  AllowAdd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AllowDelete?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AllowReordering?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Loading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Rows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ScrollToLast?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectedItem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UseVirtualization?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  VituralizationHeight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RepeaterStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RepeaterStyleConfigurations'] = ResolversParentTypes['RepeaterStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ResizablePropertiesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResizableProperties'] = ResolversParentTypes['ResizableProperties']> = ResolversObject<{
  direction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dragBorderColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxHeight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minHeight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startHeight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startWidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ResolutionButtonsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResolutionButtons'] = ResolversParentTypes['ResolutionButtons']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['ResolutionButtonsBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FieldFormat']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  InitialState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ResolutionButtonsBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResolutionButtonsBindings'] = ResolversParentTypes['ResolutionButtonsBindings']> = ResolversObject<{
  SetHeight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SetWidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface ResponsivePropertyScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ResponsiveProperty'], any> {
  name: 'ResponsiveProperty';
}

export type ResponsivePropertyObjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResponsivePropertyObject'] = ResolversParentTypes['ResponsivePropertyObject']> = ResolversObject<{
  lg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  md?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sm?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  xl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  xs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReviewDialogResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewDialog'] = ResolversParentTypes['ReviewDialog']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ReviewDialogBindings']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['ReviewDialogData']>, ParentType, ContextType>;
  Enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  Item?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  ShowComments?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowInfo?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowReaction?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowTextNotes?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowVoiceNotes?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReviewDialogBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewDialogBindings'] = ResolversParentTypes['ReviewDialogBindings']> = ResolversObject<{
  Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Enabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReviewDialogDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewDialogData'] = ResolversParentTypes['ReviewDialogData']> = ResolversObject<{
  Item?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  NoteCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Notes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReviewNote']>>>, ParentType, ContextType>;
  Reaction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Reviewer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReviewNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewNote'] = ResolversParentTypes['ReviewNote']> = ResolversObject<{
  AudioNote?: Resolver<Maybe<ResolversTypes['Audio']>, ParentType, ContextType>;
  Author?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Excerpts?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  NoteType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ParentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ReviewDateTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  ScreenRecording?: Resolver<Maybe<ResolversTypes['Video']>, ParentType, ContextType>;
  Screenshot?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  Sentiment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  VideoNote?: Resolver<Maybe<ResolversTypes['Video']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RichTextEditorResolvers<ContextType = any, ParentType extends ResolversParentTypes['RichTextEditor'] = ResolversParentTypes['RichTextEditor']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['RichTextEditorBindings']>, ParentType, ContextType>;
  CharCounterCount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CharCounterMax?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  ContextAutocomplete?: Resolver<Maybe<ResolversTypes['ContextAutocomplete']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FileAllowedTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  FileMaxSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  HeightMax?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  HeightMin?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ImageAllowedTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  ImageDefaultWidth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ImageInsertButtons?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  ImageMaxSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  LinkEditButtons?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  LinkInsertButtons?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PlaceholderText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  QuickInsertButtons?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  QuickInsertEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  QuickInsertTags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  SupportTributes?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ToolbarButtons?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  ToolbarInline?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  TributeDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TributeKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TributeRows?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  TributeSearchString?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  VideoAllowedTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  VideoDefaultDisplay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  VideoDefaultWidth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  VideoInsertButtons?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  VideoUpload?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RichTextEditorBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RichTextEditorBindings'] = ResolversParentTypes['RichTextEditorBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Language?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TributeRows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TributeSearchString?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RichTextEditorStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RichTextEditorStyleConfigurations'] = ResolversParentTypes['RichTextEditorStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RichTreeListResolvers<ContextType = any, ParentType extends ResolversParentTypes['RichTreeList'] = ResolversParentTypes['RichTreeList']> = ResolversObject<{
  AllowAdd?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AllowDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AllowReordering?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['RichTreeListBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Items?: Resolver<Maybe<Array<Array<ResolversTypes['String']>>>, ParentType, ContextType>;
  Loading?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Searchable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RichTreeListBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RichTreeListBindings'] = ResolversParentTypes['RichTreeListBindings']> = ResolversObject<{
  AllowAdd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AllowDelete?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AllowReordering?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Items?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Loading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectedItem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface SampleDataScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['SampleData'], any> {
  name: 'SampleData';
}

export type ScrollToTopResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScrollToTop'] = ResolversParentTypes['ScrollToTop']> = ResolversObject<{
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Target?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendEmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendEmail'] = ResolversParentTypes['SendEmail']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['SendEmailBindings']>, ParentType, ContextType>;
  CC?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  To?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendEmailBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendEmailBindings'] = ResolversParentTypes['SendEmailBindings']> = ResolversObject<{
  CC?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  To?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendMessageToChildResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendMessageToChild'] = ResolversParentTypes['SendMessageToChild']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['SendMessageToChildBindings']>, ParentType, ContextType>;
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  IFrame?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendMessageToChildBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendMessageToChildBindings'] = ResolversParentTypes['SendMessageToChildBindings']> = ResolversObject<{
  Actions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendMessageToParentResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendMessageToParent'] = ResolversParentTypes['SendMessageToParent']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['BindingsDictionary']>, ParentType, ContextType>;
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendSmsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendSMS'] = ResolversParentTypes['SendSMS']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['SendSMSBindings']>, ParentType, ContextType>;
  Message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendSmsBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendSMSBindings'] = ResolversParentTypes['SendSMSBindings']> = ResolversObject<{
  Message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ServiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Service'] = ResolversParentTypes['Service']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ServiceBinding']>, ParentType, ContextType>;
  ConfigBindings?: Resolver<Maybe<ResolversTypes['ServiceBinding']>, ParentType, ContextType>;
  Debounce?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Fields?: Resolver<Maybe<Array<Maybe<ResolversTypes['ServiceField']>>>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  IgnoreLocale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  IsReadOnlyReference?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Mappings?: Resolver<Maybe<ResolversTypes['Mapping']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Require?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SampleData?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  Service?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Trigger?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UseSampleData?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface ServiceBindingScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ServiceBinding'], any> {
  name: 'ServiceBinding';
}

export type ServiceFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ServiceField'] = ResolversParentTypes['ServiceField']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['ServiceFieldBindings']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['FieldValueExpression']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ServiceFieldBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ServiceFieldBindings'] = ResolversParentTypes['ServiceFieldBindings']> = ResolversObject<{
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ServiceLibraryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ServiceLibrary'] = ResolversParentTypes['ServiceLibrary']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['ServiceLibraryBindings']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ServiceSets?: Resolver<Maybe<Array<Maybe<ResolversTypes['ServiceSet']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ServiceLibraryBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ServiceLibraryBindings'] = ResolversParentTypes['ServiceLibraryBindings']> = ResolversObject<{
  Enabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ServiceSets?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ServiceListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ServiceList'] = ResolversParentTypes['ServiceList']> = ResolversObject<{
  Fields?: Resolver<Maybe<Array<Maybe<ResolversTypes['IField']>>>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Service?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ServiceSetResolvers<ContextType = any, ParentType extends ResolversParentTypes['ServiceSet'] = ResolversParentTypes['ServiceSet']> = ResolversObject<{
  Category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  LibraryServices?: Resolver<Maybe<Array<Maybe<ResolversTypes['Service']>>>, ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  SubCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ServiceSnapshotOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ServiceSnapshotOptions'] = ResolversParentTypes['ServiceSnapshotOptions']> = ResolversObject<{
  SelectedFieldsToSnap?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  SnapAllFields?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  SnapServiceData?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface ServiceSnapshotOptionsDictionaryScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ServiceSnapshotOptionsDictionary'], any> {
  name: 'ServiceSnapshotOptionsDictionary';
}

export type SetStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetState'] = ResolversParentTypes['SetState']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['BindingsDictionary']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShareResolvers<ContextType = any, ParentType extends ResolversParentTypes['Share'] = ResolversParentTypes['Share']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['ShareBindings']>, ParentType, ContextType>;
  Component?: Resolver<Maybe<ResolversTypes['Component']>, ParentType, ContextType>;
  File?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NoteType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectedUsers?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  Text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShareBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShareBindings'] = ResolversParentTypes['ShareBindings']> = ResolversObject<{
  Component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  File?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NoteType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectedUsers?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShareDialogResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShareDialog'] = ResolversParentTypes['ShareDialog']> = ResolversObject<{
  AudioNote?: Resolver<Maybe<ResolversTypes['Audio']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['ShareDialogBindings']>, ParentType, ContextType>;
  ComponentInstanceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ContextId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['ShareDialogData']>, ParentType, ContextType>;
  Enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  NoteType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectedFieldsToSnap?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  ShareSource?: Resolver<Maybe<ResolversTypes['ShareSource']>, ParentType, ContextType>;
  SharedWith?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  SnapAllFields?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  SnapComponentData?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  VideoNote?: Resolver<Maybe<ResolversTypes['Video']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShareDialogBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShareDialogBindings'] = ResolversParentTypes['ShareDialogBindings']> = ResolversObject<{
  Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Enabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShareDialogDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShareDialogData'] = ResolversParentTypes['ShareDialogData']> = ResolversObject<{
  ComponentInstanceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Item?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShareSourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShareSource'] = ResolversParentTypes['ShareSource']> = ResolversObject<{
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SharingInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharingInfo'] = ResolversParentTypes['SharingInfo']> = ResolversObject<{
  AudioNote?: Resolver<Maybe<ResolversTypes['Audio']>, ParentType, ContextType>;
  NoteType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ServiceSnapshots?: Resolver<Maybe<Array<Maybe<ResolversTypes['Service']>>>, ParentType, ContextType>;
  ShareSource?: Resolver<Maybe<ResolversTypes['ShareSource']>, ParentType, ContextType>;
  SharedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  SharedOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  Text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  VideoNote?: Resolver<Maybe<ResolversTypes['Video']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SharingOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharingOptions'] = ResolversParentTypes['SharingOptions']> = ResolversObject<{
  CanShare?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ServiceSnapshotOptions?: Resolver<Maybe<ResolversTypes['ServiceSnapshotOptionsDictionary']>, ParentType, ContextType>;
  TargetComponentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowMessage'] = ResolversParentTypes['ShowMessage']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['ShowMessageBindings']>, ParentType, ContextType>;
  Message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ShowCancelButton?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowCloseButton?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ShowOkButton?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowMessageBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowMessageBindings'] = ResolversParentTypes['ShowMessageBindings']> = ResolversObject<{
  Message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShowToastResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowToast'] = ResolversParentTypes['ShowToast']> = ResolversObject<{
  AutoHideDuration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Severity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SimpleContainerResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimpleContainer'] = ResolversParentTypes['SimpleContainer']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['SimpleContainerBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Context?: Resolver<Maybe<Array<Maybe<ResolversTypes['IField']>>>, ParentType, ContextType>;
  CreateForm?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  IgnoreLayout?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  InReviewMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  IsReadOnlyReference?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Items?: Resolver<Maybe<Array<ResolversTypes['LayoutItem']>>, ParentType, ContextType>;
  Layout?: Resolver<Maybe<ResolversTypes['Layout']>, ParentType, ContextType>;
  Paper?: Resolver<Maybe<ResolversTypes['Paper']>, ParentType, ContextType>;
  Resizable?: Resolver<Maybe<ResolversTypes['ResizableProperties']>, ParentType, ContextType>;
  ReviewDialogOptions?: Resolver<Maybe<ResolversTypes['ReviewDialog']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UniqueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SimpleContainerBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimpleContainerBindings'] = ResolversParentTypes['SimpleContainerBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Enabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  InReviewMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SimpleContainerStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimpleContainerStyleConfigurations'] = ResolversParentTypes['SimpleContainerStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface SingleMappingScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['SingleMapping'], any> {
  name: 'SingleMapping';
}

export type SiteConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SiteConfiguration'] = ResolversParentTypes['SiteConfiguration']> = ResolversObject<{
  CustomLabels?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomLabel']>>>, ParentType, ContextType>;
  DefaultCCY?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DefaultLocale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DefaultTemplate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DefaultTemplatePublicView?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Formats?: Resolver<Maybe<ResolversTypes['Formats']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  IsDefault?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Locales?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NamedTemplates?: Resolver<Maybe<ResolversTypes['StringDictionary']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Settings?: Resolver<Maybe<ResolversTypes['SiteSettings']>, ParentType, ContextType>;
  ThemeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  URLMatches?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SiteSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SiteSettings'] = ResolversParentTypes['SiteSettings']> = ResolversObject<{
  HideListExportIcon?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ListAndChartLabels?: Resolver<Maybe<ResolversTypes['ListAndChartLabels']>, ParentType, ContextType>;
  Logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LogoClassName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MarketAppsThemeMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SliderResolvers<ContextType = any, ParentType extends ResolversParentTypes['Slider'] = ResolversParentTypes['Slider']> = ResolversObject<{
  Analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType>;
  AriaLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AriaLabelledby?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AriaValuetext?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['SliderBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  DisableSwap?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FieldFormat']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  MarkFrequency?: Resolver<Maybe<ResolversTypes['MarkFrequency']>, ParentType, ContextType>;
  Marks?: Resolver<Maybe<ResolversTypes['SliderMarks']>, ParentType, ContextType>;
  Max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  Min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Orientation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Step?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
  ValueLabelDisplay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValueLabelItem?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SliderBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SliderBindings'] = ResolversParentTypes['SliderBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface SliderMarksScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['SliderMarks'], any> {
  name: 'SliderMarks';
}

export type SliderStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SliderStyleConfigurations'] = ResolversParentTypes['SliderStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SlotResolvers<ContextType = any, ParentType extends ResolversParentTypes['Slot'] = ResolversParentTypes['Slot']> = ResolversObject<{
  InputAdornment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Position?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SnackbarResolvers<ContextType = any, ParentType extends ResolversParentTypes['Snackbar'] = ResolversParentTypes['Snackbar']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  AutoHideDuration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Autohide?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['SnackbarBindings']>, ParentType, ContextType>;
  Button?: Resolver<Maybe<ResolversTypes['Button']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Open?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Severity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShowAnimation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SnackbarBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SnackbarBindings'] = ResolversParentTypes['SnackbarBindings']> = ResolversObject<{
  Message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Open?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Severity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SocialLoginButtonResolvers<ContextType = any, ParentType extends ResolversParentTypes['SocialLoginButton'] = ResolversParentTypes['SocialLoginButton']> = ResolversObject<{
  Icon?: Resolver<ResolversTypes['Image'], ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  SocialNetwork?: Resolver<ResolversTypes['SocialNetwork'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SpreadsheetModeOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpreadsheetModeOptions'] = ResolversParentTypes['SpreadsheetModeOptions']> = ResolversObject<{
  Mode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ShowAddRowsButton?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface StateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['State'], any> {
  name: 'State';
}

export type StateInspectorResolvers<ContextType = any, ParentType extends ResolversParentTypes['StateInspector'] = ResolversParentTypes['StateInspector']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['StateInspectorBindings']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StateInspectorBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['StateInspectorBindings'] = ResolversParentTypes['StateInspectorBindings']> = ResolversObject<{
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface StringDictionaryScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['StringDictionary'], any> {
  name: 'StringDictionary';
}

export type StyleEditorResolvers<ContextType = any, ParentType extends ResolversParentTypes['StyleEditor'] = ResolversParentTypes['StyleEditor']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['StyleEditorBindings']>, ParentType, ContextType>;
  ContextId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Layout?: Resolver<Maybe<ResolversTypes['Layout']>, ParentType, ContextType>;
  Name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StyleEditorBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['StyleEditorBindings'] = ResolversParentTypes['StyleEditorBindings']> = ResolversObject<{
  Layout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StylePropertiesResolvers<ContextType = any, ParentType extends ResolversParentTypes['StyleProperties'] = ResolversParentTypes['StyleProperties']> = ResolversObject<{
  alignItems?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  alignSelf?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  backgroundColor?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  display?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  flex?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  flexDirection?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  fontDecoration?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  fontSize?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  fontStyle?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  fontType?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  fontWeight?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  gap?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  horizonalAlign?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  margin?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  marginBottom?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  marginLeft?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  marginRight?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  marginTop?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  maxHeight?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  maxWidth?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  minHeight?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  minWidth?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  padding?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  verticalAlign?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['ResponsiveProperty']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface StylePropertiesDictionaryScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['StylePropertiesDictionary'], any> {
  name: 'StylePropertiesDictionary';
}

export interface StyleSetScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['StyleSet'], any> {
  name: 'StyleSet';
}

export type SwitchResolvers<ContextType = any, ParentType extends ResolversParentTypes['Switch'] = ResolversParentTypes['Switch']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['SwitchBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Checked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DisableRipple?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Edge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FieldFormat']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelPlacement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  LabelWhenOff?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  LabelWhenOn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SwitchBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwitchBindings'] = ResolversParentTypes['SwitchBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SwitchStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwitchStyleConfigurations'] = ResolversParentTypes['SwitchStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TabContainerResolvers<ContextType = any, ParentType extends ResolversParentTypes['TabContainer'] = ResolversParentTypes['TabContainer']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  AriaLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['TabContainerBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  BoxStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  ContentClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  InReviewMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Items?: Resolver<Array<ResolversTypes['TabItemOrContainer']>, ParentType, ContextType>;
  MaxTabs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  MoreTabsText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Paper?: Resolver<Maybe<ResolversTypes['Paper']>, ParentType, ContextType>;
  Resizable?: Resolver<Maybe<ResolversTypes['ResizableProperties']>, ParentType, ContextType>;
  ReviewDialogOptions?: Resolver<Maybe<ResolversTypes['ReviewDialog']>, ParentType, ContextType>;
  SelectedTabId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectedTabTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  TabClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  TabIndicatorStyles?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  TabStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  UniqueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Variant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TabContainerBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TabContainerBindings'] = ResolversParentTypes['TabContainerBindings']> = ResolversObject<{
  BoxStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ContentClasses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  InReviewMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  MaxTabs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectedTabId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectedTabTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TabClasses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TabIndicatorStyles?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  TabStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TabContainerStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TabContainerStyleConfigurations'] = ResolversParentTypes['TabContainerStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TabItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['TabItem'] = ResolversParentTypes['TabItem']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['TabItemBindings']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Icon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FlexLayoutItem']>>>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  TabClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  TabIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TabItemBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TabItemBindings'] = ResolversParentTypes['TabItemBindings']> = ResolversObject<{
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TabClasses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TabIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TabItemOrContainerResolvers<ContextType = any, ParentType extends ResolversParentTypes['TabItemOrContainer'] = ResolversParentTypes['TabItemOrContainer']> = ResolversObject<{
  __resolveType: TypeResolveFn<'SimpleContainer' | 'TabItem', ParentType, ContextType>;
}>;

export type TabItemStyleConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TabItemStyleConfigurations'] = ResolversParentTypes['TabItemStyleConfigurations']> = ResolversObject<{
  ControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExternalControlType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Slots?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TabLayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['TabLayout'] = ResolversParentTypes['TabLayout']> = ResolversObject<{
  AriaLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['TabLayoutBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ContentClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  InReviewMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Paper?: Resolver<Maybe<ResolversTypes['Paper']>, ParentType, ContextType>;
  ReviewDialogOptions?: Resolver<Maybe<ResolversTypes['ReviewDialog']>, ParentType, ContextType>;
  SelectedTabId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  TabClasses?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  TabIndicatorStyles?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Tabs?: Resolver<Array<ResolversTypes['TabItem']>, ParentType, ContextType>;
  UniqueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TabLayoutBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TabLayoutBindings'] = ResolversParentTypes['TabLayoutBindings']> = ResolversObject<{
  ContentClasses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  InReviewMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectedTabId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TabClasses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TabIndicatorStyles?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TableItemPropsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TableItemProps'] = ResolversParentTypes['TableItemProps']> = ResolversObject<{
  ItemId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TableLayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['TableLayout'] = ResolversParentTypes['TableLayout']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  CollapseIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  ContentItemsProps?: Resolver<Maybe<Array<Maybe<ResolversTypes['TableItemProps']>>>, ParentType, ContextType>;
  ContextId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ExpandIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  Expandable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  HeaderItemsProps?: Resolver<Maybe<Array<Maybe<ResolversTypes['TableItemProps']>>>, ParentType, ContextType>;
  HeaderRowStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  LayoutItem?: Resolver<Maybe<ResolversTypes['LayoutItem']>, ParentType, ContextType>;
  RowStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  RowsItems?: Resolver<Maybe<Array<Array<ResolversTypes['String']>>>, ParentType, ContextType>;
  TableStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface TagSetScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['TagSet'], any> {
  name: 'TagSet';
}

export type ThemeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Theme'] = ResolversParentTypes['Theme']> = ResolversObject<{
  Styles?: Resolver<Maybe<ResolversTypes['StyleSet']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TimePickerResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimePicker'] = ResolversParentTypes['TimePicker']> = ResolversObject<{
  Analytics?: Resolver<Maybe<ResolversTypes['Analytics']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['TimePickerBindings']>, ParentType, ContextType>;
  ClassName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TimePickerBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimePickerBindings'] = ResolversParentTypes['TimePickerBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TimeZonePickerResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimeZonePicker'] = ResolversParentTypes['TimeZonePicker']> = ResolversObject<{
  AutoSelect?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['TimePickerBindings']>, ParentType, ContextType>;
  ClassName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TimeZonePickerBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimeZonePickerBindings'] = ResolversParentTypes['TimeZonePickerBindings']> = ResolversObject<{
  AutoSelect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransformResolvers<ContextType = any, ParentType extends ResolversParentTypes['Transform'] = ResolversParentTypes['Transform']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['TransformBindings']>, ParentType, ContextType>;
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DataTransformations?: Resolver<Maybe<ResolversTypes['BindingsDictionary']>, ParentType, ContextType>;
  InputData?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  Options?: Resolver<Maybe<ResolversTypes['TransformMethodOptions']>, ParentType, ContextType>;
  TransformMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransformBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransformBindings'] = ResolversParentTypes['TransformBindings']> = ResolversObject<{
  InputData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Options?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TransformMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface TransformMethodOptionsScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['TransformMethodOptions'], any> {
  name: 'TransformMethodOptions';
}

export type TreeKeyConversionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreeKeyConversion'] = ResolversParentTypes['TreeKeyConversion']> = ResolversObject<{
  Children?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TreeListResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreeList'] = ResolversParentTypes['TreeList']> = ResolversObject<{
  AllowAdd?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AllowDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  AllowReordering?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['TreeListBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DefaultCollapseIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  DefaultEndIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  DefaultExpandIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  DefaultParentIcon?: Resolver<Maybe<ResolversTypes['Icon']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DisableSelection?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DisabledItemsFocusable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ForceExpanded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  KeyConversion?: Resolver<ResolversTypes['TreeKeyConversion'], ParentType, ContextType>;
  NewItemLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NewItemTypename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Service?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TopLevelLabelField?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Typename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  UniqueName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  getData?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TreeListBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TreeListBindings'] = ResolversParentTypes['TreeListBindings']> = ResolversObject<{
  AllowAdd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AllowDelete?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  AllowReordering?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Disabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Loading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  NodesExpanded?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Rows?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SelectedItem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TriggerActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TriggerAction'] = ResolversParentTypes['TriggerAction']> = ResolversObject<{
  Bindings?: Resolver<Maybe<ResolversTypes['TriggerActionBindings']>, ParentType, ContextType>;
  CommandResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Event?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Form?: Resolver<Maybe<ResolversTypes['FormId']>, ParentType, ContextType>;
  TargetId?: Resolver<Maybe<ResolversTypes['LayoutItemId']>, ParentType, ContextType>;
  Trigger?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TriggerActionBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TriggerActionBindings'] = ResolversParentTypes['TriggerActionBindings']> = ResolversObject<{
  Event?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Form?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TargetId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Trigger?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TriggerPropagationResolvers<ContextType = any, ParentType extends ResolversParentTypes['TriggerPropagation'] = ResolversParentTypes['TriggerPropagation']> = ResolversObject<{
  PropagateOnFailure?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Trigger?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TypedBindingEditorResolvers<ContextType = any, ParentType extends ResolversParentTypes['TypedBindingEditor'] = ResolversParentTypes['TypedBindingEditor']> = ResolversObject<{
  Id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UndoRedoToolbarResolvers<ContextType = any, ParentType extends ResolversParentTypes['UndoRedoToolbar'] = ResolversParentTypes['UndoRedoToolbar']> = ResolversObject<{
  Actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['IActionTrigger']>>>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['UndoRedoToolbarBindings']>, ParentType, ContextType>;
  BlockDelete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  CanBeDesigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Classes?: Resolver<Maybe<ResolversTypes['ClassSet']>, ParentType, ContextType>;
  DefaultValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  DisableKeyActions?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  FieldType?: Resolver<Maybe<ResolversTypes['FieldType']>, ParentType, ContextType>;
  Format?: Resolver<Maybe<ResolversTypes['FieldFormat']>, ParentType, ContextType>;
  Id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  InDesignMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  TrackedObject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ValidationRules?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValidationRule']>>>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Method']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UndoRedoToolbarBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UndoRedoToolbarBindings'] = ResolversParentTypes['UndoRedoToolbarBindings']> = ResolversObject<{
  Classes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  TrackedObject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface UserScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['User'], any> {
  name: 'User';
}

export type ValidResolvers<ContextType = any, ParentType extends ResolversParentTypes['Valid'] = ResolversParentTypes['Valid']> = ResolversObject<{
  reasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ValidationRuleResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidationRule'] = ResolversParentTypes['ValidationRule']> = ResolversObject<{
  ErrorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  Parameters?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  ValidationMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface VideoScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Video'], any> {
  name: 'Video';
}

export type VisibleMenuResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisibleMenu'] = ResolversParentTypes['VisibleMenu']> = ResolversObject<{
  AllowNavigation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Bindings?: Resolver<Maybe<ResolversTypes['VisibleMenuBindings']>, ParentType, ContextType>;
  ButtonStyle?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['SampleData']>, ParentType, ContextType>;
  Id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  IsCollapsible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Loading?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  Sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  Service?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['StyleProperties']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VisibleMenuBindingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisibleMenuBindings'] = ResolversParentTypes['VisibleMenuBindings']> = ResolversObject<{
  ButtonStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Loading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  Style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = any> = ResolversObject<{
  AIDialog?: AiDialogResolvers<ContextType>;
  AIDialogBindings?: AiDialogBindingsResolvers<ContextType>;
  AccordionGroup?: AccordionGroupResolvers<ContextType>;
  AccordionGroupBindings?: AccordionGroupBindingsResolvers<ContextType>;
  AccordionGroupStyleConfigurations?: AccordionGroupStyleConfigurationsResolvers<ContextType>;
  AccordionLayout?: AccordionLayoutResolvers<ContextType>;
  AccordionLayoutBindings?: AccordionLayoutBindingsResolvers<ContextType>;
  Action?: ActionResolvers<ContextType>;
  ActionEditor?: ActionEditorResolvers<ContextType>;
  ActionEditorBindings?: ActionEditorBindingsResolvers<ContextType>;
  Adornment?: AdornmentResolvers<ContextType>;
  Analytics?: AnalyticsResolvers<ContextType>;
  AnalyticsBindings?: AnalyticsBindingsResolvers<ContextType>;
  AppBar?: AppBarResolvers<ContextType>;
  AppBarBindings?: AppBarBindingsResolvers<ContextType>;
  Attribute?: AttributeResolvers<ContextType>;
  Audio?: GraphQLScalarType;
  AudioPlayer?: AudioPlayerResolvers<ContextType>;
  AudioPlayerBindings?: AudioPlayerBindingsResolvers<ContextType>;
  AudioRecorder?: AudioRecorderResolvers<ContextType>;
  AudioRecorderBindings?: AudioRecorderBindingsResolvers<ContextType>;
  Avatar?: AvatarResolvers<ContextType>;
  AvatarBindings?: AvatarBindingsResolvers<ContextType>;
  BasicInput?: BasicInputResolvers<ContextType>;
  BecomeUser?: BecomeUserResolvers<ContextType>;
  BecomeUserBindings?: BecomeUserBindingsResolvers<ContextType>;
  BindingEditor?: BindingEditorResolvers<ContextType>;
  BindingsDictionary?: GraphQLScalarType;
  BookmarkId?: GraphQLScalarType;
  BooleanFormat?: BooleanFormatResolvers<ContextType>;
  Button?: ButtonResolvers<ContextType>;
  ButtonBindings?: ButtonBindingsResolvers<ContextType>;
  ButtonGroup?: ButtonGroupResolvers<ContextType>;
  ButtonGroupBindings?: ButtonGroupBindingsResolvers<ContextType>;
  ButtonStyleConfigurations?: ButtonStyleConfigurationsResolvers<ContextType>;
  CallPhone?: CallPhoneResolvers<ContextType>;
  CallPhoneBindings?: CallPhoneBindingsResolvers<ContextType>;
  CallService?: CallServiceResolvers<ContextType>;
  CallServiceBindings?: CallServiceBindingsResolvers<ContextType>;
  Chart?: ChartResolvers<ContextType>;
  ChartBindings?: ChartBindingsResolvers<ContextType>;
  ChartField?: ChartFieldResolvers<ContextType>;
  ChartMetadata?: GraphQLScalarType;
  Checkbox?: CheckboxResolvers<ContextType>;
  CheckboxBindings?: CheckboxBindingsResolvers<ContextType>;
  CheckboxStyleConfigurations?: CheckboxStyleConfigurationsResolvers<ContextType>;
  CircularProgress?: CircularProgressResolvers<ContextType>;
  CircularProgressBindings?: CircularProgressBindingsResolvers<ContextType>;
  ClassSet?: GraphQLScalarType;
  ClearForm?: ClearFormResolvers<ContextType>;
  CloseContextMenu?: CloseContextMenuResolvers<ContextType>;
  CloseContextMenuBindings?: CloseContextMenuBindingsResolvers<ContextType>;
  CloseModalPopup?: CloseModalPopupResolvers<ContextType>;
  CodeEditor?: CodeEditorResolvers<ContextType>;
  CodeEditorBindings?: CodeEditorBindingsResolvers<ContextType>;
  CodeEditorOptions?: GraphQLScalarType;
  Command?: CommandResolvers<ContextType>;
  CommandSet?: CommandSetResolvers<ContextType>;
  Component?: ComponentResolvers<ContextType>;
  ComponentBindings?: ComponentBindingsResolvers<ContextType>;
  ComponentId?: GraphQLScalarType;
  ComponentLibrary?: ComponentLibraryResolvers<ContextType>;
  ComponentLibraryBindings?: ComponentLibraryBindingsResolvers<ContextType>;
  ConfigurationEditor?: ConfigurationEditorResolvers<ContextType>;
  ConfigurationEditorBindings?: ConfigurationEditorBindingsResolvers<ContextType>;
  Container?: ContainerResolvers<ContextType>;
  ContextAutocomplete?: ContextAutocompleteResolvers<ContextType>;
  ContextAutocompleteBindings?: ContextAutocompleteBindingsResolvers<ContextType>;
  ContextMenu?: ContextMenuResolvers<ContextType>;
  ContextMenuBindings?: ContextMenuBindingsResolvers<ContextType>;
  ContextMenuId?: GraphQLScalarType;
  Control?: ControlResolvers<ContextType>;
  CopyToClipboard?: CopyToClipboardResolvers<ContextType>;
  CopyToClipboardBindings?: CopyToClipboardBindingsResolvers<ContextType>;
  Country?: CountryResolvers<ContextType>;
  CssClass?: CssClassResolvers<ContextType>;
  CssObject?: GraphQLScalarType;
  CssParamsBindings?: GraphQLScalarType;
  CustomLabel?: CustomLabelResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateFormat?: DateFormatResolvers<ContextType>;
  DatePicker?: DatePickerResolvers<ContextType>;
  DatePickerBindings?: DatePickerBindingsResolvers<ContextType>;
  DatePickerStyleConfigurations?: DatePickerStyleConfigurationsResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  DateTimePicker?: DateTimePickerResolvers<ContextType>;
  DateTimePickerBindings?: DateTimePickerBindingsResolvers<ContextType>;
  Dialog?: DialogResolvers<ContextType>;
  DialogBindings?: DialogBindingsResolvers<ContextType>;
  Document?: GraphQLScalarType;
  DocumentViewer?: DocumentViewerResolvers<ContextType>;
  DocumentViewerBindings?: DocumentViewerBindingsResolvers<ContextType>;
  DocumentViewerStyleConfigurations?: DocumentViewerStyleConfigurationsResolvers<ContextType>;
  Drawer?: DrawerResolvers<ContextType>;
  DropDownButton?: DropDownButtonResolvers<ContextType>;
  Entity?: EntityResolvers<ContextType>;
  EventData?: GraphQLScalarType;
  Feature?: FeatureResolvers<ContextType>;
  FeatureBindings?: FeatureBindingsResolvers<ContextType>;
  Feed?: FeedResolvers<ContextType>;
  FeedBindings?: FeedBindingsResolvers<ContextType>;
  FieldFormat?: FieldFormatResolvers<ContextType>;
  FieldList?: FieldListResolvers<ContextType>;
  FieldValueExpression?: GraphQLScalarType;
  FileList?: FileListResolvers<ContextType>;
  FileListBindings?: FileListBindingsResolvers<ContextType>;
  FileUpload?: FileUploadResolvers<ContextType>;
  FileUploadBindings?: FileUploadBindingsResolvers<ContextType>;
  FilterParams?: FilterParamsResolvers<ContextType>;
  FinApp?: FinAppResolvers<ContextType>;
  FinAppBindings?: FinAppBindingsResolvers<ContextType>;
  FinAppStyleConfigurations?: FinAppStyleConfigurationsResolvers<ContextType>;
  FlexLayout?: FlexLayoutResolvers<ContextType>;
  FlexLayoutBindings?: FlexLayoutBindingsResolvers<ContextType>;
  FlexLayoutItem?: GraphQLScalarType;
  FlexProperties?: FlexPropertiesResolvers<ContextType>;
  Form?: FormResolvers<ContextType>;
  FormBindings?: FormBindingsResolvers<ContextType>;
  FormId?: GraphQLScalarType;
  FormStyleConfigurations?: FormStyleConfigurationsResolvers<ContextType>;
  FormatName?: GraphQLScalarType;
  Formats?: GraphQLScalarType;
  FragmentLayout?: FragmentLayoutResolvers<ContextType>;
  FragmentLayoutBindings?: FragmentLayoutBindingsResolvers<ContextType>;
  FreeFormLayout?: FreeFormLayoutResolvers<ContextType>;
  FreeFormLayoutBindings?: FreeFormLayoutBindingsResolvers<ContextType>;
  GenerateCode?: GenerateCodeResolvers<ContextType>;
  GoBack?: GoBackResolvers<ContextType>;
  GoToBookmark?: GoToBookmarkResolvers<ContextType>;
  GoToBookmarkBindings?: GoToBookmarkBindingsResolvers<ContextType>;
  GoToPage?: GoToPageResolvers<ContextType>;
  GoToPageBindings?: GoToPageBindingsResolvers<ContextType>;
  GoogleAnalytics?: GoogleAnalyticsResolvers<ContextType>;
  GridEditor?: GridEditorResolvers<ContextType>;
  GridEditorBindings?: GridEditorBindingsResolvers<ContextType>;
  GridStackLayout?: GridStackLayoutResolvers<ContextType>;
  Html?: HtmlResolvers<ContextType>;
  HtmlBindings?: HtmlBindingsResolvers<ContextType>;
  IActionTrigger?: IActionTriggerResolvers<ContextType>;
  IApplication?: IApplicationResolvers<ContextType>;
  IDesignable?: IDesignableResolvers<ContextType>;
  IEditable?: IEditableResolvers<ContextType>;
  IField?: IFieldResolvers<ContextType>;
  IFrame?: IFrameResolvers<ContextType>;
  IFrameBindings?: IFrameBindingsResolvers<ContextType>;
  IInstruction?: IInstructionResolvers<ContextType>;
  IParameter?: IParameterResolvers<ContextType>;
  IParameterWithValues?: IParameterWithValuesResolvers<ContextType>;
  ISelectFromList?: ISelectFromListResolvers<ContextType>;
  Icon?: IconResolvers<ContextType>;
  IconBindings?: IconBindingsResolvers<ContextType>;
  IconSelector?: IconSelectorResolvers<ContextType>;
  IconSelectorBindings?: IconSelectorBindingsResolvers<ContextType>;
  IconStyleConfigurations?: IconStyleConfigurationsResolvers<ContextType>;
  Image?: ImageResolvers<ContextType>;
  ImageBindings?: ImageBindingsResolvers<ContextType>;
  InputBinding?: GraphQLScalarType;
  InputData?: InputDataResolvers<ContextType>;
  InputField?: InputFieldResolvers<ContextType>;
  InputFieldBindings?: InputFieldBindingsResolvers<ContextType>;
  InputFieldStyleConfigurations?: InputFieldStyleConfigurationsResolvers<ContextType>;
  JsonView?: JsonViewResolvers<ContextType>;
  JsonViewBindings?: JsonViewBindingsResolvers<ContextType>;
  Label?: LabelResolvers<ContextType>;
  LabelBindings?: LabelBindingsResolvers<ContextType>;
  LabelStyleConfigurations?: LabelStyleConfigurationsResolvers<ContextType>;
  Layout?: LayoutResolvers<ContextType>;
  LayoutItem?: LayoutItemResolvers<ContextType>;
  LayoutItemId?: GraphQLScalarType;
  LibraryItem?: LibraryItemResolvers<ContextType>;
  LinearLayout?: LinearLayoutResolvers<ContextType>;
  LinearProgress?: LinearProgressResolvers<ContextType>;
  LinearProgressBindings?: LinearProgressBindingsResolvers<ContextType>;
  Link?: LinkResolvers<ContextType>;
  LinkBindings?: LinkBindingsResolvers<ContextType>;
  List?: ListResolvers<ContextType>;
  ListAndChartLabels?: ListAndChartLabelsResolvers<ContextType>;
  ListBindings?: ListBindingsResolvers<ContextType>;
  ListClearAllButton?: ListClearAllButtonResolvers<ContextType>;
  ListClearAllButtonBindings?: ListClearAllButtonBindingsResolvers<ContextType>;
  ListColumn?: ListColumnResolvers<ContextType>;
  ListColumnBindings?: ListColumnBindingsResolvers<ContextType>;
  ListColumnStyleConfigurations?: ListColumnStyleConfigurationsResolvers<ContextType>;
  ListExportButton?: ListExportButtonResolvers<ContextType>;
  ListExportButtonBindings?: ListExportButtonBindingsResolvers<ContextType>;
  ListPageInfo?: ListPageInfoResolvers<ContextType>;
  ListQuickFilter?: ListQuickFilterResolvers<ContextType>;
  ListQuickFilterBindings?: ListQuickFilterBindingsResolvers<ContextType>;
  ListStyleConfigurations?: ListStyleConfigurationsResolvers<ContextType>;
  ListToolbar?: ListToolbarResolvers<ContextType>;
  LocalizedAppInfo?: LocalizedAppInfoResolvers<ContextType>;
  Login?: LoginResolvers<ContextType>;
  LoginBindings?: LoginBindingsResolvers<ContextType>;
  LoginPage?: LoginPageResolvers<ContextType>;
  Logout?: LogoutResolvers<ContextType>;
  Mapping?: MappingResolvers<ContextType>;
  MarkFrequency?: MarkFrequencyResolvers<ContextType>;
  Markdown?: MarkdownResolvers<ContextType>;
  MarkdownBindings?: MarkdownBindingsResolvers<ContextType>;
  Menu?: MenuResolvers<ContextType>;
  MenuBindings?: MenuBindingsResolvers<ContextType>;
  Method?: GraphQLScalarType;
  ModalPopupEditor?: ModalPopupEditorResolvers<ContextType>;
  ModalPopupEditorBindings?: ModalPopupEditorBindingsResolvers<ContextType>;
  Model?: ModelResolvers<ContextType>;
  MultiFilter?: MultiFilterResolvers<ContextType>;
  MultiFilterBindings?: MultiFilterBindingsResolvers<ContextType>;
  MultiSelect?: MultiSelectResolvers<ContextType>;
  MultiSelectBindings?: MultiSelectBindingsResolvers<ContextType>;
  MultiSelectObject?: GraphQLScalarType;
  MultiSelectStyleConfigurations?: MultiSelectStyleConfigurationsResolvers<ContextType>;
  NativeApplication?: NativeApplicationResolvers<ContextType>;
  NumberFormat?: NumberFormatResolvers<ContextType>;
  OpenContextMenu?: OpenContextMenuResolvers<ContextType>;
  OpenContextMenuBindings?: OpenContextMenuBindingsResolvers<ContextType>;
  OpenModalPopup?: OpenModalPopupResolvers<ContextType>;
  Overlay?: OverlayResolvers<ContextType>;
  OverlayBindings?: OverlayBindingsResolvers<ContextType>;
  Page?: PageResolvers<ContextType>;
  PageBindings?: PageBindingsResolvers<ContextType>;
  PageTemplate?: PageTemplateResolvers<ContextType>;
  Paper?: PaperResolvers<ContextType>;
  PasteFromClipboard?: PasteFromClipboardResolvers<ContextType>;
  Position?: PositionResolvers<ContextType>;
  PropertiesEditor?: PropertiesEditorResolvers<ContextType>;
  PropertiesEditorBindings?: PropertiesEditorBindingsResolvers<ContextType>;
  ProportionalBar?: ProportionalBarResolvers<ContextType>;
  ProportionalBarBindings?: ProportionalBarBindingsResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RadioGroup?: RadioGroupResolvers<ContextType>;
  RadioGroupBindings?: RadioGroupBindingsResolvers<ContextType>;
  Reference?: ReferenceResolvers<ContextType>;
  ReferenceBindings?: ReferenceBindingsResolvers<ContextType>;
  ReferenceStyleConfigurations?: ReferenceStyleConfigurationsResolvers<ContextType>;
  RefreshGrid?: GraphQLScalarType;
  ReloadPage?: ReloadPageResolvers<ContextType>;
  Repeater?: RepeaterResolvers<ContextType>;
  RepeaterBindings?: RepeaterBindingsResolvers<ContextType>;
  RepeaterStyleConfigurations?: RepeaterStyleConfigurationsResolvers<ContextType>;
  ResizableProperties?: ResizablePropertiesResolvers<ContextType>;
  ResolutionButtons?: ResolutionButtonsResolvers<ContextType>;
  ResolutionButtonsBindings?: ResolutionButtonsBindingsResolvers<ContextType>;
  ResponsiveProperty?: GraphQLScalarType;
  ResponsivePropertyObject?: ResponsivePropertyObjectResolvers<ContextType>;
  ReviewDialog?: ReviewDialogResolvers<ContextType>;
  ReviewDialogBindings?: ReviewDialogBindingsResolvers<ContextType>;
  ReviewDialogData?: ReviewDialogDataResolvers<ContextType>;
  ReviewNote?: ReviewNoteResolvers<ContextType>;
  RichTextEditor?: RichTextEditorResolvers<ContextType>;
  RichTextEditorBindings?: RichTextEditorBindingsResolvers<ContextType>;
  RichTextEditorStyleConfigurations?: RichTextEditorStyleConfigurationsResolvers<ContextType>;
  RichTreeList?: RichTreeListResolvers<ContextType>;
  RichTreeListBindings?: RichTreeListBindingsResolvers<ContextType>;
  SampleData?: GraphQLScalarType;
  ScrollToTop?: ScrollToTopResolvers<ContextType>;
  SendEmail?: SendEmailResolvers<ContextType>;
  SendEmailBindings?: SendEmailBindingsResolvers<ContextType>;
  SendMessageToChild?: SendMessageToChildResolvers<ContextType>;
  SendMessageToChildBindings?: SendMessageToChildBindingsResolvers<ContextType>;
  SendMessageToParent?: SendMessageToParentResolvers<ContextType>;
  SendSMS?: SendSmsResolvers<ContextType>;
  SendSMSBindings?: SendSmsBindingsResolvers<ContextType>;
  Service?: ServiceResolvers<ContextType>;
  ServiceBinding?: GraphQLScalarType;
  ServiceField?: ServiceFieldResolvers<ContextType>;
  ServiceFieldBindings?: ServiceFieldBindingsResolvers<ContextType>;
  ServiceLibrary?: ServiceLibraryResolvers<ContextType>;
  ServiceLibraryBindings?: ServiceLibraryBindingsResolvers<ContextType>;
  ServiceList?: ServiceListResolvers<ContextType>;
  ServiceSet?: ServiceSetResolvers<ContextType>;
  ServiceSnapshotOptions?: ServiceSnapshotOptionsResolvers<ContextType>;
  ServiceSnapshotOptionsDictionary?: GraphQLScalarType;
  SetState?: SetStateResolvers<ContextType>;
  Share?: ShareResolvers<ContextType>;
  ShareBindings?: ShareBindingsResolvers<ContextType>;
  ShareDialog?: ShareDialogResolvers<ContextType>;
  ShareDialogBindings?: ShareDialogBindingsResolvers<ContextType>;
  ShareDialogData?: ShareDialogDataResolvers<ContextType>;
  ShareSource?: ShareSourceResolvers<ContextType>;
  SharingInfo?: SharingInfoResolvers<ContextType>;
  SharingOptions?: SharingOptionsResolvers<ContextType>;
  ShowMessage?: ShowMessageResolvers<ContextType>;
  ShowMessageBindings?: ShowMessageBindingsResolvers<ContextType>;
  ShowToast?: ShowToastResolvers<ContextType>;
  SimpleContainer?: SimpleContainerResolvers<ContextType>;
  SimpleContainerBindings?: SimpleContainerBindingsResolvers<ContextType>;
  SimpleContainerStyleConfigurations?: SimpleContainerStyleConfigurationsResolvers<ContextType>;
  SingleMapping?: GraphQLScalarType;
  SiteConfiguration?: SiteConfigurationResolvers<ContextType>;
  SiteSettings?: SiteSettingsResolvers<ContextType>;
  Slider?: SliderResolvers<ContextType>;
  SliderBindings?: SliderBindingsResolvers<ContextType>;
  SliderMarks?: GraphQLScalarType;
  SliderStyleConfigurations?: SliderStyleConfigurationsResolvers<ContextType>;
  Slot?: SlotResolvers<ContextType>;
  Snackbar?: SnackbarResolvers<ContextType>;
  SnackbarBindings?: SnackbarBindingsResolvers<ContextType>;
  SocialLoginButton?: SocialLoginButtonResolvers<ContextType>;
  SpreadsheetModeOptions?: SpreadsheetModeOptionsResolvers<ContextType>;
  State?: GraphQLScalarType;
  StateInspector?: StateInspectorResolvers<ContextType>;
  StateInspectorBindings?: StateInspectorBindingsResolvers<ContextType>;
  StringDictionary?: GraphQLScalarType;
  StyleEditor?: StyleEditorResolvers<ContextType>;
  StyleEditorBindings?: StyleEditorBindingsResolvers<ContextType>;
  StyleProperties?: StylePropertiesResolvers<ContextType>;
  StylePropertiesDictionary?: GraphQLScalarType;
  StyleSet?: GraphQLScalarType;
  Switch?: SwitchResolvers<ContextType>;
  SwitchBindings?: SwitchBindingsResolvers<ContextType>;
  SwitchStyleConfigurations?: SwitchStyleConfigurationsResolvers<ContextType>;
  TabContainer?: TabContainerResolvers<ContextType>;
  TabContainerBindings?: TabContainerBindingsResolvers<ContextType>;
  TabContainerStyleConfigurations?: TabContainerStyleConfigurationsResolvers<ContextType>;
  TabItem?: TabItemResolvers<ContextType>;
  TabItemBindings?: TabItemBindingsResolvers<ContextType>;
  TabItemOrContainer?: TabItemOrContainerResolvers<ContextType>;
  TabItemStyleConfigurations?: TabItemStyleConfigurationsResolvers<ContextType>;
  TabLayout?: TabLayoutResolvers<ContextType>;
  TabLayoutBindings?: TabLayoutBindingsResolvers<ContextType>;
  TableItemProps?: TableItemPropsResolvers<ContextType>;
  TableLayout?: TableLayoutResolvers<ContextType>;
  TagSet?: GraphQLScalarType;
  Theme?: ThemeResolvers<ContextType>;
  TimePicker?: TimePickerResolvers<ContextType>;
  TimePickerBindings?: TimePickerBindingsResolvers<ContextType>;
  TimeZonePicker?: TimeZonePickerResolvers<ContextType>;
  TimeZonePickerBindings?: TimeZonePickerBindingsResolvers<ContextType>;
  Transform?: TransformResolvers<ContextType>;
  TransformBindings?: TransformBindingsResolvers<ContextType>;
  TransformMethodOptions?: GraphQLScalarType;
  TreeKeyConversion?: TreeKeyConversionResolvers<ContextType>;
  TreeList?: TreeListResolvers<ContextType>;
  TreeListBindings?: TreeListBindingsResolvers<ContextType>;
  TriggerAction?: TriggerActionResolvers<ContextType>;
  TriggerActionBindings?: TriggerActionBindingsResolvers<ContextType>;
  TriggerPropagation?: TriggerPropagationResolvers<ContextType>;
  TypedBindingEditor?: TypedBindingEditorResolvers<ContextType>;
  UndoRedoToolbar?: UndoRedoToolbarResolvers<ContextType>;
  UndoRedoToolbarBindings?: UndoRedoToolbarBindingsResolvers<ContextType>;
  User?: GraphQLScalarType;
  Valid?: ValidResolvers<ContextType>;
  ValidationRule?: ValidationRuleResolvers<ContextType>;
  Video?: GraphQLScalarType;
  VisibleMenu?: VisibleMenuResolvers<ContextType>;
  VisibleMenuBindings?: VisibleMenuBindingsResolvers<ContextType>;
}>;

export type DirectiveResolvers<ContextType = any> = ResolversObject<{
  constant?: ConstantDirectiveResolver<any, any, ContextType>;
  editorProps?: EditorPropsDirectiveResolver<any, any, ContextType>;
  expression?: ExpressionDirectiveResolver<any, any, ContextType>;
  localizable?: LocalizableDirectiveResolver<any, any, ContextType>;
  mappings?: MappingsDirectiveResolver<any, any, ContextType>;
  recommendedValues?: RecommendedValuesDirectiveResolver<any, any, ContextType>;
  runtimeOnly?: RuntimeOnlyDirectiveResolver<any, any, ContextType>;
  service?: ServiceDirectiveResolver<any, any, ContextType>;
  themeColor?: ThemeColorDirectiveResolver<any, any, ContextType>;
  unique?: UniqueDirectiveResolver<any, any, ContextType>;
}>;
